import {
  Unit_instanceat14thlj150z as Unit_instance,
  compareTo3ankvs086tmwq as compareTo,
  coerceIn10f36k81le1mm as coerceIn,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  StringBuildermazzzhj6kkai as StringBuilder,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  lazy2hsh8ze7j6ikd as lazy,
  VOID7hggqo3abtya as VOID,
  binarySearchyyczvdessj07 as binarySearch,
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
  getOrNull1go7ef9ldk0df as getOrNull,
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfvhqybd2zx248 as listOf,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  contentEquals5p44wfjhu6ta as contentEquals,
  contentHashCodem24x0wy7gjt7 as contentHashCode,
  contentToString28hodxfcotn0 as contentToString,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  until1jbpn0z3f8lbg as until,
  createThis2j2avj17cvnv2 as createThis,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  listOf1jh22dvmctj1r as listOf_0,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  last3s1sh0kl8j0vf as last_0,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
  Enum3alwj03lh1n41 as Enum,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  step18s9qzr5xwxat as step,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  addAll1k27qatfgp3k5 as addAll,
  numberToDouble210hrknaofnhf as numberToDouble,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trimEnd17pt8cbotbalj as trimEnd,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  toString30pk9tzaqopn as toString_0,
  Comparable198qfk8pnblz0 as Comparable,
  enumEntries20mr21zbe3az4 as enumEntries,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  KProperty02ce7r476m8633 as KProperty0,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  IntArrayList3liuagbdnwmna as IntArrayList,
  _BSearchResult___init__impl__em6zam3kgjdixysmohf as _BSearchResult___init__impl__em6zam,
  _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o as _BSearchResult___get_found__impl__om04iz,
  PointArrayList281mrsgyr6ua1 as PointArrayList,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  sort23bpsawysis6n as sort,
  pointArrayListOf7rbgdbqf3x4b as pointArrayListOf,
  pointArrayListOf2s9je3njyg83l as pointArrayListOf_0,
  pointArrayListOf36sb9r6prgwk4 as pointArrayListOf_1,
  binarySearch1lxbagta5e4q4 as binarySearch_0,
  _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci as _BSearchResult___get_index__impl__b5kraz,
  _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2 as _BSearchResult___get_nearIndex__impl__s8nq43,
  getCyclic18d9063nmuul as getCyclic,
  swap3upf401qn4fc8 as swap,
  rotateRight96vk8nw2c6nx as rotateRight,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  get_size3oaoh8cpamcqc as get_size,
  Pool1zbsw0zhvh8ca as Pool,
  SortOps3rp25tm4jbjru as SortOps,
  genericSort3vhmyxbppxo3h as genericSort,
  PointIntArrayList1s7gare9hr1oh as PointIntArrayList,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Mixin3lmkm5hum2vdj as Mixin,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Property1m5vulkepgwzd as Property,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  convertRange139vj18oahy2c as convertRange,
  Ratio__minus_impl_s1uwyg39ebtqskl4ycn as Ratio__minus_impl_s1uwyg,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  Ratio__times_impl_ucdh7yuy2trpt4sqvt as Ratio__times_impl_ucdh7y_0,
  _Ratio___get_value__impl__57cli6w1n0arietzij as _Ratio___get_value__impl__57cli6,
  normalizeZero2ksfd6bzt4qwz as normalizeZero,
  toRatio1hooqit5gulhr as toRatio,
  isAlmostEquals18m8qk24p7w0q as isAlmostEquals,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals_0,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__hashCode_impl_quhc2v2f99yx2uv51mf as Ratio__hashCode_impl_quhc2v,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  isAlmostZero7baqs51et9hm as isAlmostZero,
  Ratio136tf4z2t0p2d as Ratio,
  toRatioa3v13oich5q as toRatio_0,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  convertRange1a6ancvyn151r as convertRange_0,
  interpolate2g7wzskc23f1q as interpolate,
  interpolate35pbs3ac913y4 as interpolate_0,
  _Ratio___get_absoluteValue__impl__92ozif2q8z2akxn3hd8 as _Ratio___get_absoluteValue__impl__92ozif,
  umod164hvijxhfi8p as umod,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  insert2fz5125p2hdyd as insert_0,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_0,
  clamp31lhm66c28ic8 as clamp,
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_0,
  invoke3idfsdzzpzmqq as invoke,
  invoke1y68e7g1lbvl5 as invoke_0,
  Easing3266vfl8a4o75 as Easing,
  toRatiolga1a9coidva as toRatio_1,
  clampdicp8njiht45 as clamp_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  transformY3ktoxhxwkzwk1 as transformY,
  transformX33nszy4vzqsfy as transformX,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_1,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_2,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_3,
  Angle_between72970e1vlen9 as Angle_between,
  Angle2itorpob18n08 as Angle,
  outerCircle30hn5vvbpz9gu as outerCircle,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_4,
  interpolatewhd2sgxffql5 as interpolate_1,
  _Angle___get_normalized__impl__9s30ys1q15xt9x23bx as _Angle___get_normalized__impl__9s30ys,
  Angle__plus_impl_26v37karx983dsduoy as Angle__plus_impl_26v37k,
  Angle__compareTo_impl_a0hfds24obl4qqhxk1t as Angle__compareTo_impl_a0hfds,
  Angle__minus_impl_xeau7ko02ca30grn4a as Angle__minus_impl_xeau7k,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
  _Angle___init__impl__g23q1m36yxttgnpy5tv as _Angle___init__impl__g23q1m,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2,
  Angle__div_impl_ut2btd1qmy7ftoy1opp as Angle__div_impl_ut2btd,
  _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq as _Angle___get_cosine__impl__vprvmu,
  _Angle___get_sine__impl__15nmyi39oh4tio4auz1 as _Angle___get_sine__impl__15nmyi,
  _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg as _Angle___get_tangent__impl__vushdy,
  Size2Dum5ayuyhhau7 as Size2D,
  Rectangle3q03woyn9k8x1 as Rectangle,
  _Angle___get_ratio__impl__ap3on435dv91f5cbp85 as _Angle___get_ratio__impl__ap3on4,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_5,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x,
  Companion_getInstance2yu48324co92b as Companion_getInstance_6,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Vector2I2k5512l4eeahb as Vector2I,
  toIntu0rc68akxu7a as toInt,
  Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp as Angle__unaryPlus_impl_eyi5pl,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  BoundsBuilder162uwsje56mvu as BoundsBuilder,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x_0,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_7,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class IntSegmentSet {
  constructor() {
    this.s4k_1 = IntArrayList.l3w(16);
    this.t4k_1 = IntArrayList.l3w(16);
  }
  g1() {
    return this.s4k_1.g1();
  }
  j1() {
    return this.g1() === 0;
  }
  d1t() {
    return this.g1() > 0;
  }
  ai() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.clear.<anonymous>' call
    this.s4k_1.h3();
    this.t4k_1.h3();
    return this;
  }
  u4k() {
    return this.d1t() ? this.s4k_1.x27(0) : 0;
  }
  v4k() {
    return this.d1t() ? this.t4k_1.x27(this.t4k_1.g1() - 1 | 0) : 0;
  }
  w4k(x) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = this.g1() - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findNearIndex.<anonymous>' call
        var min = this.s4k_1.x27(mid);
        var max = this.t4k_1.x27(mid);
        var mval = x < min ? 1 : x > max ? -1 : 0;
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.datastructure.genericBinarySearch.<anonymous>' call
      tmp$ret$1 = (-low | 0) - 1 | 0;
    }
    return _BSearchResult___init__impl__em6zam(tmp$ret$1);
  }
  x4k(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchLeft' call
    var toIndex = this.g1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findLeftBound.<anonymous>' call
        var mval = compareTo(this.s4k_1.x27(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchLeft.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.min' call
      var b = high;
      var tmp$ret$2 = Math.min(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.g1() - 1 | 0);
  }
  y4k(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchRight' call
    var toIndex = this.g1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findRightBound.<anonymous>' call
        var mval = compareTo(this.t4k_1.x27(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchRight.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.max' call
      var b = high;
      var tmp$ret$2 = Math.max(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.g1() - 1 | 0);
  }
  e45(min, max) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    $l$block_0: {
      // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(min <= max)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.h5(toString(message));
      }
      if (this.j1()) {
        insertAt(this, this.g1(), min, max);
      } else if (min === this.v4k()) {
        this.t4k_1.w3w(this.t4k_1.g1() - 1 | 0, max);
      } else if (max === this.u4k()) {
        this.s4k_1.w3w(0, min);
      } else {
        var removeStart = -1;
        var removeCount = -1;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (this.j1()) {
            break $l$block;
          }
          var nmin = this.x4k(min);
          var nmax = this.y4k(max);
          var inductionVariable = nmin;
          if (inductionVariable <= nmax)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>.<anonymous>' call
              var n_0 = n;
              var x1 = this.s4k_1.x27(n);
              var x2 = this.t4k_1.x27(n);
              if (this.z4k(x1, x2, min, max)) {
                if (removeStart === -1)
                  removeStart = n_0;
                var tmp = removeStart;
                // Inline function 'kotlin.math.min' call
                var a = this.s4k_1.x27(removeStart);
                // Inline function 'kotlin.math.min' call
                var b = Math.min(x1, min);
                var tmp$ret$3 = Math.min(a, b);
                this.s4k_1.w3w(tmp, tmp$ret$3);
                var tmp_0 = removeStart;
                // Inline function 'kotlin.math.max' call
                var a_0 = this.t4k_1.x27(removeStart);
                // Inline function 'kotlin.math.max' call
                var b_0 = Math.max(x2, max);
                var tmp$ret$5 = Math.max(a_0, b_0);
                this.t4k_1.w3w(tmp_0, tmp$ret$5);
                removeCount = removeCount + 1 | 0;
              }
            }
             while (!(n === nmax));
        }
        if (removeCount !== 0)
          if (removeCount > 0) {
            removeAt(this, removeStart + 1 | 0, removeCount);
          } else if (max < this.u4k()) {
            insertAt(this, 0, min, max);
          } else if (min > this.v4k()) {
            insertAt(this, this.g1(), min, max);
          } else {
            var inductionVariable_0 = coerceAtLeast(this.x4k(min), 1);
            var last = this.y4k(max);
            if (inductionVariable_0 <= last)
              do {
                var m = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var prevMax = this.t4k_1.x27(m - 1 | 0);
                var currMin = this.s4k_1.x27(m);
                if (min > prevMax && max < currMin) {
                  insertAt(this, m, min, max);
                  break $l$block_0;
                }
              }
               while (!(m === last));
            // Inline function 'kotlin.error' call
            var message_0 = 'Unexpected';
            throw IllegalStateException.h5(toString(message_0));
          }
      }
    }
    return this;
  }
  hq(v) {
    return _BSearchResult___get_found__impl__om04iz(this.w4k(v));
  }
  a4l(a, b) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>' call
    var aSmaller = a.g1() < b.g1();
    var av = aSmaller ? a : b;
    var bv = aSmaller ? b : a;
    // Inline function 'kotlin.also' call
    this.ai();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = av.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>' call
        var x1 = av.s4k_1.x27(n);
        // Inline function 'korlibs.math.segment.IntSegmentSet.intersection' call
        var max = av.t4k_1.x27(n);
        var count = 0;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (bv.j1()) {
            break $l$block;
          }
          var nmin = bv.x4k(x1);
          var nmax = bv.y4k(max);
          var inductionVariable_0 = nmin;
          if (inductionVariable_0 <= nmax)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.intersection.<anonymous>' call
              var x1_0 = bv.s4k_1.x27(n_0);
              var x2 = bv.t4k_1.x27(n_0);
              if (bv.z4k(x1_0, x2, x1, max)) {
                // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.math.max' call
                var min = Math.max(x1_0, x1);
                // Inline function 'kotlin.math.min' call
                var max_0 = Math.min(x2, max);
                this.e45(min, max_0);
                count = count + 1 | 0;
              }
            }
             while (!(n_0 === nmax));
        }
      }
       while (inductionVariable < last);
    return this;
  }
  z4k(x1, x2, y1, y2) {
    return x2 >= y1 && y2 >= x1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>' call
    this_0.gc('[');
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>.<anonymous>' call
        var min = this.s4k_1.x27(n);
        var max = this.t4k_1.x27(n);
        var first = n === 0;
        if (!first) {
          this_0.gc(', ');
        }
        this_0.gc('' + min + '-' + max);
      }
       while (inductionVariable < last);
    this_0.gc(']');
    return this_0.toString();
  }
}
class CurveInfo {
  constructor(index, curve, startLength, endLength, bounds) {
    this.b4l_1 = index;
    this.c4l_1 = curve;
    this.d4l_1 = startLength;
    this.e4l_1 = endLength;
    this.f4l_1 = bounds;
  }
  r3x(length) {
    var containsLower = this.d4l_1;
    return length <= this.e4l_1 ? containsLower <= length : false;
  }
  a() {
    return this.e4l_1 - this.d4l_1;
  }
  toString() {
    return 'CurveInfo(index=' + this.b4l_1 + ', curve=' + this.c4l_1.toString() + ', startLength=' + this.d4l_1 + ', endLength=' + this.e4l_1 + ', bounds=' + this.f4l_1.toString() + ')';
  }
  hashCode() {
    var result = this.b4l_1;
    result = imul(result, 31) + this.c4l_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e4l_1) | 0;
    result = imul(result, 31) + this.f4l_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveInfo))
      return false;
    var tmp0_other_with_cast = other instanceof CurveInfo ? other : THROW_CCE();
    if (!(this.b4l_1 === tmp0_other_with_cast.b4l_1))
      return false;
    if (!this.c4l_1.equals(tmp0_other_with_cast.c4l_1))
      return false;
    if (!equals(this.d4l_1, tmp0_other_with_cast.d4l_1))
      return false;
    if (!equals(this.e4l_1, tmp0_other_with_cast.e4l_1))
      return false;
    if (!this.f4l_1.equals(tmp0_other_with_cast.f4l_1))
      return false;
    return true;
  }
}
class Curves {
  constructor(beziers, closed) {
    this.g4l_1 = new Mixin();
    this.h4l_1 = beziers;
    this.i4l_1 = closed;
    this.j4l_1 = false;
    var tmp = this;
    tmp.k4l_1 = lazy(Curves$contiguous$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.l4l_1 = lazy(Curves$infos$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.m4l_1 = lazy(Curves$length$delegate$lambda(this));
  }
  c28(_set____db54di) {
    this.g4l_1.c28(_set____db54di);
  }
  d28() {
    return this.g4l_1.d28();
  }
  z4l() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l4l_1;
    infos$factory();
    return this_0.w1();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m4l_1;
    length$factory();
    return this_0.w1();
  }
  a4m(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.d4l_1 / this.a());
  }
  b4m(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.e4l_1 / this.a());
  }
  c4m(t) {
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var tmp = this.z4l();
    var index = binarySearch(tmp, VOID, VOID, Curves$findInfo$lambda(pos));
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance().p27_1) < 0)
      return first(this.z4l());
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance().s27_1) > 0)
      return last(this.z4l());
    var tmp0_elvis_lhs = getOrNull(this.z4l(), index);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.h5(toString('OUTSIDE'));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  d4m(length) {
    if (length <= 0.0)
      return Companion_getInstance().p27_1;
    if (length >= this.a())
      return Companion_getInstance().s27_1;
    var tmp = this.z4l();
    var curveIndex = binarySearch(tmp, VOID, VOID, Curves$ratioFromLength$lambda(length));
    var index = curveIndex < 0 ? (-curveIndex | 0) + 1 | 0 : curveIndex;
    if (curveIndex < 0) {
      return Companion_getInstance().t27_1;
    }
    var info = this.z4l().h1(index);
    var lengthInCurve = length - info.d4l_1;
    var ratioInCurve = info.c4l_1.d4m(lengthInCurve);
    return convertRange(ratioInCurve, Companion_getInstance().p27_1, Companion_getInstance().s27_1, this.a4m(info), this.b4m(info));
  }
  e4m(len0, len1) {
    return this.f4m(this.d4m(len0), this.d4m(len1));
  }
  f4m(t0, t1) {
    if (Ratio__compareTo_impl_z2ienc(t0, t1) > 0)
      return this.f4m(t1, t0);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(Ratio__compareTo_impl_z2ienc(t0, t1) <= 0)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString(message));
    }
    if (equals(t0, t1))
      return new Curves(emptyList(), false);
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t0, this.a());
    var info = this.c4m(t0);
    var posInCurve = pos - info.d4l_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>' call
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos_0 = Ratio__times_impl_ucdh7y(t1, this.a());
    var info_0 = this.c4m(t1);
    var posInCurve_0 = pos_0 - info_0.d4l_1;
    var ratioInCurve_0 = _Ratio___init__impl__9mwvn2(posInCurve_0 / info_0.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>' call
    var tmp;
    if (info.b4l_1 === info_0.b4l_1) {
      tmp = listOf(info.c4l_1.f4m(ratioInCurve, ratioInCurve_0).g4m_1);
    } else {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList.z();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>.<anonymous>' call
      if (!equals(ratioInCurve, Companion_getInstance().s27_1)) {
        this_0.h(info.c4l_1.k4m(ratioInCurve).g4m_1);
      }
      var inductionVariable = info.b4l_1 + 1 | 0;
      var last = info_0.b4l_1;
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.h(this.z4l().h1(index).c4l_1);
        }
         while (inductionVariable < last);
      if (!equals(ratioInCurve_0, Companion_getInstance().p27_1)) {
        this_0.h(info_0.c4l_1.l4m(ratioInCurve_0).g4m_1);
      }
      tmp = this_0.m8();
    }
    var tmp$ret$7 = tmp;
    return new Curves(tmp$ret$7, false);
  }
  toString() {
    return 'Curves(beziers=' + toString(this.h4l_1) + ', closed=' + this.i4l_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.h4l_1);
    result = imul(result, 31) + getBooleanHashCode(this.i4l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Curves))
      return false;
    var tmp0_other_with_cast = other instanceof Curves ? other : THROW_CCE();
    if (!equals(this.h4l_1, tmp0_other_with_cast.h4l_1))
      return false;
    if (!(this.i4l_1 === tmp0_other_with_cast.i4l_1))
      return false;
    return true;
  }
}
class ProjectedPoint {
  constructor(p, t, dSq) {
    p = p === VOID ? Vector2D.i3l() : p;
    t = t === VOID ? Companion_getInstance().p27_1 : t;
    dSq = dSq === VOID ? 0.0 : dSq;
    this.z4m_1 = p;
    this.a4n_1 = t;
    this.b4n_1 = dSq;
  }
  d4n(other, epsilon) {
    return this.z4m_1.l3t(other.z4m_1, epsilon) && isAlmostEquals(this.a4n_1, other.a4n_1, toRatio(epsilon)) && isAlmostEquals_0(this.b4n_1, other.b4n_1, epsilon);
  }
  f27(other, epsilon) {
    return this.d4n(other instanceof ProjectedPoint ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return 'ProjectedPoint(p=' + this.z4m_1.toString() + ', t=' + Ratio__toString_impl_mfgt3e(this.a4n_1) + ', dSq=' + this.b4n_1 + ')';
  }
  hashCode() {
    var result = this.z4m_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.a4n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b4n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectedPoint))
      return false;
    var tmp0_other_with_cast = other instanceof ProjectedPoint ? other : THROW_CCE();
    if (!this.z4m_1.equals(tmp0_other_with_cast.z4m_1))
      return false;
    if (!equals(this.a4n_1, tmp0_other_with_cast.a4n_1))
      return false;
    if (!equals(this.b4n_1, tmp0_other_with_cast.b4n_1))
      return false;
    return true;
  }
}
class Extrema {
  constructor(xt, yt) {
    this.m4m_1 = xt;
    this.n4m_1 = yt;
    var tmp = this;
    tmp.o4m_1 = lazy(Bezier$Extrema$allt$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.p4m_1 = lazy(Bezier$Extrema$xt01$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.q4m_1 = lazy(Bezier$Extrema$yt01$delegate$lambda(this));
  }
  e4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p4m_1;
    xt01$factory();
    return this_0.w1();
  }
  f4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q4m_1;
    yt01$factory();
    return this_0.w1();
  }
  x4m(index) {
    return index === 0 ? this.e4n() : this.f4n();
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Extrema) {
      tmp_0 = contentEquals(this.m4m_1, other.m4m_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.n4m_1, other.n4m_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.m4m_1) + imul(contentHashCode(this.n4m_1), 7) | 0;
  }
  toString() {
    return 'Extrema(x=' + contentToString(this.m4m_1) + ', y=' + contentToString(this.n4m_1) + ')';
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.r4m_1 = new Float64Array([-0.06405689286260563, 0.06405689286260563, -0.1911188674736163, 0.1911188674736163, -0.3150426796961634, 0.3150426796961634, -0.4337935076260451, 0.4337935076260451, -0.5454214713888396, 0.5454214713888396, -0.6480936519369755, 0.6480936519369755, -0.7401241915785544, 0.7401241915785544, -0.820001985973903, 0.820001985973903, -0.8864155270044011, 0.8864155270044011, -0.9382745520027328, 0.9382745520027328, -0.9747285559713095, 0.9747285559713095, -0.9951872199970213, 0.9951872199970213]);
    var tmp_0 = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp_0.s4m_1 = new Float64Array([0.12793819534675216, 0.12793819534675216, 0.1258374563468283, 0.1258374563468283, 0.12167047292780339, 0.12167047292780339, 0.1155056680537256, 0.1155056680537256, 0.10744427011596563, 0.10744427011596563, 0.09761865210411388, 0.09761865210411388, 0.08619016153195327, 0.08619016153195327, 0.0733464814110803, 0.0733464814110803, 0.05929858491543678, 0.05929858491543678, 0.04427743881741981, 0.04427743881741981, 0.028531388628933663, 0.028531388628933663, 0.0123412297999872, 0.0123412297999872]);
    this.t4m_1 = 6.283185307179586;
    this.u4m_1 = Line2D.j3l(0, 0, 1, 0);
    this.v4m_1 = new Float64Array(0);
  }
  g4n(p0, p1, p2, p3, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.cubicCalc' call
    var x0 = p0.r3i_1;
    var y0 = p0.s3i_1;
    var x1 = p1.r3i_1;
    var y1 = p1.s3i_1;
    var x2 = p2.r3i_1;
    var y2 = p2.s3i_1;
    var cx = 3.0 * (x1 - x0);
    var bx = 3.0 * (x2 - x1) - cx;
    var ax = p3.r3i_1 - x0 - cx - bx;
    var cy = 3.0 * (y1 - y0);
    var by = 3.0 * (y2 - y1) - cy;
    var ay = p3.s3i_1 - y0 - cy - by;
    var tSquared = Ratio__times_impl_ucdh7y_0(t, t);
    var tCubed = Ratio__times_impl_ucdh7y_0(tSquared, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp = ax * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_0 = tmp + bx * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var x = tmp_0 + cx * _Ratio___get_value__impl__57cli6(t) + x0;
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_1 = ay * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_2 = tmp_1 + by * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var y = tmp_2 + cy * _Ratio___get_value__impl__57cli6(t) + y0;
    out = Vector2D.y3k(x, y);
    return out;
  }
  h4n(p, c, a, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.quadCalc' call
    var x0 = p.r3i_1;
    var y0 = p.s3i_1;
    var xc = c.r3i_1;
    var yc = c.s3i_1;
    var x1 = a.r3i_1;
    var y1 = a.s3i_1;
    var t1 = 1 - Ratio__toDouble_impl_o7epze(t);
    var a_0 = t1 * t1;
    var c_0 = Ratio__times_impl_ucdh7y_0(t, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var b = 2 * t1 * _Ratio___get_value__impl__57cli6(t);
    var x = a_0 * x0 + b * xc + Ratio__times_impl_ucdh7y(c_0, x1);
    var y = a_0 * y0 + b * yc + Ratio__times_impl_ucdh7y(c_0, y1);
    out = Vector2D.y3k(x, y);
    return out;
  }
  i4n(a, b) {
    return a + (b - a) * (2.0 / 3.0);
  }
  j4n(a, b) {
    return b + (a - b) * (2.0 / 3.0);
  }
}
class Bezier {
  static r4n(points, dummy) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.n4l_1 = points;
    if ($this.n4l_1.g1() > 4) {
      // Inline function 'kotlin.error' call
      var message = 'Only supports quad and cubic beziers';
      throw IllegalStateException.h5(toString(message));
    }
    var tmp = $this;
    tmp.o4l_1 = lazy(Bezier$aligned$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.p4l_1 = lazy(Bezier$dpoints$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.q4l_1 = lazy(Bezier$direction$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.r4l_1 = lazy(Bezier$extrema$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.s4l_1 = lazy(Bezier$outerCircle$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.t4l_1 = lazy(Bezier$boundingBox$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.u4l_1 = lazy(Bezier$length$delegate$lambda($this));
    var tmp_6 = $this;
    tmp_6.v4l_1 = lazy(Bezier$lut$delegate$lambda($this));
    var tmp_7 = $this;
    tmp_7.w4l_1 = lazy(Bezier$isLinear$delegate$lambda($this));
    var tmp_8 = $this;
    tmp_8.x4l_1 = lazy(Bezier$isSimple$delegate$lambda($this));
    return $this;
  }
  static s4n() {
    Companion_getInstance_8();
    return this.t4n(Vector2D.m3q(0.0, 0.0), Vector2D.m3q(0.0, 0.0));
  }
  static t4n(p0, p1) {
    Companion_getInstance_8();
    return this.r4n(pointArrayListOf(p0, p1), Unit_instance);
  }
  static u4n(p0, p1, p2) {
    Companion_getInstance_8();
    return this.r4n(pointArrayListOf_0(p0, p1, p2), Unit_instance);
  }
  static v4n(p0, p1, p2, p3) {
    Companion_getInstance_8();
    return this.r4n(pointArrayListOf_1(p0, p1, p2, p3), Unit_instance);
  }
  static w4n(points) {
    Companion_getInstance_8();
    return this.r4n(points.t44(), Unit_instance);
  }
  x4n(other, epsilon) {
    if (!(this.n4l_1.g1() === other.n4l_1.g1()))
      return false;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = until(0, this.n4l_1.g1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var inductionVariable = this_0.f2_1;
      var last = this_0.g2_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.math.geom.bezier.Bezier.isAlmostEquals.<anonymous>' call
          var it = element;
          if (!this.n4l_1.h1(it).l3t(other.n4l_1.h1(it), epsilon)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
         while (!(element === last));
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  f27(other, epsilon) {
    return this.x4n(other instanceof Bezier ? other : THROW_CCE(), epsilon);
  }
  y4m(t) {
    return this.y4n(t);
  }
  y4l() {
    return this.n4n();
  }
  z4n(m) {
    return _getBoundingBox(this, m);
  }
  a4o(t) {
    return this.y4n(t);
  }
  equals(other) {
    var tmp;
    if (other instanceof Bezier) {
      tmp = equals(this.n4l_1, other.n4l_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.n4l_1);
  }
  toString() {
    return 'Bezier(' + toString(this.n4l_1) + ')';
  }
  l4n() {
    return 2;
  }
  k4n() {
    return this.n4l_1.g1() - 1 | 0;
  }
  m4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p4l_1;
    dpoints$factory();
    return this_0.w1();
  }
  w4m() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r4l_1;
    extrema$factory();
    return this_0.w1();
  }
  b4o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s4l_1;
    outerCircle$factory();
    return this_0.w1();
  }
  n4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t4l_1;
    boundingBox$factory();
    return this_0.w1();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u4l_1;
    length$factory_0();
    return this_0.w1();
  }
  c4o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v4l_1;
    lut$factory();
    return this_0.w1();
  }
  d4m(length) {
    return this.c4o().k4o(length).e4o_1;
  }
  l4o(steps, out) {
    out.h3();
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance();
    var NS = (steps + 1 | 0) - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.Bezier.getLUT.<anonymous>' call
        var t = toRatio(ratio);
        out.m4o(t, this.y4n(t));
      }
       while (!(n === end));
    return out;
  }
  p4n(steps, out, $super) {
    steps = steps === VOID ? 100 : steps;
    out = out === VOID ? CurveLUT.n4o(this, steps + 1 | 0) : out;
    return $super === VOID ? this.l4o(steps, out) : $super.l4o.call(this, steps, out);
  }
  o4o(point, out) {
    out.c4n_1 = this;
    if (this.n4l_1.g1() === 2) {
      var p0 = this.n4l_1.h1(0);
      var p1 = this.n4l_1.h1(1);
      return findNearestLine(this, point.r3i_1, point.s3i_1, p0.r3i_1, p0.s3i_1, p1.r3i_1, p1.s3i_1, out);
    }
    var LUT = this.c4o();
    var l = LUT.p4o();
    var closest = LUT.q4o(point);
    var mpos = closest.s4o_1;
    var t1 = (mpos - 1 | 0) / l;
    var t2 = (mpos + 1 | 0) / l;
    var step = 0.1 / l;
    var mdistSq = closest.r4o_1;
    var t = t1;
    var ft = t;
    mdistSq = mdistSq + 1;
    while (t < t2 + step) {
      var p = this.y4n(toRatio(t));
      var d = Companion_getInstance_2().h3k(point, p);
      if (d < mdistSq) {
        mdistSq = d;
        ft = t;
        out.z4m_1 = p;
      }
      t = t + step;
    }
    out.z4m_1 = this.y4n(toRatio(ft));
    out.a4n_1 = ft < 0 ? Companion_getInstance().p27_1 : ft > 1 ? Companion_getInstance().s27_1 : toRatio(ft);
    out.b4n_1 = mdistSq;
    return out;
  }
  t4o() {
    if (this.n4l_1.g1() < 4)
      return Companion_getInstance_8().v4m_1;
    var p = _get_aligned__7fjidv(this);
    var p1 = p.h1(1);
    var p2 = p.h1(2);
    var p3 = p.h1(3);
    var a = p2.r3i_1 * p1.s3i_1;
    var b = p3.r3i_1 * p1.s3i_1;
    var c = p1.r3i_1 * p2.s3i_1;
    var d = p3.r3i_1 * p2.s3i_1;
    var v1 = 18.0 * (-3.0 * a + 2.0 * b + 3.0 * c - d);
    var v2 = 18.0 * (3.0 * a - b - 3.0 * c);
    var v3 = 18.0 * (c - a);
    if (isAlmostZero(v1)) {
      if (!isAlmostZero(v2)) {
        var t = -v3 / v2;
        if (0.0 <= t ? t <= 1.0 : false) {
          // Inline function 'kotlin.doubleArrayOf' call
          return new Float64Array([t]);
        }
      }
      return Companion_getInstance_8().v4m_1;
    }
    var d2 = 2.0 * v1;
    if (isAlmostEquals_0(d2, 0.0))
      return Companion_getInstance_8().v4m_1;
    var trm = v2 * v2 - 4.0 * v1 * v3;
    if (trm < 0)
      return Companion_getInstance_8().v4m_1;
    // Inline function 'kotlin.math.sqrt' call
    var sq = Math.sqrt(trm);
    var out0 = (sq - v2) / d2;
    var out1 = -(v2 + sq) / d2;
    var out = DoubleArrayList.f3x(2);
    if (0.0 <= out0 ? out0 <= 1.0 : false) {
      out.s29(out0);
    }
    if (0.0 <= out1 ? out1 <= 1.0 : false) {
      out.s29(out1);
    }
    return out.y27();
  }
  y4n(t) {
    return compute(Companion_getInstance_8(), t, this.n4l_1);
  }
  u4o(t, normalize) {
    var out = compute(Companion_getInstance_8(), t, this.m4n().h1(0));
    if ((equals(t, Companion_getInstance().p27_1) || equals(t, Companion_getInstance().s27_1)) && isAlmostZero(out.h3t())) {
      var inductionVariable = 0;
      if (inductionVariable < 10)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.math.pow' call
          var n_0 = -(10 - n | 0) | 0;
          var newT = Math.pow(10.0, n_0);
          var nt = equals(t, Companion_getInstance().s27_1) ? 1.0 - newT : newT;
          out = compute(Companion_getInstance_8(), _Ratio___init__impl__9mwvn2(nt), this.m4n().h1(0));
          if (!isAlmostZero(out.h3t()))
            break $l$loop;
        }
         while (inductionVariable < 10);
    }
    if (normalize)
      out = out.j3t();
    return out;
  }
  o4n(t, normalize, $super) {
    normalize = normalize === VOID ? false : normalize;
    return $super === VOID ? this.u4o(t, normalize) : $super.u4o.call(this, new Ratio(t), normalize);
  }
  v4o(t, normalize) {
    return this.u4o(t, normalize).k3t();
  }
  q4n(t) {
    return this.v4o(t, true);
  }
  w4o(t, out) {
    if (this.k4n() < 2)
      return null;
    var p = this.n4l_1;
    out.y44(p, 0);
    out.y44(p, 1);
    out.y44(p, 2);
    if (this.k4n() === 3) {
      out.y44(p, 3);
    }
    while (p.g1() > 1) {
      var next = new PointArrayList();
      var inductionVariable = 0;
      var last = p.g1() - 1 | 0;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var p_0 = interpolate_1(toRatio_0(t), p.h1(i), p.h1(i + 1 | 0));
          out.v44(p_0);
          next.v44(p_0);
        }
         while (inductionVariable < last);
      p = next;
    }
    return out;
  }
  x4o(t, out, $super) {
    out = out === VOID ? new PointArrayList() : out;
    return $super === VOID ? this.w4o(t, out) : $super.w4o.call(this, new Ratio(t), out);
  }
  f4m(t0, t1) {
    return SubBezier.y4o(this.k4m(t0).l4m(map(Companion_getInstance_8(), t1, t0, Companion_getInstance().s27_1, Companion_getInstance().p27_1, Companion_getInstance().s27_1)).g4m_1, t0, t1, this);
  }
  l4m(t) {
    return SubBezier.z4o(this).l4m(t);
  }
  k4m(t) {
    return SubBezier.z4o(this).k4m(t);
  }
  a4p() {
    return Line2D.g3l(this.n4l_1.h1(0), this.n4l_1.h1(this.k4n()));
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_0 = new Int32Array([0, 3, 5]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$1 = new Int32Array([0, 4, 7, 9]);
    tmp.b4p_1 = listOf_0([null, null, tmp_0, tmp$ret$1]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_2 = new Int32Array([5, 4, 2]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$3 = new Int32Array([9, 8, 6, 3]);
    tmp_1.c4p_1 = listOf_0([null, null, tmp_2, tmp$ret$3]);
  }
}
class SubBezier {
  static y4o(curve, t1, t2, parent) {
    Companion_getInstance_9();
    var $this = createThis(this);
    $this.g4m_1 = curve;
    $this.h4m_1 = t1;
    $this.i4m_1 = t2;
    $this.j4m_1 = parent;
    return $this;
  }
  static z4o(curve) {
    Companion_getInstance_9();
    return this.y4o(curve, Companion_getInstance().p27_1, Companion_getInstance().s27_1, null);
  }
  a4o(t) {
    return this.g4m_1.a4o(convertRange(t, this.h4m_1, this.i4m_1, Companion_getInstance().p27_1, Companion_getInstance().s27_1));
  }
  l4m(t) {
    return _splitLeft$default(this, t);
  }
  k4m(t) {
    return _splitRight$default(this, t);
  }
  toString() {
    return 'SubBezier[' + get_niceStr(Ratio__toDouble_impl_o7epze(this.h4m_1)) + '..' + get_niceStr(Ratio__toDouble_impl_o7epze(this.i4m_1)) + '](' + this.g4m_1.toString() + ')';
  }
}
class ClosestResult {
  constructor(mdistSq, mpos) {
    this.r4o_1 = mdistSq;
    this.s4o_1 = mpos;
  }
}
class Estimation {
  constructor(point, ratio, length) {
    point = point === VOID ? Vector2D.i3l() : point;
    ratio = ratio === VOID ? Companion_getInstance().p27_1 : ratio;
    length = length === VOID ? 0.0 : length;
    this.d4o_1 = point;
    this.e4o_1 = ratio;
    this.f4o_1 = length;
  }
  toString() {
    return 'Estimation(point=' + this.d4o_1.m3t() + ', ratio=' + get_niceStr_0(this.e4o_1) + ', length=' + get_niceStr(this.f4o_1) + ')';
  }
  hashCode() {
    var result = this.d4o_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.e4o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.f4o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Estimation))
      return false;
    var tmp0_other_with_cast = other instanceof Estimation ? other : THROW_CCE();
    if (!this.d4o_1.equals(tmp0_other_with_cast.d4o_1))
      return false;
    if (!equals(this.e4o_1, tmp0_other_with_cast.e4o_1))
      return false;
    if (!equals(this.f4o_1, tmp0_other_with_cast.f4o_1))
      return false;
    return true;
  }
}
class CurveLUT {
  static f4p(curve, points, ts, _estimatedLengths) {
    var $this = createThis(this);
    $this.g4o_1 = curve;
    $this.h4o_1 = points;
    $this.i4o_1 = ts;
    $this.j4o_1 = _estimatedLengths;
    return $this;
  }
  static n4o(curve, capacity) {
    return this.f4p(curve, new PointArrayList(capacity), DoubleArrayList.f3x(capacity), DoubleArrayList.f3x(capacity));
  }
  e4p() {
    if (this.j4o_1.j1()) {
      this.j4o_1.s29(0.0);
    }
    while (this.j4o_1.g1() < this.g1()) {
      var pos = this.j4o_1.g1();
      var prev = last_0(this.j4o_1);
      this.j4o_1.s29(prev + Companion_getInstance_2().d3t(this.h4o_1.h1(pos - 1 | 0), this.h4o_1.h1(pos)));
    }
    return this.j4o_1;
  }
  p4o() {
    return this.h4o_1.g1() - 1 | 0;
  }
  g1() {
    return this.h4o_1.g1();
  }
  h3() {
    this.h4o_1.ai();
    this.i4o_1.h3();
    this.j4o_1.h3();
  }
  m4o(t, p) {
    this.h4o_1.v44(p);
    this.i4o_1.s29(Ratio__toDouble_impl_o7epze(t));
  }
  q4o(point) {
    var mdistSq = Infinity;
    var mpos = 0;
    var inductionVariable = 0;
    var last = this.g1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = Companion_getInstance_2().h3k(this.h4o_1.h1(n), point);
        if (d < mdistSq) {
          mdistSq = d;
          mpos = n;
        }
      }
       while (inductionVariable < last);
    return new ClosestResult(mdistSq, mpos);
  }
  d4p(_this__u8e3s4, index, ratio) {
    var ratio0 = toRatio(this.i4o_1.h1(index));
    var length0 = this.e4p().h1(index);
    var point0 = this.h4o_1.h1(index);
    if (ratio === 0.0) {
      _this__u8e3s4.e4o_1 = ratio0;
      _this__u8e3s4.f4o_1 = length0;
      _this__u8e3s4.d4o_1 = point0;
    } else {
      var ratio1 = toRatio(this.i4o_1.h1(index + 1 | 0));
      var length1 = this.e4p().h1(index + 1 | 0);
      var point1 = this.h4o_1.h1(index + 1 | 0);
      _this__u8e3s4.e4o_1 = interpolate(toRatio(ratio), ratio0, ratio1);
      _this__u8e3s4.f4o_1 = interpolate_0(toRatio(ratio), length0, length1);
      _this__u8e3s4.d4o_1 = interpolate_1(toRatio(ratio), point0, point1);
    }
    return _this__u8e3s4;
  }
  g4p(length, out) {
    return estimateAt(this, this.e4p(), length, out);
  }
  k4o(length, out, $super) {
    out = out === VOID ? new Estimation() : out;
    return $super === VOID ? this.g4p(length, out) : $super.g4p.call(this, length, out);
  }
  toString() {
    var tmp = toString(this.g4o_1);
    var tmp_0 = until(0, this.g1());
    return 'CurveLUT[' + tmp + '](' + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, CurveLUT$toString$lambda(this)) + ')';
  }
  hashCode() {
    var result = hashCode(this.g4o_1);
    result = imul(result, 31) + this.h4o_1.hashCode() | 0;
    result = imul(result, 31) + this.i4o_1.hashCode() | 0;
    result = imul(result, 31) + this.j4o_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveLUT))
      return false;
    var tmp0_other_with_cast = other instanceof CurveLUT ? other : THROW_CCE();
    if (!equals(this.g4o_1, tmp0_other_with_cast.g4o_1))
      return false;
    if (!this.h4o_1.equals(tmp0_other_with_cast.h4o_1))
      return false;
    if (!this.i4o_1.equals(tmp0_other_with_cast.i4o_1))
      return false;
    if (!this.j4o_1.equals(tmp0_other_with_cast.j4o_1))
      return false;
    return true;
  }
}
class Arc {
  constructor() {
    this.h4p_1 = 0.5522847498307933;
    this.i4p_1 = 6.283185307179586;
  }
  j4p(out, center, r, start, end, counterclockwise) {
    var x = center.em();
    var y = center.fm();
    var startAngle = _Angle___get_normalized__impl__9s30ys(start);
    var endAngle1 = _Angle___get_normalized__impl__9s30ys(end);
    var endAngle = Angle__compareTo_impl_a0hfds(endAngle1, startAngle) < 0 ? Angle__plus_impl_26v37k(endAngle1, Companion_getInstance_3().m3i_1) : endAngle1;
    // Inline function 'korlibs.math.geom.min' call
    var a = Companion_getInstance_3().m3i_1;
    // Inline function 'korlibs.math.geom.abs' call
    var angle = Angle__minus_impl_xeau7k(endAngle, startAngle);
    var b = _Angle___get_absoluteValue__impl__4qoakv(angle);
    // Inline function 'kotlin.math.min' call
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var a_0 = _Angle___get_radians__impl__n00yt5(a);
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var b_0 = _Angle___get_radians__impl__n00yt5(b);
    var tmp$ret$3 = Math.min(a_0, b_0);
    var remainingAngle = _Angle___init__impl__g23q1m(tmp$ret$3);
    if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_3().h3i_1) < 0 && !equals(start, end))
      remainingAngle = Companion_getInstance_3().m3i_1;
    var sgn1 = Angle__compareTo_impl_a0hfds(startAngle, endAngle) < 0 ? 1 : -1;
    var sgn = counterclockwise ? -sgn1 | 0 : sgn1;
    if (counterclockwise) {
      remainingAngle = Angle__minus_impl_xeau7k(Companion_getInstance_3().m3i_1, remainingAngle);
      if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_3().h3i_1) < 0 && !equals(start, end))
        remainingAngle = Companion_getInstance_3().m3i_1;
    }
    var a1 = startAngle;
    var index = 0;
    while (Angle__compareTo_impl_a0hfds(remainingAngle, Companion_getInstance_3().h3i_1) > 0) {
      var tmp = a1;
      // Inline function 'korlibs.math.geom.min' call
      var a_1 = remainingAngle;
      var b_1 = Companion_getInstance_3().j3i_1;
      // Inline function 'kotlin.math.min' call
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var a_2 = _Angle___get_radians__impl__n00yt5(a_1);
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var b_2 = _Angle___get_radians__impl__n00yt5(b_1);
      var tmp$ret$7 = Math.min(a_2, b_2);
      var tmp$ret$8 = _Angle___init__impl__g23q1m(tmp$ret$7);
      var a2 = Angle__plus_impl_26v37k(tmp, Angle__times_impl_v3s9y2(tmp$ret$8, sgn));
      var a_3 = Angle__div_impl_ut2btd(Angle__minus_impl_xeau7k(a2, a1), 2.0);
      var x4 = r * _Angle___get_cosine__impl__vprvmu(a_3);
      var y4 = r * _Angle___get_sine__impl__15nmyi(a_3);
      var x1 = x4;
      var y1 = -y4;
      var f = 0.5522847498307933 * _Angle___get_tangent__impl__vushdy(a_3);
      var x2 = x1 + f * y4;
      var y2 = y1 + f * x4;
      var x3 = x2;
      var y3 = -y2;
      var ar = Angle__plus_impl_26v37k(a_3, a1);
      var cos_ar = _Angle___get_cosine__impl__vprvmu(ar);
      var sin_ar = _Angle___get_sine__impl__15nmyi(ar);
      if (index === 0) {
        out.k4p(Vector2D.y3k(x + r * _Angle___get_cosine__impl__vprvmu(a1), y + r * _Angle___get_sine__impl__15nmyi(a1)));
      }
      out.l4p(Vector2D.y3k(x + x2 * cos_ar - y2 * sin_ar, y + x2 * sin_ar + y2 * cos_ar), Vector2D.y3k(x + x3 * cos_ar - y3 * sin_ar, y + x3 * sin_ar + y3 * cos_ar), Vector2D.y3k(x + r * _Angle___get_cosine__impl__vprvmu(a2), y + r * _Angle___get_sine__impl__15nmyi(a2)));
      index = index + 1 | 0;
      var tmp_0 = remainingAngle;
      // Inline function 'korlibs.math.geom.abs' call
      var angle_0 = Angle__minus_impl_xeau7k(a2, a1);
      var tmp$ret$9 = _Angle___get_absoluteValue__impl__4qoakv(angle_0);
      remainingAngle = Angle__minus_impl_xeau7k(tmp_0, tmp$ret$9);
      a1 = a2;
    }
    if (equals(startAngle, endAngle) && !(index === 0)) {
      out.p6();
    }
  }
}
class Companion_1 {
  a4q(width, height, algo) {
    return new BinPacker(Size2D.r3q(width, height), algo);
  }
  b4q(width, height, algo) {
    return Companion_instance_1.a4q(width, height, algo);
  }
  c4q(width, height, algo, $super) {
    algo = algo === VOID ? MaxRects.e4q(width, height) : algo;
    return $super === VOID ? this.b4q(width, height, algo) : $super.b4q.call(this, width, height, algo);
  }
}
class ImageDoNotFitException extends Error {
  static j4q(width, height, packer) {
    var $this = createThis(this);
    setPropertiesToThrowableInstance($this, "Size '" + width + 'x' + height + "' doesn't fit in '" + packer.f3u() + 'x' + packer.g3u() + "'");
    captureStack($this, $this.i4q_1);
    $this.f4q_1 = width;
    $this.g4q_1 = height;
    $this.h4q_1 = packer;
    return $this;
  }
}
class BinPacker {
  constructor(size, algo) {
    algo = algo === VOID ? MaxRects.n4q(size) : algo;
    this.k4q_1 = size;
    this.l4q_1 = algo;
    this.m4q_1 = FastArrayList.u28();
  }
  f3u() {
    return this.k4q_1.u3j_1;
  }
  g3u() {
    return this.k4q_1.v3j_1;
  }
  u44(width, height) {
    var tmp0_elvis_lhs = this.o4q(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw ImageDoNotFitException.j4q(width, height, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  o4q(width, height) {
    var tmp0_elvis_lhs = this.l4q_1.p4q(Size2D.r3q(width, height));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rect = tmp;
    // Inline function 'kotlin.collections.plusAssign' call
    this.m4q_1.h(rect);
    return rect;
  }
}
class MaxRects {
  static n4q(maxSize) {
    var $this = createThis(this);
    $this.d4q_1 = fastArrayListOf([Companion_getInstance_1().x3j(Companion_getInstance_2().t3i_1, maxSize)]);
    return $this;
  }
  static e4q(width, height) {
    return this.n4q(Size2D.r3q(width, height));
  }
  p4q(size) {
    return this.q4q(size);
  }
  q4q(size) {
    var width = size.em();
    var height = size.fm();
    if (width <= 0.0 && height <= 0.0)
      return Companion_getInstance_1().k3q(0, 0, 0, 0);
    var newNode = quickFindPositionForNewNodeBestAreaFit(this, width, height);
    if (newNode.e3j_1 === 0.0)
      return null;
    var numRectanglesToProcess = this.d4q_1.g1();
    var i = 0;
    while (i < numRectanglesToProcess) {
      if (splitFreeNode(this, this.d4q_1.h1(i), newNode)) {
        this.d4q_1.j3(i);
        numRectanglesToProcess = numRectanglesToProcess - 1 | 0;
        i = i - 1 | 0;
      }
      i = i + 1 | 0;
    }
    pruneFreeList(this);
    return newNode;
  }
}
class Companion_2 {}
class HitTestDirection extends Enum {}
class Convex {
  z4p(curves) {
    var tmp0_elvis_lhs = toNonCurveSimplePointList(curves);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var points = tmp;
    return this.r4q(points);
  }
  r4q(vertices) {
    var base = 0;
    var n = vertices.g1();
    var TWO_PI = 3.141592653589793 * 2;
    if (n <= 3)
      return true;
    if (vertices.w3k(base) === vertices.w3k(n - 1 | 0) && vertices.x3k(base) === vertices.x3k(n - 1 | 0)) {
      n = n - 1 | 0;
    }
    var old_x = vertices.w3k(n - 2 | 0);
    var old_y = vertices.x3k(n - 2 | 0);
    var new_x = vertices.w3k(n - 1 | 0);
    var new_y = vertices.x3k(n - 1 | 0);
    // Inline function 'kotlin.math.atan2' call
    var y = new_y - old_y;
    var x = new_x - old_x;
    var new_direction = Math.atan2(y, x);
    var old_direction;
    var angle_sum = Companion_getInstance_3().i3i_1;
    var orientation = 0.0;
    var inductionVariable = 0;
    var last = n;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        old_x = new_x;
        old_y = new_y;
        old_direction = new_direction;
        var _unary__edvuaz = base;
        base = _unary__edvuaz + 1 | 0;
        var p = _unary__edvuaz;
        new_x = vertices.w3k(p);
        new_y = vertices.x3k(p);
        // Inline function 'kotlin.math.atan2' call
        var y_0 = new_y - old_y;
        var x_0 = new_x - old_x;
        new_direction = Math.atan2(y_0, x_0);
        if (old_x === new_x && old_y === new_y) {
          return false;
        }
        var angle = new_direction - old_direction;
        if (angle <= -3.141592653589793)
          angle = angle + TWO_PI;
        else if (angle > 3.141592653589793)
          angle = angle - TWO_PI;
        if (i === 0) {
          if (angle === 0.0) {
            return false;
          }
          orientation = angle > 0 ? 1.0 : -1.0;
        } else if (orientation * angle < 0.0) {
          return false;
        }
        var tmp = angle_sum;
        // Inline function 'korlibs.math.geom.Companion.fromRadians' call
        Companion_getInstance_3();
        var radians = angle;
        var tmp$ret$2 = _Angle___init__impl__g23q1m(radians);
        angle_sum = Angle__plus_impl_26v37k(tmp, tmp$ret$2);
      }
       while (inductionVariable < last);
    return isAlmostEquals(Companion_getInstance().s27_1, _Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle_sum)));
  }
}
class AbstractShape2D {}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    this.s4q_1 = values();
  }
  h1(index) {
    return this.s4q_1[umod(index, 4)];
  }
}
class SliceRotation extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.v4q_1 = imul(this.p3_1, 90);
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(8), null);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var this_0 = new Int32Array([0, 1, 2, 3]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.INDICES.<anonymous>' call
      var orientation = _SliceOrientation___init__impl__ewylib(tmp_2);
      if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
        swap(this_0, 0, 1);
        swap(this_0, 3, 2);
      }
      rotateRight(this_0, _SliceOrientation___get_rotation__impl__m65r0o(orientation).p3_1);
      tmp_1[tmp_2] = this_0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.w4q_1 = tmp_1;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(8), null);
    while (tmp_4 < 8) {
      var tmp_6 = tmp_4;
      var orientation_0 = _SliceOrientation___init__impl__ewylib(tmp_6);
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_1 = StringBuilder.f();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.NAMES.<anonymous>' call
      this_1.gc(_SliceOrientation___get_flipX__impl__lgb7bx(orientation_0) ? 'MIRROR_HORIZONTAL_ROTATE_' : 'ROTATE_');
      this_1.rh(_SliceOrientation___get_rotation__impl__m65r0o(orientation_0).v4q_1);
      tmp_5[tmp_6] = this_1.toString();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.x4q_1 = tmp_5;
    var tmp_7 = this;
    var tmp39_rotation = SliceRotation_R0_getInstance();
    tmp_7.y4q_1 = _SliceOrientation___init__impl__ewylib_0(tmp39_rotation, false);
    var tmp_8 = this;
    var tmp40_rotation = SliceRotation_R90_getInstance();
    tmp_8.z4q_1 = _SliceOrientation___init__impl__ewylib_0(tmp40_rotation, false);
    var tmp_9 = this;
    var tmp41_rotation = SliceRotation_R180_getInstance();
    tmp_9.a4r_1 = _SliceOrientation___init__impl__ewylib_0(tmp41_rotation, false);
    var tmp_10 = this;
    var tmp42_rotation = SliceRotation_R270_getInstance();
    tmp_10.b4r_1 = _SliceOrientation___init__impl__ewylib_0(tmp42_rotation, false);
    this.c4r_1 = _SliceOrientation___init__impl__ewylib_0(VOID, true);
    var tmp_11 = this;
    var tmp43_rotation = SliceRotation_R90_getInstance();
    tmp_11.d4r_1 = _SliceOrientation___init__impl__ewylib_0(tmp43_rotation, true);
    var tmp_12 = this;
    var tmp44_rotation = SliceRotation_R180_getInstance();
    tmp_12.e4r_1 = _SliceOrientation___init__impl__ewylib_0(tmp44_rotation, true);
    var tmp_13 = this;
    var tmp45_rotation = SliceRotation_R270_getInstance();
    tmp_13.f4r_1 = _SliceOrientation___init__impl__ewylib_0(tmp45_rotation, true);
    this.g4r_1 = listOf_0([new SliceOrientation(this.y4q_1), new SliceOrientation(this.z4q_1), new SliceOrientation(this.a4r_1), new SliceOrientation(this.b4r_1), new SliceOrientation(this.c4r_1), new SliceOrientation(this.d4r_1), new SliceOrientation(this.e4r_1), new SliceOrientation(this.f4r_1)]);
  }
}
class SliceOrientation {
  constructor(raw) {
    Companion_getInstance_13();
    this.h4r_1 = raw;
  }
  toString() {
    return SliceOrientation__toString_impl_tdph6r(this.h4r_1);
  }
  hashCode() {
    return SliceOrientation__hashCode_impl_7mjkdw(this.h4r_1);
  }
  equals(other) {
    return SliceOrientation__equals_impl_h4gywg(this.h4r_1, other);
  }
}
class SliceCoords {}
function x(index) {
  switch (index) {
    case 0:
      return this.c4t();
    case 1:
      return this.e4t();
    case 2:
      return this.g4t();
    case 3:
      return this.i4t();
    default:
      return NaN;
  }
}
function y(index) {
  switch (index) {
    case 0:
      return this.d4t();
    case 1:
      return this.f4t();
    case 2:
      return this.h4t();
    case 3:
      return this.j4t();
    default:
      return NaN;
  }
}
class SliceCoordsWithBase {}
function get_frameOffsetX() {
  return this.t4s().t3l_1;
}
function get_frameOffsetY() {
  return this.t4s().q3l_1;
}
function get_frameWidth() {
  return this.f3u() + this.t4s().x3l() | 0;
}
function get_frameHeight() {
  return this.g3u() + this.t4s().y3l() | 0;
}
class SliceCoordsWithBaseAndRect {}
function get_left() {
  return this.s4s().i3j();
}
function get_top() {
  return this.s4s().d3q();
}
function get_right() {
  return this.s4s().j3j();
}
function get_bottom() {
  return this.s4s().c3q();
}
function get_area() {
  return this.s4s().x3r();
}
class RectSlice {
  constructor(base, rect, orientation, padding, name) {
    orientation = orientation === VOID ? Companion_getInstance_13().y4q_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_5().p3l_1 : padding;
    name = name === VOID ? null : name;
    this.i4r_1 = base;
    this.j4r_1 = rect;
    this.k4r_1 = orientation;
    this.l4r_1 = padding;
    this.m4r_1 = name;
    this.n4r_1 = this.i4r_1.g1().v3s_1;
    this.o4r_1 = this.i4r_1.g1().w3s_1;
    this.p4r_1 = this.j4r_1.h3r_1;
    this.q4r_1 = this.j4r_1.i3r_1;
    this.r4r_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.k4r_1) ? this.j4r_1.h3r_1 : this.j4r_1.i3r_1;
    this.s4r_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.k4r_1) ? this.j4r_1.i3r_1 : this.j4r_1.h3r_1;
    this.t4r_1 = this.r4r_1 + this.l4r_1.x3l() | 0;
    this.u4r_1 = this.s4r_1 + this.l4r_1.y3l() | 0;
    this.v4r_1 = this.j4r_1.i3j() / this.n4r_1;
    this.w4r_1 = this.j4r_1.j3j() / this.n4r_1;
    this.x4r_1 = this.j4r_1.d3q() / this.o4r_1;
    this.y4r_1 = this.j4r_1.c3q() / this.o4r_1;
    this.z4r_1 = new RectCoords(this.v4r_1, this.x4r_1, this.w4r_1, this.x4r_1, this.w4r_1, this.y4r_1, this.v4r_1, this.y4r_1);
    this.a4s_1 = transformed_1(this.z4r_1, this.k4r_1);
    this.b4s_1 = this.a4s_1.j4s_1;
    this.c4s_1 = this.a4s_1.k4s_1;
    this.d4s_1 = this.a4s_1.l4s_1;
    this.e4s_1 = this.a4s_1.m4s_1;
    this.f4s_1 = this.a4s_1.n4s_1;
    this.g4s_1 = this.a4s_1.o4s_1;
    this.h4s_1 = this.a4s_1.p4s_1;
    this.i4s_1 = this.a4s_1.q4s_1;
  }
  r4s() {
    return this.i4r_1;
  }
  s4s() {
    return this.j4r_1;
  }
  t4s() {
    return this.l4r_1;
  }
  f3u() {
    return this.r4r_1;
  }
  g3u() {
    return this.s4r_1;
  }
  u4s() {
    return this.t4r_1;
  }
  v4s() {
    return this.u4r_1;
  }
  w4s(left, top, right, bottom, name, clamped, orientation) {
    var tmp = this.j4r_1.y3r(left, top, right, bottom, clamped);
    return new RectSlice(this.i4r_1, tmp, orientation, this.l4r_1, name == null ? this.m4r_1 : name);
  }
  x4s(left, top, right, bottom, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.k4r_1 : orientation;
    return $super === VOID ? this.w4s(left, top, right, bottom, name, clamped, orientation) : $super.w4s.call(this, left, top, right, bottom, name, clamped, new SliceOrientation(orientation));
  }
  y4s(x, y, width, height, name, clamped, orientation) {
    return this.w4s(x, y, x + width | 0, y + height | 0, name, clamped, orientation);
  }
  z4s(x, y, width, height, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.k4r_1 : orientation;
    return $super === VOID ? this.y4s(x, y, width, height, name, clamped, orientation) : $super.y4s.call(this, x, y, width, height, name, clamped, new SliceOrientation(orientation));
  }
  a4t(rect, name, clamped, orientation) {
    return this.w4s(rect.i3j(), rect.d3q(), rect.j3j(), rect.c3q(), name, clamped, orientation);
  }
  b4t(rect, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.k4r_1 : orientation;
    return $super === VOID ? this.a4t(rect, name, clamped, orientation) : $super.a4t.call(this, rect, name, clamped, new SliceOrientation(orientation));
  }
  c4t() {
    return this.b4s_1;
  }
  d4t() {
    return this.c4s_1;
  }
  e4t() {
    return this.d4s_1;
  }
  f4t() {
    return this.e4s_1;
  }
  g4t() {
    return this.f4s_1;
  }
  h4t() {
    return this.g4s_1;
  }
  i4t() {
    return this.h4s_1;
  }
  j4t() {
    return this.i4s_1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.slice.RectSlice.toString.<anonymous>' call
    this_0.gc('RectSlice(');
    this_0.gc(this.m4r_1);
    this_0.gc(':');
    this_0.fc(this.j4r_1);
    if (!(this.k4r_1 === Companion_getInstance_13().y4q_1)) {
      this_0.gc(':');
      this_0.fc(new SliceOrientation(this.k4r_1));
    }
    if (this.l4r_1.w3l()) {
      this_0.gc(':');
      this_0.fc(this.l4r_1);
    }
    this_0.gc(')');
    return this_0.toString();
  }
  hashCode() {
    var result = hashCode(this.i4r_1);
    result = imul(result, 31) + this.j4r_1.hashCode() | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.k4r_1) | 0;
    result = imul(result, 31) + this.l4r_1.hashCode() | 0;
    result = imul(result, 31) + (this.m4r_1 == null ? 0 : getStringHashCode(this.m4r_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectSlice))
      return false;
    var tmp0_other_with_cast = other instanceof RectSlice ? other : THROW_CCE();
    if (!equals(this.i4r_1, tmp0_other_with_cast.i4r_1))
      return false;
    if (!this.j4r_1.equals(tmp0_other_with_cast.j4r_1))
      return false;
    if (!(this.k4r_1 === tmp0_other_with_cast.k4r_1))
      return false;
    if (!this.l4r_1.equals(tmp0_other_with_cast.l4r_1))
      return false;
    if (!(this.m4r_1 == tmp0_other_with_cast.m4r_1))
      return false;
    return true;
  }
}
class Companion_5 {
  o4t(base, coords, name, flippedWidthHeight) {
    return new SliceCoordsImpl(base, coords, name, flippedWidthHeight);
  }
  p4t(base, coords, name, flippedWidthHeight, $super) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    return $super === VOID ? this.o4t(base, coords, name, flippedWidthHeight) : $super.o4t.call(this, base, coords, name, flippedWidthHeight);
  }
}
class SliceCoordsImpl {
  constructor(base, coords, name, flippedWidthHeight) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    this.q4t_1 = base;
    this.r4t_1 = coords;
    this.s4t_1 = name;
    this.t4t_1 = flippedWidthHeight;
    this.u4t_1 = Companion_getInstance_5().p3l_1;
    this.v4t_1 = !this.t4t_1 ? this.q4t_1.g1().v3s_1 : this.q4t_1.g1().w3s_1;
    this.w4t_1 = !this.t4t_1 ? this.q4t_1.g1().w3s_1 : this.q4t_1.g1().v3s_1;
    this.x4t_1 = numberToInt(Companion_getInstance_2().b3t(this.r4t_1.c4t(), this.r4t_1.d4t(), this.r4t_1.e4t(), this.r4t_1.f4t()) * this.v4t_1);
    this.y4t_1 = numberToInt(Companion_getInstance_2().b3t(this.r4t_1.c4t(), this.r4t_1.d4t(), this.r4t_1.i4t(), this.r4t_1.j4t()) * this.w4t_1);
    this.z4t_1 = this.x4t_1 + this.u4t_1.x3l() | 0;
    this.a4u_1 = this.y4t_1 + this.u4t_1.y3l() | 0;
  }
  r4s() {
    return this.q4t_1;
  }
  t4s() {
    return this.u4t_1;
  }
  f3u() {
    return this.x4t_1;
  }
  g3u() {
    return this.y4t_1;
  }
  u4s() {
    return this.z4t_1;
  }
  v4s() {
    return this.a4u_1;
  }
  c4t() {
    return this.r4t_1.c4t();
  }
  d4t() {
    return this.r4t_1.d4t();
  }
  e4t() {
    return this.r4t_1.e4t();
  }
  f4t() {
    return this.r4t_1.f4t();
  }
  g4t() {
    return this.r4t_1.g4t();
  }
  h4t() {
    return this.r4t_1.h4t();
  }
  i4t() {
    return this.r4t_1.i4t();
  }
  j4t() {
    return this.r4t_1.j4t();
  }
  toString() {
    return 'SliceCoordsImpl(base=' + toString(this.q4t_1) + ', coords=' + toString(this.r4t_1) + ', name=' + this.s4t_1 + ', flippedWidthHeight=' + this.t4t_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.q4t_1);
    result = imul(result, 31) + hashCode(this.r4t_1) | 0;
    result = imul(result, 31) + (this.s4t_1 == null ? 0 : getStringHashCode(this.s4t_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t4t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SliceCoordsImpl))
      return false;
    var tmp0_other_with_cast = other instanceof SliceCoordsImpl ? other : THROW_CCE();
    if (!equals(this.q4t_1, tmp0_other_with_cast.q4t_1))
      return false;
    if (!equals(this.r4t_1, tmp0_other_with_cast.r4t_1))
      return false;
    if (!(this.s4t_1 == tmp0_other_with_cast.s4t_1))
      return false;
    if (!(this.t4t_1 === tmp0_other_with_cast.t4t_1))
      return false;
    return true;
  }
}
class RectCoords {
  constructor(tlX, tlY, trX, trY, brX, brY, blX, blY) {
    this.j4s_1 = tlX;
    this.k4s_1 = tlY;
    this.l4s_1 = trX;
    this.m4s_1 = trY;
    this.n4s_1 = brX;
    this.o4s_1 = brY;
    this.p4s_1 = blX;
    this.q4s_1 = blY;
  }
  c4t() {
    return this.j4s_1;
  }
  d4t() {
    return this.k4s_1;
  }
  e4t() {
    return this.l4s_1;
  }
  f4t() {
    return this.m4s_1;
  }
  g4t() {
    return this.n4s_1;
  }
  h4t() {
    return this.o4s_1;
  }
  i4t() {
    return this.p4s_1;
  }
  j4t() {
    return this.q4s_1;
  }
  toString() {
    return 'RectCoords(tlX=' + this.j4s_1 + ', tlY=' + this.k4s_1 + ', trX=' + this.l4s_1 + ', trY=' + this.m4s_1 + ', brX=' + this.n4s_1 + ', brY=' + this.o4s_1 + ', blX=' + this.p4s_1 + ', blY=' + this.q4s_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.j4s_1);
    result = imul(result, 31) + getNumberHashCode(this.k4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q4s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCoords))
      return false;
    var tmp0_other_with_cast = other instanceof RectCoords ? other : THROW_CCE();
    if (!equals(this.j4s_1, tmp0_other_with_cast.j4s_1))
      return false;
    if (!equals(this.k4s_1, tmp0_other_with_cast.k4s_1))
      return false;
    if (!equals(this.l4s_1, tmp0_other_with_cast.l4s_1))
      return false;
    if (!equals(this.m4s_1, tmp0_other_with_cast.m4s_1))
      return false;
    if (!equals(this.n4s_1, tmp0_other_with_cast.n4s_1))
      return false;
    if (!equals(this.o4s_1, tmp0_other_with_cast.o4s_1))
      return false;
    if (!equals(this.p4s_1, tmp0_other_with_cast.p4s_1))
      return false;
    if (!equals(this.q4s_1, tmp0_other_with_cast.q4s_1))
      return false;
    return true;
  }
}
class Bucket {
  constructor() {
    this.b4u_1 = FastArrayList.u28();
  }
  ai() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.Bucket.clear.<anonymous>' call
    this.b4u_1.h3();
    return this;
  }
}
class Buckets {
  constructor(pool, ySize) {
    this.c4u_1 = pool;
    this.d4u_1 = ySize;
    this.e4u_1 = FastIntMap();
  }
  g1() {
    return get_size(this.e4u_1);
  }
  f4u(y) {
    return y / this.d4u_1 | 0;
  }
  g4u(index) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.e4u_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(index);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.math.geom.vector.Buckets.getForIndex.<anonymous>' call
      var out = this.c4u_1.f42();
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(index, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  h4u(y) {
    // Inline function 'korlibs.datastructure.get' call
    var this_0 = this.e4u_1;
    var key = this.f4u(y);
    // Inline function 'kotlin.js.asDynamic' call
    return this_0.get(key);
  }
  h3() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.e4u_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.math.geom.vector.Buckets.clear.<anonymous>' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this_0.get(it);
      var value = ensureNotNull(tmp$ret$2);
      this.c4u_1.g42(value.ai());
    }
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.e4u_1.clear();
  }
  i4u(edge, threshold) {
    var min = this.f4u(edge.t4u());
    var max = this.f4u(edge.u4u());
    if ((max - min | 0) < threshold) {
      var inductionVariable = min;
      if (inductionVariable <= max)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.g4u(n).b4u_1.h(edge);
        }
         while (!(n === max));
      return true;
    }
    return false;
  }
  v4u(edge, threshold, $super) {
    threshold = threshold === VOID ? 2147483647 : threshold;
    return $super === VOID ? this.i4u(edge, threshold) : $super.i4u.call(this, edge, threshold);
  }
}
class AllBuckets {
  constructor() {
    var tmp = this;
    var tmp_0 = PolygonScanline$AllBuckets$pool$lambda;
    tmp.w4u_1 = Pool.c42(tmp_0, VOID, PolygonScanline$AllBuckets$pool$lambda_0);
    this.x4u_1 = new Buckets(this.w4u_1, 80);
    this.y4u_1 = new Buckets(this.w4u_1, 320);
    this.z4u_1 = new Buckets(this.w4u_1, 1280);
  }
  a4v(edge) {
    if (this.x4u_1.i4u(edge, 4))
      return Unit_instance;
    if (this.y4u_1.i4u(edge, 4))
      return Unit_instance;
    this.z4u_1.v4u(edge);
  }
  h3() {
    this.x4u_1.h3();
    this.y4u_1.h3();
    this.z4u_1.h3();
  }
}
class XWithWind {
  constructor() {
    this.v4v_1 = IntArrayList.l3w(1024);
    this.w4v_1 = IntArrayList.l3w(1024);
  }
  g1() {
    return this.v4v_1.g1();
  }
  x4v(x, wind) {
    this.v4v_1.r3w(x);
    this.w4v_1.r3w(wind);
  }
  h3() {
    this.v4v_1.h3();
    this.w4v_1.h3();
  }
  toString() {
    return 'XWithWind(' + this.v4v_1.toString() + ', ' + this.w4v_1.toString() + ')';
  }
}
class IntArrayListSort extends SortOps {
  constructor() {
    IntArrayListSort_instance = null;
    super();
    IntArrayListSort_instance = this;
  }
  y4v(subject, l, r) {
    return compareTo(subject.v4v_1.x27(l), subject.v4v_1.x27(r));
  }
  u3x(subject, l, r) {
    return this.y4v(subject instanceof XWithWind ? subject : THROW_CCE(), l, r);
  }
  z4v(subject, indexL, indexR) {
    subject.v4v_1.a3x(indexL, indexR);
    subject.w4v_1.a3x(indexL, indexR);
  }
  w3x(subject, indexL, indexR) {
    return this.z4v(subject instanceof XWithWind ? subject : THROW_CCE(), indexL, indexR);
  }
}
class RastScale {
  l4w() {
    return 20;
  }
  m4w() {
    return 0;
  }
  t4v(_this__u8e3s4) {
    return numberToInt(_this__u8e3s4 * this.l4w()) + this.m4w() | 0;
  }
}
class PolygonScanline extends RastScale {
  constructor() {
    super();
    this.b4v_1 = -1;
    this.c4v_1 = Winding_NON_ZERO_getInstance();
    this.d4v_1 = Companion_getInstance_6().p3j();
    var tmp = this;
    tmp.e4v_1 = Pool.d42(VOID, PolygonScanline$edgesPool$lambda);
    this.f4v_1 = FastArrayList.u28();
    this.g4v_1 = FastArrayList.u28();
    this.h4v_1 = FastArrayList.u28();
    this.i4v_1 = new AllBuckets();
    this.j4v_1 = true;
    this.k4v_1 = new PointArrayList();
    this.l4v_1 = 0.0;
    this.m4v_1 = 0.0;
    this.n4v_1 = 0.0;
    this.o4v_1 = 0.0;
    this.p4v_1 = false;
    this.q4v_1 = new XWithWind();
    this.r4v_1 = 0;
    this.s4v_1 = new IntSegmentSet();
  }
  y4l() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(this.d4v_1);
  }
  u1w() {
    this.j4v_1 = true;
    this.d4v_1 = Companion_getInstance_6().k3j_1;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.f4v_1.s28_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.e4v_1.g42(it);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.g4v_1.s28_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_0 = array_0[_unary__edvuaz_0];
      this.e4v_1.g42(it_0);
    }
    this.f4v_1.h3();
    this.g4v_1.h3();
    this.h4v_1.h3();
    this.k4v_1.ai();
    this.i4v_1.h3();
    this.l4v_1 = 0.0;
    this.m4v_1 = 0.0;
    this.n4v_1 = 0.0;
    this.o4v_1 = 0.0;
    this.p4v_1 = false;
  }
  a4w() {
    return this.f4v_1.g1();
  }
  d1t() {
    return this.a4w() > 0;
  }
  b4w(x, y) {
    this.n4v_1 = x;
    this.o4v_1 = y;
    this.l4v_1 = x;
    this.m4v_1 = y;
    this.p4v_1 = true;
  }
  c4w(x, y) {
    if (this.p4v_1) {
      addPoint(this, this.n4v_1, this.o4v_1);
    }
    addEdge(this, this.n4v_1, this.o4v_1, x, y);
    addPoint(this, x, y);
    this.n4v_1 = x;
    this.o4v_1 = y;
    this.p4v_1 = false;
  }
  k4p(p) {
    return this.b4w(p.r3i_1, p.s3i_1);
  }
  x4p(p) {
    return this.c4w(p.r3i_1, p.s3i_1);
  }
  d4w(path) {
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.i3l();
    var l = Vector2D.i3l();
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.p6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.n4p_1;
    var n_0 = 0;
    while (n_0 < this_0.g1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.x27(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.o4p_1.h1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.y3k(tmp, path.o4p_1.h1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.e4w(it, true);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.o4p_1.h1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.y3k(tmp_0, path.o4p_1.h1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.e4w(it_0, false);
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.o4p_1.h1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.y3k(tmp_1, path.o4p_1.h1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.o4p_1.h1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.y3k(tmp_2, path.o4p_1.h1(_unary__edvuaz_7));
          var sum = Companion_getInstance_2().d3t(l, c) + Companion_getInstance_2().d3t(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.i3l()};
          var prevPos = {_v: Vector2D.i3l()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance().p27_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_8().h4n(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_8().h4n(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.e4w(it_1, false);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.o4p_1.h1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.y3k(tmp_3, path.o4p_1.h1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.o4p_1.h1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.y3k(tmp_4, path.o4p_1.h1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.o4p_1.h1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.y3k(tmp_5, path.o4p_1.h1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_2().d3t(l, c0) + Companion_getInstance_2().d3t(c0, c1) + Companion_getInstance_2().d3t(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.i3l()};
          var prevPos_0 = {_v: Vector2D.i3l()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance().p27_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_8().g4n(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_8().g4n(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.e4w(it_2, false);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          var p = i;
          this.e4w(p, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          if (true) {
            this.p6();
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.p6();
    }
  }
  e4w(p, move) {
    var tmp;
    if (move) {
      this.k4p(p);
      tmp = Unit_instance;
    } else {
      this.x4p(p);
      tmp = Unit_instance;
    }
    return tmp;
  }
  f4w(x, y, move) {
    var tmp;
    if (move) {
      this.b4w(x, y);
      tmp = Unit_instance;
    } else {
      this.c4w(x, y);
      tmp = Unit_instance;
    }
    return tmp;
  }
  p6() {
    this.c4w(this.l4v_1, this.m4v_1);
  }
  g4w(y, winding, out) {
    this.r4v_1 = 0;
    this.q4v_1.h3();
    out.ai();
    var tmp = this;
    var tmp_0 = this.r4v_1;
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY' call
    var edgesChecked = 0;
    // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY' call
    var this_0 = this.i4v_1;
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_1 = this_0.x4u_1;
    if (this_1.g1() > 0) {
      var tmp47_safe_receiver = this_1.h4u(y);
      if (tmp47_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = tmp47_safe_receiver.b4u_1.s28_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge = array[_unary__edvuaz];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge.i4w(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge.q4u_1) {
              this.q4v_1.x4v(edge.h4w(y), edge.n4u_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_2 = this_0.y4u_1;
    if (this_2.g1() > 0) {
      var tmp47_safe_receiver_0 = this_2.h4u(y);
      if (tmp47_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp47_safe_receiver_0.b4u_1.s28_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_0 = array_0[_unary__edvuaz_0];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_0.i4w(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_0.q4u_1) {
              this.q4v_1.x4v(edge_0.h4w(y), edge_0.n4u_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_3 = this_0.z4u_1;
    if (this_3.g1() > 0) {
      var tmp47_safe_receiver_1 = this_3.h4u(y);
      if (tmp47_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_1 = tmp47_safe_receiver_1.b4u_1.s28_1;
        var n_1 = 0;
        while (n_1 < array_1.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_1 = array_1[_unary__edvuaz_1];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_1.i4w(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_1.q4u_1) {
              this.q4v_1.x4v(edge_1.h4w(y), edge_1.n4u_1);
            }
          }
        }
      }
    }
    tmp.r4v_1 = tmp_0 + edgesChecked | 0;
    genericSort(this.q4v_1, 0, this.q4v_1.g1() - 1 | 0, IntArrayListSort_getInstance());
    var tempX = this.q4v_1.v4v_1;
    var tempW = this.q4v_1.w4v_1;
    if (this.q4v_1.g1() >= 2) {
      switch (winding.p3_1) {
        case 0:
          var progression = step(until(0, tempX.g1() - 1 | 0), 2);
          var inductionVariable = progression.f2_1;
          var last = progression.g2_1;
          var step_0 = progression.h2_1;
          if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + step_0 | 0;
              var a = tempX.x27(i);
              var b = tempX.x27(i + 1 | 0);
              out.e45(a, b);
            }
             while (!(i === last));
          break;
        case 1:
          var count = 0;
          var startX = 0;
          var endX = 0;
          var pending = false;
          var inductionVariable_0 = 0;
          var last_0 = tempX.g1() - 1 | 0;
          if (inductionVariable_0 < last_0)
            do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var a_0 = tempX.x27(i_0);
              count = count + tempW.x27(i_0) | 0;
              var b_0 = tempX.x27(i_0 + 1 | 0);
              if (!(count === 0)) {
                if (pending && !(a_0 === endX)) {
                  out.e45(startX, endX);
                  startX = a_0;
                  endX = b_0;
                } else {
                  if (!pending) {
                    startX = a_0;
                  }
                  endX = b_0;
                }
                pending = true;
              }
            }
             while (inductionVariable_0 < last_0);
          if (pending) {
            out.e45(startX, endX);
          }

          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    return out;
  }
  j4w(x, y, winding) {
    return this.k4w(this.t4v(x), this.t4v(y), winding);
  }
  k4w(x, y, winding) {
    var ss = this.s4v_1;
    this.g4w(y, winding, ss.ai());
    return ss.hq(x);
  }
}
class Companion_6 {
  constructor() {
    this.n4w_1 = 20;
    this.o4w_1 = 0;
    this.p4w_1 = 80;
    this.q4w_1 = 320;
    this.r4w_1 = 1280;
  }
}
class Companion_7 {
  s4w(a, b) {
    // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY' call
    var Ax = a.j4u_1;
    var Ay = a.k4u_1;
    var Bx = a.l4u_1;
    var By = a.m4u_1;
    var Cx = b.j4u_1;
    var Cy = b.k4u_1;
    var Dx = b.l4u_1;
    var Dy = b.m4u_1;
    var tmp52_safe_receiver = this.t4w(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
    var tmp;
    if (tmp52_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY.<anonymous>' call
      tmp = Vector2I.v3r(numberToInt(floorCeil(tmp52_safe_receiver.r3i_1)), numberToInt(floorCeil(tmp52_safe_receiver.s3i_1)));
    }
    var tmp51_safe_receiver = tmp;
    var tmp_0;
    if (tmp51_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion.getIntersectXY.<anonymous>' call
      tmp_0 = Vector2D.k3l(tmp51_safe_receiver.s3r_1, tmp51_safe_receiver.t3r_1);
    }
    return tmp_0;
  }
  u4w(a, b) {
    return Angle__minus_impl_xeau7k(b.v4w(), a.v4w());
  }
  t4w(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    return Companion_instance_15.t4w(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
  }
}
class MEdge {
  constructor() {
    this.j4u_1 = 0;
    this.k4u_1 = 0;
    this.l4u_1 = 0;
    this.m4u_1 = 0;
    this.n4u_1 = 0;
    this.o4u_1 = 0;
    this.p4u_1 = 0;
    this.q4u_1 = false;
    this.r4u_1 = false;
    this.s4u_1 = 0;
  }
  w3k(n) {
    return n === 0 ? this.j4u_1 : this.l4u_1;
  }
  x3k(n) {
    return n === 0 ? this.k4u_1 : this.m4u_1;
  }
  w4w(other) {
    return this.u4v(other.j4u_1, other.k4u_1, other.l4u_1, other.m4u_1, other.n4u_1);
  }
  u4v(ax, ay, bx, by, wind) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.MEdge.setTo.<anonymous>' call
    this.j4u_1 = ax;
    this.k4u_1 = ay;
    this.l4u_1 = bx;
    this.m4u_1 = by;
    this.p4u_1 = bx - ax | 0;
    this.o4u_1 = by - ay | 0;
    this.q4u_1 = ay === by;
    this.r4u_1 = ax === bx;
    this.n4u_1 = wind;
    this.s4u_1 = this.r4u_1 ? 0 : ay - (imul(ax, this.o4u_1) / this.p4u_1 | 0) | 0;
    return this;
  }
  t4u() {
    // Inline function 'kotlin.math.min' call
    var a = this.k4u_1;
    var b = this.m4u_1;
    return Math.min(a, b);
  }
  u4u() {
    // Inline function 'kotlin.math.max' call
    var a = this.k4u_1;
    var b = this.m4u_1;
    return Math.max(a, b);
  }
  i4w(y) {
    return y >= this.k4u_1 && y < this.m4u_1;
  }
  h4w(y) {
    return this.r4u_1 || this.o4u_1 === 0 ? this.j4u_1 : imul(y - this.s4u_1 | 0, this.p4u_1) / this.o4u_1 | 0;
  }
  v4w() {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_3();
    var x0 = this.j4u_1;
    var y0 = this.k4u_1;
    var x1 = this.l4u_1;
    var y1 = this.m4u_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var up = Companion_getInstance_2().x3i_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  toString() {
    return 'Edge([' + this.j4u_1 + ',' + this.k4u_1 + ']-[' + this.l4u_1 + ',' + this.m4u_1 + '])';
  }
}
class EdgePoint extends Enum {
  constructor(name, ordinal, n) {
    super(name, ordinal);
    this.q4x_1 = n;
  }
}
class StrokeToFill {
  constructor() {
    this.x4w_1 = 1;
    this.z4w_1 = LineCap_BUTT_getInstance();
    this.a4x_1 = LineCap_BUTT_getInstance();
    this.b4x_1 = LineJoin_BEVEL_getInstance();
    this.c4x_1 = 4.0;
    this.d4x_1 = new PointIntArrayList(1024);
    this.e4x_1 = IntArrayList.l3w(1024);
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(2), null);
    while (tmp_0 < 2) {
      tmp_1[tmp_0] = new PointIntArrayList(1024);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.f4x_1 = tmp_1;
    this.g4x_1 = this.f4x_1[0];
    this.h4x_1 = this.f4x_1[1];
    this.i4x_1 = new MEdge();
    this.j4x_1 = new MEdge();
    this.k4x_1 = new MEdge();
    this.l4x_1 = new MEdge();
    this.m4x_1 = new MEdge();
    this.n4x_1 = new MEdge();
  }
  r4x(_this__u8e3s4, edge, width, angle) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.setEdgeDisplaced.<anonymous>' call
    var ldx = width * _Angle___get_cosine__impl__vprvmu(angle);
    var ldy = width * _Angle___get_sine__impl__15nmyi(angle);
    _this__u8e3s4.u4v(numberToInt(edge.j4u_1 + ldx), numberToInt(edge.k4u_1 + ldy), numberToInt(edge.l4u_1 + ldx), numberToInt(edge.m4u_1 + ldy), edge.n4u_1);
    return _this__u8e3s4;
  }
  s4x(_this__u8e3s4, e) {
    return _this__u8e3s4.e45(e.j4u_1, e.k4u_1);
  }
  t4x(_this__u8e3s4, e) {
    return _this__u8e3s4.e45(e.l4u_1, e.m4u_1);
  }
  u4x(_this__u8e3s4, e) {
    _this__u8e3s4.e45(numberToInt(e.r3i_1), numberToInt(e.s3i_1));
  }
  v4x(out, mainPrev, mainCurr, prev, curr, join, miterLimit, scale, forcedMiter) {
    var rjoin = forcedMiter ? LineJoin_MITER_getInstance() : join;
    switch (rjoin.p3_1) {
      case 2:
        var intersection2 = Vector2D.k3l(mainPrev.l4u_1, mainPrev.m4u_1);
        var intersection = Companion_instance_7.s4w(prev, curr);
        if (!(intersection == null)) {
          var dist = Companion_getInstance_2().d3t(intersection, intersection2);
          if (forcedMiter || dist <= miterLimit) {
            out.f45(toInt(intersection));
          } else {
            this.t4x(out, prev);
            this.s4x(out, curr);
          }
        }

        break;
      case 0:
        this.t4x(out, prev);
        this.s4x(out, curr);
        break;
      case 1:
        var i = Companion_instance_7.s4w(prev, curr);
        if (!(i == null)) {
          var count = clamp(numberToInt(Companion_getInstance_2().c3t(prev.l4u_1, prev.m4u_1, curr.j4u_1, curr.k4u_1) * scale), 4, 64);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.u4x(out, Companion_getInstance_8().h4n(Vector2D.y3k(prev.l4u_1, prev.m4u_1), Vector2D.y3k(i.r3i_1, i.s3i_1), Vector2D.y3k(curr.j4u_1, curr.k4u_1), _Ratio___init__impl__9mwvn2(n / count)));
            }
             while (!(n === count));
        } else {
          this.t4x(out, prev);
          this.s4x(out, curr);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  w4x(l, r, left, right, epoint, cap, scale) {
    var angle = epoint.equals(EdgePoint_A_getInstance()) ? Angle__unaryMinus_impl_7901fr(left.v4w()) : Angle__unaryPlus_impl_eyi5pl(left.v4w());
    var lx = left.w3k(epoint.q4x_1);
    var ly = left.x3k(epoint.q4x_1);
    var rx = right.w3k(epoint.q4x_1);
    var ry = right.x3k(epoint.q4x_1);
    switch (cap.p3_1) {
      case 0:
        l.e45(lx, ly);
        r.e45(rx, ry);
        break;
      case 2:
      case 1:
        var ax = numberToInt(_Angle___get_cosine__impl__vprvmu(angle) * this.x4w_1 / 2);
        var ay = numberToInt(_Angle___get_sine__impl__15nmyi(angle) * this.x4w_1 / 2);
        var lx2 = lx + ax | 0;
        var ly2 = ly + ay | 0;
        var rx2 = rx + ax | 0;
        var ry2 = ry + ay | 0;
        if (cap.equals(LineCap_SQUARE_getInstance())) {
          l.e45(lx2, ly2);
          r.e45(rx2, ry2);
        } else {
          var count = clamp(numberToInt(Companion_getInstance_22().c3t(lx, ly, rx, ry) * scale), 4, 64);
          l.e45(lx, ly);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var m = epoint.equals(EdgePoint_A_getInstance()) ? n : count - n | 0;
              var ratio = _Ratio___init__impl__9mwvn2(m / count);
              this.u4x(r, Companion_getInstance_8().g4n(Vector2D.y3k(lx, ly), Vector2D.y3k(lx2, ly2), Vector2D.y3k(rx2, ry2), Vector2D.y3k(rx, ry), ratio));
            }
             while (!(n === count));
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  e4y(scale, closed) {
    if (this.d4x_1.j1())
      return Unit_instance;
    var weightD2 = this.x4w_1 / 2 | 0;
    this.g4x_1.h3();
    this.h4x_1.h3();
    var sp = this.d4x_1;
    var nstrokePoints = sp.g1();
    var inductionVariable = 0;
    if (inductionVariable < nstrokePoints)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var isFirst = n === 0;
        var isLast = n === (nstrokePoints - 1 | 0);
        var isMiddle = !isFirst && (!isLast || closed);
        var n1 = isLast ? closed ? 1 : n : n + 1 | 0;
        this.i4x_1.w4w(this.l4x_1);
        this.j4x_1.w4w(this.m4x_1);
        this.k4x_1.w4w(this.n4x_1);
        var doJoin = !(this.e4x_1.x27(n) === 0);
        this.l4x_1.u4v(sp.w3k(n), sp.x3k(n), sp.w3k(n1), sp.x3k(n1), 1);
        this.r4x(this.m4x_1, this.l4x_1, weightD2, Angle__minus_impl_xeau7k(this.l4x_1.v4w(), get_degrees(90)));
        this.r4x(this.n4x_1, this.l4x_1, weightD2, Angle__plus_impl_26v37k(this.l4x_1.v4w(), get_degrees(90)));
        if (isFirst) {
          this.w4x(this.g4x_1, this.h4x_1, this.m4x_1, this.n4x_1, EdgePoint_A_getInstance(), closed ? LineCap_BUTT_getInstance() : this.z4w_1, scale);
        } else if (isMiddle) {
          var angle = Companion_instance_7.u4w(this.i4x_1, this.l4x_1);
          var leftAngle = Angle__compareTo_impl_a0hfds(angle, get_degrees(0)) > 0;
          if (doJoin) {
            this.v4x(this.g4x_1, this.i4x_1, this.l4x_1, this.j4x_1, this.m4x_1, this.b4x_1, this.c4x_1, scale, leftAngle);
            this.v4x(this.h4x_1, this.i4x_1, this.l4x_1, this.k4x_1, this.n4x_1, this.b4x_1, this.c4x_1, scale, !leftAngle);
          } else {
            this.s4x(this.g4x_1, this.m4x_1);
            this.s4x(this.h4x_1, this.n4x_1);
          }
        } else if (isLast) {
          if (closed) {
            this.w4x(this.g4x_1, this.h4x_1, this.m4x_1, this.n4x_1, EdgePoint_B_getInstance(), LineCap_BUTT_getInstance(), scale);
          } else {
            this.w4x(this.g4x_1, this.h4x_1, this.j4x_1, this.k4x_1, EdgePoint_B_getInstance(), this.a4x_1, scale);
          }
        }
      }
       while (inductionVariable < nstrokePoints);
    var inductionVariable_0 = 0;
    var last = this.g4x_1.g1();
    if (inductionVariable_0 < last)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var x = this.g4x_1.w3k(n_0);
        var y = this.g4x_1.x3k(n_0);
        if (n_0 === 0) {
          _get_outFill__zcv64g(this).k4p(Vector2D.y3k(x * scale, y * scale));
        } else {
          _get_outFill__zcv64g(this).x4p(Vector2D.y3k(x * scale, y * scale));
        }
      }
       while (inductionVariable_0 < last);
    var inductionVariable_1 = 0;
    var last_0 = this.h4x_1.g1();
    if (inductionVariable_1 < last_0)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var m = (this.h4x_1.g1() - n_1 | 0) - 1 | 0;
        _get_outFill__zcv64g(this).x4p(Vector2D.y3k(this.h4x_1.w3k(m) * scale, this.h4x_1.x3k(m) * scale));
      }
       while (inductionVariable_1 < last_0);
    _get_outFill__zcv64g(this).p6();
    _get_outFill__zcv64g(this).p4p_1 = Winding_NON_ZERO_getInstance();
    this.d4x_1.h3();
    this.e4x_1.h3();
  }
  f4y(outFill, weight, startCap, endCap, joins, miterLimit) {
    this.y4w_1 = outFill;
    this.x4w_1 = weight;
    this.z4w_1 = startCap;
    this.a4x_1 = endCap;
    this.b4x_1 = joins;
    this.c4x_1 = miterLimit * weight;
  }
  g4y(stroke, lineWidth, joins, startCap, endCap, miterLimit, outFill) {
    var scale = 20;
    var iscale = 1.0 / 20;
    this.f4y(outFill, numberToInt(lineWidth * scale), startCap, endCap, joins, miterLimit);
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.i3l();
    var l = Vector2D.i3l();
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.e4y(iscale, true);
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = stroke.n4p_1;
    var n_0 = 0;
    while (n_0 < this_0.g1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.x27(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = stroke.o4p_1.h1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.y3k(tmp, stroke.o4p_1.h1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.e4y(iscale, false);
          }

          this.d4x_1.e45(numberToInt(it.r3i_1 * scale), numberToInt(it.s3i_1 * scale));
          this.e4x_1.r3w(0);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = stroke.o4p_1.h1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.y3k(tmp_0, stroke.o4p_1.h1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (false) {
            this.e4y(iscale, false);
          }

          this.d4x_1.e45(numberToInt(it_0.r3i_1 * scale), numberToInt(it_0.s3i_1 * scale));
          this.e4x_1.r3w(0);
          l = it_0;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.e4x_1.w3w(this.e4x_1.g1() - 1 | 0, 1);
          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = stroke.o4p_1.h1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.y3k(tmp_1, stroke.o4p_1.h1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = stroke.o4p_1.h1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.y3k(tmp_2, stroke.o4p_1.h1(_unary__edvuaz_7));
          var sum = Companion_getInstance_2().d3t(l, c) + Companion_getInstance_2().d3t(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.i3l()};
          var prevPos = {_v: Vector2D.i3l()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance().p27_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_8().h4n(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_8().h4n(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.e4y(iscale, false);
              }
              this.d4x_1.e45(numberToInt(it_1.r3i_1 * scale), numberToInt(it_1.s3i_1 * scale));
              this.e4x_1.r3w(0);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.e4x_1.w3w(this.e4x_1.g1() - 1 | 0, 1);
          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = stroke.o4p_1.h1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.y3k(tmp_3, stroke.o4p_1.h1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = stroke.o4p_1.h1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.y3k(tmp_4, stroke.o4p_1.h1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = stroke.o4p_1.h1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.y3k(tmp_5, stroke.o4p_1.h1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_2().d3t(l, c0) + Companion_getInstance_2().d3t(c0, c1) + Companion_getInstance_2().d3t(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.i3l()};
          var prevPos_0 = {_v: Vector2D.i3l()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance().p27_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_8().g4n(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_8().g4n(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.e4y(iscale, false);
              }
              this.d4x_1.e45(numberToInt(it_2.r3i_1 * scale), numberToInt(it_2.s3i_1 * scale));
              this.e4x_1.r3w(0);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.e4x_1.w3w(this.e4x_1.g1() - 1 | 0, 1);
          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          var p = i;
          if (false) {
            this.e4y(iscale, false);
          }

          this.d4x_1.e45(numberToInt(p.r3i_1 * scale), numberToInt(p.s3i_1 * scale));
          this.e4x_1.r3w(0);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.e4x_1.w3w(this.e4x_1.g1() - 1 | 0, 1);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.e4y(iscale, true);
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.e4y(iscale, true);
    }
    this.e4y(iscale, false);
  }
}
class VectorBuilder {}
function quadTo(c, a) {
  // Inline function 'korlibs.math.geom.bezier.Companion.quadToCubic' call
  var this_0 = Companion_getInstance_8();
  var x0 = this.v4y().r3i_1;
  var y0 = this.v4y().s3i_1;
  var xc = c.r3i_1;
  var yc = c.s3i_1;
  var x1 = a.r3i_1;
  var y1 = a.s3i_1;
  var cx1 = this_0.i4n(x0, xc);
  var cy1 = this_0.i4n(y0, yc);
  var cx2 = this_0.j4n(xc, x1);
  var cy2 = this_0.j4n(yc, y1);
  this.l4p(Vector2D.y3k(cx1, cy1), Vector2D.y3k(cx2, cy2), Vector2D.y3k(x1, y1));
}
function line(p0, p1) {
  this.k4p(p0);
  this.x4p(p1);
}
function isEmpty() {
  return this.u4y() === 0;
}
function isNotEmpty() {
  return !(this.u4y() === 0);
}
function rect(rect) {
  return this.z4y(rect.b3j_1, rect.c3j_1, rect.d3j_1, rect.e3j_1);
}
function rect_0(pos, size) {
  this.z4y(pos.r3i_1, pos.s3i_1, size.u3j_1, size.v3j_1);
}
function rect_1(x, y, width, height) {
  this.k4p(Vector2D.y3k(x, y));
  this.x4p(Vector2D.y3k(x + width, y));
  this.x4p(Vector2D.y3k(x + width, y + height));
  this.x4p(Vector2D.y3k(x, y + height));
  this.p6();
}
function rect_2(x, y, width, height) {
  return this.z4y(x, y, width, height);
}
function arc(center, r, start, end, counterclockwise) {
  return Arc_instance.j4p(this, center, numberToDouble(r), start, end, counterclockwise);
}
function arc$default(center, r, start, end, counterclockwise, $super) {
  counterclockwise = counterclockwise === VOID ? false : counterclockwise;
  var tmp;
  if ($super === VOID) {
    this.b4z(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  } else {
    arc(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  }
  return tmp;
}
function circle(center, radius) {
  return this.c4z(center, radius, Companion_getInstance_3().i3i_1, Companion_getInstance_3().m3i_1);
}
function rMoveTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.v4y();
  var tmp$ret$0 = Vector2D.y3k(this_0.r3i_1 + delta.r3i_1, this_0.s3i_1 + delta.s3i_1);
  return this.k4p(tmp$ret$0);
}
function rLineTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.v4y();
  var tmp$ret$0 = Vector2D.y3k(this_0.r3i_1 + delta.r3i_1, this_0.s3i_1 + delta.s3i_1);
  return this.x4p(tmp$ret$0);
}
function transformed(m) {
  var im = m.h3n();
  var parent = this;
  return new VectorBuilder$transformed$1(parent, im, m);
}
function transformed_0(m, block) {
  return block(this.m3r(m));
}
class VectorBuilder$transformed$1 {
  constructor($parent, $im, $m) {
    this.r4y_1 = $parent;
    this.s4y_1 = $im;
    this.t4y_1 = $m;
    this.q4y_1 = $parent.u4y();
  }
  v4y() {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.s4y_1;
      var p = this.r4y_1.v4y();
      if (this_0.g3j()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.y3k(this_0.r3m(p.r3i_1, p.s3i_1), this_0.u3m(p.r3i_1, p.s3i_1));
    }
    return tmp$ret$0;
  }
  u4y() {
    return this.q4y_1;
  }
  p6() {
    return this.r4y_1.p6();
  }
  x4p(p) {
    return this.r4y_1.x4p(t(this, p));
  }
  k4p(p) {
    return this.r4y_1.x4p(t(this, p));
  }
  y4p(c, a) {
    return this.r4y_1.y4p(t(this, c), t(this, a));
  }
  l4p(c1, c2, a) {
    return this.r4y_1.l4p(t(this, c1), t(this, c2), t(this, a));
  }
}
class Companion_8 {}
class Visitor {}
function close() {
  return Unit_instance;
}
function moveTo(p) {
  return Unit_instance;
}
function lineTo(p) {
  return Unit_instance;
}
function quadTo_0(c, a) {
  return Unit_instance;
}
function cubicTo(c1, c2, a) {
  return Unit_instance;
}
class VectorPath extends AbstractShape2D {
  constructor(commands, data, winding, optimize) {
    commands = commands === VOID ? IntArrayList.l3w() : commands;
    data = data === VOID ? DoubleArrayList.f3x() : data;
    winding = winding === VOID ? Companion_instance_9.h4z() : winding;
    optimize = optimize === VOID ? true : optimize;
    super();
    this.m4p_1 = new Mixin();
    this.n4p_1 = commands;
    this.o4p_1 = data;
    this.p4p_1 = winding;
    this.q4p_1 = optimize;
    this.r4p_1 = false;
    this.s4p_1 = 0;
    this.t4p_1 = Vector2D.i3l();
    this.u4p_1 = Vector2D.i3l();
    this.v4p_1 = null;
    this.w4p_1 = null;
  }
  c28(_set____db54di) {
    this.m4p_1.c28(_set____db54di);
  }
  d28() {
    return this.m4p_1.d28();
  }
  z27() {
    return new VectorPath(IntArrayList.n3w(this.n4p_1), DoubleArrayList.g3x(this.o4p_1), this.p4p_1);
  }
  equals(other) {
    if (this === other)
      return true;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof VectorPath) {
      tmp_1 = this.n4p_1.equals(other.n4p_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o4p_1.equals(other.o4p_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.p4p_1.equals(other.p4p_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return (this.n4p_1.hashCode() + imul(this.o4p_1.hashCode(), 13) | 0) + imul(this.p4p_1.p3_1, 111) | 0;
  }
  i4z(visitor) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.n4p_1;
    var n_0 = 0;
    while (n_0 < this_0.g1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.x27(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.o4p_1.h1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var p0 = Vector2D.y3k(tmp, this.o4p_1.h1(_unary__edvuaz_1));
          visitor.k4p(p0);
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.o4p_1.h1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var p0_0 = Vector2D.y3k(tmp_0, this.o4p_1.h1(_unary__edvuaz_3));
          visitor.x4p(p0_0);
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.o4p_1.h1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var p0_1 = Vector2D.y3k(tmp_1, this.o4p_1.h1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.o4p_1.h1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p1 = Vector2D.y3k(tmp_2, this.o4p_1.h1(_unary__edvuaz_7));
          visitor.y4p(p0_1, p1);
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.o4p_1.h1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var p0_2 = Vector2D.y3k(tmp_3, this.o4p_1.h1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.o4p_1.h1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var p1_0 = Vector2D.y3k(tmp_4, this.o4p_1.h1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.o4p_1.h1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p2 = Vector2D.y3k(tmp_5, this.o4p_1.h1(_unary__edvuaz_13));
          visitor.l4p(p0_2, p1_0, p2);
          break;
        case 4:
          visitor.p6();
          break;
      }
    }
  }
  h3() {
    this.n4p_1.h3();
    this.o4p_1.h3();
    this.t4p_1 = Vector2D.i3l();
    this.s4p_1 = 0;
    this.j4z().b4v_1 = this.s4p_1 - 1 | 0;
  }
  v4y() {
    return this.t4p_1;
  }
  k4p(p) {
    if (this.n4p_1.d1t() && this.n4p_1.y3w() === 0) {
      if (this.t4p_1.equals(p))
        return Unit_instance;
    }
    this.n4p_1.r3w(0);
    this.o4p_1.i3x(p.r3i_1, p.s3i_1);
    this.t4p_1 = p;
    this.u4p_1 = p;
    this.s4p_1 = this.s4p_1 + 1 | 0;
  }
  x4p(p) {
    if (ensureMoveTo(this, p) && this.q4p_1)
      return Unit_instance;
    if (p.equals(this.t4p_1) && this.q4p_1)
      return Unit_instance;
    this.n4p_1.r3w(1);
    this.o4p_1.i3x(p.r3i_1, p.s3i_1);
    this.t4p_1 = p;
    this.s4p_1 = this.s4p_1 + 1 | 0;
  }
  y4p(c, a) {
    ensureMoveTo(this, c);
    this.n4p_1.r3w(2);
    this.o4p_1.j3x(c.r3i_1, c.s3i_1, a.r3i_1, a.s3i_1);
    this.t4p_1 = a;
    this.s4p_1 = this.s4p_1 + 1 | 0;
  }
  l4p(c1, c2, a) {
    ensureMoveTo(this, c1);
    this.n4p_1.r3w(3);
    this.o4p_1.k3x(c1.r3i_1, c1.s3i_1, c2.r3i_1, c2.s3i_1, a.r3i_1, a.s3i_1);
    this.t4p_1 = a;
    this.s4p_1 = this.s4p_1 + 1 | 0;
  }
  p6() {
    this.n4p_1.r3w(4);
    this.t4p_1 = this.u4p_1;
    this.s4p_1 = this.s4p_1 + 1 | 0;
  }
  u4y() {
    return this.o4p_1.g1() / 2 | 0;
  }
  y4l() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(plus(Companion_getInstance_6().p3j(), this));
  }
  k4z(p) {
    return this.j4w(p.r3i_1, p.s3i_1, this.p4p_1);
  }
  j4z() {
    if (this.w4p_1 == null)
      this.w4p_1 = new PolygonScanline();
    var scanline = ensureNotNull(this.w4p_1);
    if (!(scanline.b4v_1 === this.s4p_1)) {
      scanline.u1w();
      scanline.d4w(this);
      scanline.b4v_1 = this.s4p_1;
    }
    return ensureNotNull(this.w4p_1);
  }
  j4w(x, y, winding) {
    return this.j4z().j4w(x, y, winding);
  }
  l4z(path, transform) {
    this.n4p_1.t3w(path.n4p_1);
    if (transform.o3m()) {
      this.o4p_1.m3x(path.o4p_1);
      this.t4p_1 = path.t4p_1;
    } else {
      var progression = step(until(0, path.o4p_1.g1()), 2);
      var inductionVariable = progression.f2_1;
      var last = progression.g2_1;
      var step_0 = progression.h2_1;
      if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var tmp$ret$0;
          $l$block: {
            // Inline function 'korlibs.math.geom.Matrix.transform' call
            var p = Vector2D.y3k(path.o4p_1.h1(n + 0 | 0), path.o4p_1.h1(n + 1 | 0));
            if (transform.g3j()) {
              tmp$ret$0 = p;
              break $l$block;
            }
            tmp$ret$0 = Vector2D.y3k(transform.r3m(p.r3i_1, p.s3i_1), transform.u3m(p.r3i_1, p.s3i_1));
          }
          var p_0 = tmp$ret$0;
          this.o4p_1.i3x(p_0.r3i_1, p_0.s3i_1);
        }
         while (!(n === last));
      var tmp = this;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = path.t4p_1;
        if (transform.g3j()) {
          tmp$ret$1 = p_1;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.y3k(transform.r3m(p_1.r3i_1, p_1.s3i_1), transform.u3m(p_1.r3i_1, p_1.s3i_1));
      }
      tmp.t4p_1 = tmp$ret$1;
    }
    this.s4p_1 = this.s4p_1 + 1 | 0;
  }
  m4z(path, transform, $super) {
    transform = transform === VOID ? Companion_getInstance_4().z3l_1 : transform;
    var tmp;
    if ($super === VOID) {
      this.l4z(path, transform);
      tmp = Unit_instance;
    } else {
      tmp = $super.l4z.call(this, path, transform);
    }
    return tmp;
  }
  n4z() {
    // Inline function 'kotlin.text.trimEnd' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.n4p_1;
    var n_0 = 0;
    while (n_0 < this_1.g1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.x27(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.o4p_1.h1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.y3k(tmp, this.o4p_1.h1(_unary__edvuaz_1));
          var x = destruct.em();
          var y = destruct.fm();
          this_0.gc('M' + get_niceStr(x) + ',' + get_niceStr(y) + ' ');
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.o4p_1.h1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.y3k(tmp_0, this.o4p_1.h1(_unary__edvuaz_3));
          var x_0 = destruct_0.em();
          var y_0 = destruct_0.fm();
          this_0.gc('L' + get_niceStr(x_0) + ',' + get_niceStr(y_0) + ' ');
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.o4p_1.h1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.y3k(tmp_1, this.o4p_1.h1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.o4p_1.h1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.y3k(tmp_2, this.o4p_1.h1(_unary__edvuaz_7));
          var x1 = destruct_1.em();
          var y1 = destruct_1.fm();
          var x2 = destruct_2.em();
          var y2 = destruct_2.fm();
          this_0.gc('Q' + get_niceStr(x1) + ',' + get_niceStr(y1) + ',' + get_niceStr(x2) + ',' + get_niceStr(y2) + ' ');
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.o4p_1.h1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.y3k(tmp_3, this.o4p_1.h1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.o4p_1.h1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.y3k(tmp_4, this.o4p_1.h1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.o4p_1.h1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.y3k(tmp_5, this.o4p_1.h1(_unary__edvuaz_13));
          var x1_0 = destruct_3.em();
          var y1_0 = destruct_3.fm();
          var x2_0 = destruct_4.em();
          var y2_0 = destruct_4.fm();
          var x3 = destruct_5.em();
          var y3 = destruct_5.fm();
          this_0.gc('C' + get_niceStr(x1_0) + ',' + get_niceStr(y1_0) + ',' + get_niceStr(x2_0) + ',' + get_niceStr(y2_0) + ',' + get_niceStr(x3) + ',' + get_niceStr(y3) + ' ');
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          this_0.gc('Z ');
          break;
      }
    }
    var this_2 = this_0.toString();
    return toString(trimEnd(isCharSequence(this_2) ? this_2 : THROW_CCE()));
  }
  toString() {
    return 'VectorPath(' + this.n4z() + ')';
  }
  o4z(sx, sy) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, this.o4p_1.g1()), 2);
    var inductionVariable = progression.f2_1;
    var last = progression.g2_1;
    var step_0 = progression.h2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.VectorPath.scale.<anonymous>' call
        var it = Vector2D.y3k(this.o4p_1.h1(n + 0 | 0), this.o4p_1.h1(n + 1 | 0));
        var p = Vector2D.y3k(it.r3i_1 * sx, it.s3i_1 * sy);
        this.o4p_1.q3x(n + 0 | 0, p.r3i_1);
        this.o4p_1.q3x(n + 1 | 0, p.s3i_1);
      }
       while (!(n === last));
    this.s4p_1 = this.s4p_1 + 1 | 0;
    return this;
  }
}
class with$1 {
  constructor($bb) {
    this.p4z_1 = $bb;
  }
  k4p(p) {
    this.p4z_1._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x(this.p4z_1._v.c3k_1, p));
  }
}
class Companion_9 {
  h4z() {
    return Winding_NON_ZERO_getInstance();
  }
}
class Winding extends Enum {
  constructor(name, ordinal, str) {
    super(name, ordinal);
    this.s4z_1 = str;
  }
}
class Companion_10 {}
class LineJoin extends Enum {}
class Companion_11 {}
class LineCap extends Enum {}
class LineScaleMode extends Enum {
  constructor(name, ordinal, hScale, vScale) {
    super(name, ordinal);
    this.v4z_1 = hScale;
    this.w4z_1 = vScale;
    this.x4z_1 = this.v4z_1 || this.w4z_1;
    this.y4z_1 = (this.v4z_1 && this.w4z_1);
  }
}
class Companion_12 {}
class StrokeInfo {
  constructor(thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset) {
    thickness = thickness === VOID ? 1.0 : thickness;
    pixelHinting = pixelHinting === VOID ? false : pixelHinting;
    scaleMode = scaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : scaleMode;
    startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
    endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
    join = join === VOID ? LineJoin_MITER_getInstance() : join;
    miterLimit = miterLimit === VOID ? 20.0 : miterLimit;
    dash = dash === VOID ? null : dash;
    dashOffset = dashOffset === VOID ? 0.0 : dashOffset;
    this.h4y_1 = thickness;
    this.i4y_1 = pixelHinting;
    this.j4y_1 = scaleMode;
    this.k4y_1 = startCap;
    this.l4y_1 = endCap;
    this.m4y_1 = join;
    this.n4y_1 = miterLimit;
    this.o4y_1 = dash;
    this.p4y_1 = dashOffset;
  }
  toString() {
    return 'StrokeInfo(thickness=' + this.h4y_1 + ', pixelHinting=' + this.i4y_1 + ', scaleMode=' + this.j4y_1.toString() + ', startCap=' + this.k4y_1.toString() + ', endCap=' + this.l4y_1.toString() + ', join=' + this.m4y_1.toString() + ', miterLimit=' + this.n4y_1 + ', dash=' + toString_0(this.o4y_1) + ', dashOffset=' + this.p4y_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.h4y_1);
    result = imul(result, 31) + getBooleanHashCode(this.i4y_1) | 0;
    result = imul(result, 31) + this.j4y_1.hashCode() | 0;
    result = imul(result, 31) + this.k4y_1.hashCode() | 0;
    result = imul(result, 31) + this.l4y_1.hashCode() | 0;
    result = imul(result, 31) + this.m4y_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.n4y_1) | 0;
    result = imul(result, 31) + (this.o4y_1 == null ? 0 : hashCode(this.o4y_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p4y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StrokeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof StrokeInfo ? other : THROW_CCE();
    if (!equals(this.h4y_1, tmp0_other_with_cast.h4y_1))
      return false;
    if (!(this.i4y_1 === tmp0_other_with_cast.i4y_1))
      return false;
    if (!this.j4y_1.equals(tmp0_other_with_cast.j4y_1))
      return false;
    if (!this.k4y_1.equals(tmp0_other_with_cast.k4y_1))
      return false;
    if (!this.l4y_1.equals(tmp0_other_with_cast.l4y_1))
      return false;
    if (!this.m4y_1.equals(tmp0_other_with_cast.m4y_1))
      return false;
    if (!equals(this.n4y_1, tmp0_other_with_cast.n4y_1))
      return false;
    if (!equals(this.o4y_1, tmp0_other_with_cast.o4y_1))
      return false;
    if (!equals(this.p4y_1, tmp0_other_with_cast.p4y_1))
      return false;
    return true;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    var tmp_0 = MPoint$Companion$POOL$lambda;
    tmp.x4x_1 = ConcurrentPool.p42(tmp_0, VOID, MPoint$Companion$POOL$lambda_0);
    this.y4x_1 = new MPoint(0.0, 0.0);
    this.z4x_1 = new MPoint(1.0, 1.0);
    this.a4y_1 = new MPoint(0.0, -1.0);
    this.b4y_1 = new MPoint(0.0, +1.0);
    this.c4y_1 = new MPoint(-1.0, 0.0);
    this.d4y_1 = new MPoint(+1.0, 0.0);
  }
  c3m() {
    return new MPoint(0.0, 0.0);
  }
  c50(lx, ly, rx, ry) {
    var ret = compareTo(ly, ry);
    return ret === 0 ? compareTo(lx, rx) : ret;
  }
  p3r(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  c3t(x1, y1, x2, y2) {
    return this.p3r(x1, y1, x2, y2);
  }
}
class MPoint {
  constructor(x, y) {
    Companion_getInstance_22();
    this.z4z_1 = x;
    this.a50_1 = y;
  }
  d50(other, epsilon) {
    return isAlmostEquals_0(this.z4z_1, other.z4z_1, epsilon) && isAlmostEquals_0(this.a50_1, other.a50_1, epsilon);
  }
  f27(other, epsilon) {
    return this.d50(other instanceof MPoint ? other : THROW_CCE(), epsilon);
  }
  b50(x, y) {
    this.z4z_1 = x;
    this.a50_1 = y;
    return this;
  }
  e50(other) {
    return Companion_getInstance_22().c50(this.z4z_1, this.a50_1, other.z4z_1, other.a50_1);
  }
  d(other) {
    return this.e50(other instanceof MPoint ? other : THROW_CCE());
  }
  toString() {
    return '(' + get_niceStr(this.z4z_1) + ', ' + get_niceStr(this.a50_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.z4z_1);
    result = imul(result, 31) + getNumberHashCode(this.a50_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MPoint))
      return false;
    var tmp0_other_with_cast = other instanceof MPoint ? other : THROW_CCE();
    if (!equals(this.z4z_1, tmp0_other_with_cast.z4z_1))
      return false;
    if (!equals(this.a50_1, tmp0_other_with_cast.a50_1))
      return false;
    return true;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    var tmp = this;
    var tmp_0 = MMatrix$Companion$POOL$lambda;
    tmp.m50_1 = ConcurrentPool.p42(tmp_0, VOID, MMatrix$Companion$POOL$lambda_0);
  }
}
class MMatrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_23();
    a = a === VOID ? 1.0 : a;
    b = b === VOID ? 0.0 : b;
    c = c === VOID ? 0.0 : c;
    d = d === VOID ? 1.0 : d;
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.f50_1 = a;
    this.g50_1 = b;
    this.h50_1 = c;
    this.i50_1 = d;
    this.j50_1 = tx;
    this.k50_1 = ty;
  }
  n50(a, b, c, d, tx, ty) {
    this.f50_1 = a;
    this.g50_1 = b;
    this.h50_1 = c;
    this.i50_1 = d;
    this.j50_1 = tx;
    this.k50_1 = ty;
    return this;
  }
  l50() {
    return this.n50(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
  }
  toString() {
    return 'Matrix(a=' + this.f50_1 + ', b=' + this.g50_1 + ', c=' + this.h50_1 + ', d=' + this.i50_1 + ', tx=' + this.j50_1 + ', ty=' + this.k50_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.f50_1);
    result = imul(result, 31) + getNumberHashCode(this.g50_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h50_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i50_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j50_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k50_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MMatrix))
      return false;
    var tmp0_other_with_cast = other instanceof MMatrix ? other : THROW_CCE();
    if (!equals(this.f50_1, tmp0_other_with_cast.f50_1))
      return false;
    if (!equals(this.g50_1, tmp0_other_with_cast.g50_1))
      return false;
    if (!equals(this.h50_1, tmp0_other_with_cast.h50_1))
      return false;
    if (!equals(this.i50_1, tmp0_other_with_cast.i50_1))
      return false;
    if (!equals(this.j50_1, tmp0_other_with_cast.j50_1))
      return false;
    if (!equals(this.k50_1, tmp0_other_with_cast.k50_1))
      return false;
    return true;
  }
}
class Companion_15 {
  t4w(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    var a1 = By - Ay;
    var b1 = Ax - Bx;
    var c1 = a1 * Ax + b1 * Ay;
    var a2 = Dy - Cy;
    var b2 = Cx - Dx;
    var c2 = a2 * Cx + b2 * Cy;
    var determinant = a1 * b2 - a2 * b1;
    if (isAlmostZero(determinant))
      return null;
    var x = (b2 * c1 - b1 * c2) / determinant;
    var y = (a1 * c2 - a2 * c1) / determinant;
    return Vector2D.y3k(x, y);
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    var tmp_0 = MRectangle$Companion$POOL$lambda;
    tmp.s50_1 = ConcurrentPool.p42(tmp_0, VOID, MRectangle$Companion$POOL$lambda_0);
  }
  c3m() {
    return new MRectangle(0.0, 0.0, 0.0, 0.0);
  }
}
class MRectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_25();
    this.o50_1 = x;
    this.p50_1 = y;
    this.q50_1 = width;
    this.r50_1 = height;
  }
  t50(other, epsilon) {
    return isAlmostEquals_0(this.o50_1, other.o50_1, epsilon) && isAlmostEquals_0(this.p50_1, other.p50_1, epsilon) && isAlmostEquals_0(this.q50_1, other.q50_1, epsilon) && isAlmostEquals_0(this.r50_1, other.r50_1, epsilon);
  }
  f27(other, epsilon) {
    return this.t50(other instanceof MRectangle ? other : THROW_CCE(), epsilon);
  }
  i3j() {
    return this.o50_1;
  }
  d3q() {
    return this.p50_1;
  }
  j3j() {
    return this.o50_1 + this.q50_1;
  }
  c3q() {
    return this.p50_1 + this.r50_1;
  }
  u50(x, y, width, height) {
    this.o50_1 = x;
    this.p50_1 = y;
    this.q50_1 = width;
    this.r50_1 = height;
    return this;
  }
  v50(left, top, right, bottom) {
    return this.u50(left, top, right - left, bottom - top);
  }
  w50(left, top, right, bottom) {
    return this.v50(this.i3j() - left, this.d3q() - top, this.j3j() + right, this.c3q() + bottom);
  }
  x50(left, top, right, bottom, $super) {
    top = top === VOID ? left : top;
    right = right === VOID ? left : right;
    bottom = bottom === VOID ? top : bottom;
    return $super === VOID ? this.w50(left, top, right, bottom) : $super.w50.call(this, left, top, right, bottom);
  }
  ai() {
    return this.u50(0.0, 0.0, 0.0, 0.0);
  }
  toString() {
    return 'Rectangle(x=' + get_niceStr(this.o50_1) + ', y=' + get_niceStr(this.p50_1) + ', width=' + get_niceStr(this.q50_1) + ', height=' + get_niceStr(this.r50_1) + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof MRectangle) {
      tmp_2 = isAlmostEquals_0(this.o50_1, other.o50_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = isAlmostEquals_0(this.p50_1, other.p50_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = isAlmostEquals_0(this.q50_1, other.q50_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = isAlmostEquals_0(this.r50_1, other.r50_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  y50() {
    return new Rectangle(this.o50_1, this.p50_1, this.q50_1, this.r50_1);
  }
  hashCode() {
    var result = getNumberHashCode(this.o50_1);
    result = imul(result, 31) + getNumberHashCode(this.p50_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q50_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r50_1) | 0;
    return result;
  }
}
class Easings extends Enum {
  toString() {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return replace(super.toString(), _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45)).toLowerCase();
  }
}
class Easings$SMOOTH extends Easings {
  constructor() {
    super('SMOOTH', 0);
    Easings_SMOOTH_instance = this;
  }
  i27(it) {
    return it * it * (3 - 2 * it);
  }
}
class Easings$EASE_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_ELASTIC', 1);
    Easings_EASE_IN_ELASTIC_instance = this;
  }
  i27(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        var inv = it - 1;
        var tmp_0 = -1.0;
        // Inline function 'kotlin.math.pow' call

        var x = 10.0 * inv;
        var tmp_1 = tmp_0 * Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (inv - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_1 * Math.sin(x_0);
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_ELASTIC', 2);
    Easings_EASE_OUT_ELASTIC_instance = this;
  }
  i27(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        // Inline function 'kotlin.math.pow' call

        var x = -10.0 * it;
        var tmp_0 = Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (it - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_0 * Math.sin(x_0) + 1;
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_BOUNCE', 3);
    Easings_EASE_OUT_BOUNCE_instance = this;
  }
  i27(it) {
    var s = 7.5625;
    var p = 2.75;
    var tmp;
    if (it < 1.0 / p) {
      // Inline function 'kotlin.math.pow' call
      tmp = s * Math.pow(it, 2.0);
    } else if (it < 2.0 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = it - 1.5 / p;
      tmp = s * Math.pow(this_0, 2.0) + 0.75;
    } else if (it < 2.5 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_1 = it - 2.25 / p;
      tmp = s * Math.pow(this_1, 2.0) + 0.9375;
    } else {
      // Inline function 'kotlin.math.pow' call
      var this_2 = it - 2.625 / p;
      tmp = s * Math.pow(this_2, 2.0) + 0.984375;
    }
    return tmp;
  }
}
class Easings$LINEAR extends Easings {
  constructor() {
    super('LINEAR', 4);
    Easings_LINEAR_instance = this;
  }
  i27(it) {
    return it;
  }
}
class Easings$EASE extends Easings {
  constructor() {
    super('EASE', 5);
    Easings_EASE_instance = this;
    this.l51_1 = new EasingCubic(0.25, 0.1, 0.25, 1.0, 'ease');
  }
  i27(it) {
    return this.l51_1.i27(it);
  }
}
class Easings$EASE_IN extends Easings {
  constructor() {
    super('EASE_IN', 6);
    Easings_EASE_IN_instance = this;
    this.u51_1 = new EasingCubic(0.42, 0.0, 1.0, 1.0, 'ease-in');
  }
  i27(it) {
    return this.u51_1.i27(it);
  }
}
class Easings$EASE_OUT extends Easings {
  constructor() {
    super('EASE_OUT', 7);
    Easings_EASE_OUT_instance = this;
    this.x51_1 = new EasingCubic(0.0, 0.0, 0.58, 1.0, 'ease-out');
  }
  i27(it) {
    return this.x51_1.i27(it);
  }
}
class Easings$EASE_IN_OUT extends Easings {
  constructor() {
    super('EASE_IN_OUT', 8);
    Easings_EASE_IN_OUT_instance = this;
    this.a52_1 = new EasingCubic(0.42, 0.0, 0.58, 1.0, 'ease-in-out');
  }
  i27(it) {
    return this.a52_1.i27(it);
  }
}
class Easings$EASE_IN_OLD extends Easings {
  constructor() {
    super('EASE_IN_OLD', 9);
    Easings_EASE_IN_OLD_instance = this;
  }
  i27(it) {
    return it * it * it;
  }
}
class Easings$EASE_OUT_OLD extends Easings {
  constructor() {
    super('EASE_OUT_OLD', 10);
    Easings_EASE_OUT_OLD_instance = this;
  }
  i27(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_OLD.invoke.<anonymous>' call
    var inv = it - 1.0;
    return inv * inv * inv + 1;
  }
}
class Easings$EASE_IN_OUT_OLD extends Easings {
  constructor() {
    super('EASE_IN_OUT_OLD', 11);
    Easings_EASE_IN_OUT_OLD_instance = this;
  }
  i27(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_IN_OLD_getInstance();
    var end = Easings_EASE_OUT_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.i27(it * 2.0) : 0.5 * end.i27((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_OLD extends Easings {
  constructor() {
    super('EASE_OUT_IN_OLD', 12);
    Easings_EASE_OUT_IN_OLD_instance = this;
  }
  i27(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_OUT_OLD_getInstance();
    var end = Easings_EASE_IN_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.i27(it * 2.0) : 0.5 * end.i27((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BACK extends Easings {
  constructor() {
    super('EASE_IN_BACK', 13);
    Easings_EASE_IN_BACK_instance = this;
  }
  i27(it) {
    // Inline function 'kotlin.math.pow' call
    return Math.pow(it, 2.0) * ((1.70158 + 1.0) * it - 1.70158);
  }
}
class Easings$EASE_OUT_BACK extends Easings {
  constructor() {
    super('EASE_OUT_BACK', 14);
    Easings_EASE_OUT_BACK_instance = this;
  }
  i27(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_BACK.invoke.<anonymous>' call
    var inv = it - 1.0;
    // Inline function 'kotlin.math.pow' call
    return Math.pow(inv, 2.0) * ((1.70158 + 1.0) * inv + 1.70158) + 1.0;
  }
}
class Easings$EASE_IN_OUT_BACK extends Easings {
  constructor() {
    super('EASE_IN_OUT_BACK', 15);
    Easings_EASE_IN_OUT_BACK_instance = this;
  }
  i27(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_IN_BACK_getInstance();
    var end = Easings_EASE_OUT_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.i27(it * 2.0) : 0.5 * end.i27((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BACK extends Easings {
  constructor() {
    super('EASE_OUT_IN_BACK', 16);
    Easings_EASE_OUT_IN_BACK_instance = this;
  }
  i27(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_OUT_BACK_getInstance();
    var end = Easings_EASE_IN_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.i27(it * 2.0) : 0.5 * end.i27((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_OUT_ELASTIC', 17);
    Easings_EASE_IN_OUT_ELASTIC_instance = this;
  }
  i27(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_IN_ELASTIC_getInstance();
    var end = Easings_EASE_OUT_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.i27(it * 2.0) : 0.5 * end.i27((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_IN_ELASTIC', 18);
    Easings_EASE_OUT_IN_ELASTIC_instance = this;
  }
  i27(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_OUT_ELASTIC_getInstance();
    var end = Easings_EASE_IN_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.i27(it * 2.0) : 0.5 * end.i27((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_BOUNCE', 19);
    Easings_EASE_IN_BOUNCE_instance = this;
  }
  i27(it) {
    return 1.0 - Easings_EASE_OUT_BOUNCE_getInstance().i27(1.0 - it);
  }
}
class Easings$EASE_IN_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_OUT_BOUNCE', 20);
    Easings_EASE_IN_OUT_BOUNCE_instance = this;
  }
  i27(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_IN_BOUNCE_getInstance();
    var end = Easings_EASE_OUT_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.i27(it * 2.0) : 0.5 * end.i27((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_IN_BOUNCE', 21);
    Easings_EASE_OUT_IN_BOUNCE_instance = this;
  }
  i27(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_0();
    var start = Easings_EASE_OUT_BOUNCE_getInstance();
    var end = Easings_EASE_IN_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.i27(it * 2.0) : 0.5 * end.i27((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_QUAD extends Easings {
  constructor() {
    super('EASE_IN_QUAD', 22);
    Easings_EASE_IN_QUAD_instance = this;
  }
  i27(it) {
    return 1.0 * it * it;
  }
}
class Easings$EASE_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_OUT_QUAD', 23);
    Easings_EASE_OUT_QUAD_instance = this;
  }
  i27(it) {
    return -1.0 * it * (it - 2);
  }
}
class Easings$EASE_IN_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_IN_OUT_QUAD', 24);
    Easings_EASE_IN_OUT_QUAD_instance = this;
  }
  i27(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_IN_OUT_QUAD.invoke.<anonymous>' call
    var t = it * 2.0;
    var tmp;
    if (t < 1) {
      tmp = +1.0 / 2 * t * t;
    } else {
      tmp = -1.0 / 2 * ((t - 1) * (t - 1 - 2) - 1);
    }
    return tmp;
  }
}
class Easings$EASE_SINE extends Easings {
  constructor() {
    super('EASE_SINE', 25);
    Easings_EASE_SINE_instance = this;
  }
  i27(it) {
    // Inline function 'kotlin.math.sin' call
    var x = it * 1.5707964;
    return Math.sin(x);
  }
}
class Easings$EASE_CLAMP_START extends Easings {
  constructor() {
    super('EASE_CLAMP_START', 26);
    Easings_EASE_CLAMP_START_instance = this;
  }
  i27(it) {
    return it <= 0.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_END extends Easings {
  constructor() {
    super('EASE_CLAMP_END', 27);
    Easings_EASE_CLAMP_END_instance = this;
  }
  i27(it) {
    return it < 1.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_MIDDLE extends Easings {
  constructor() {
    super('EASE_CLAMP_MIDDLE', 28);
    Easings_EASE_CLAMP_MIDDLE_instance = this;
  }
  i27(it) {
    return it < 0.5 ? 0.0 : 1.0;
  }
}
class P {
  static r53(x, y) {
    var $this = createThis(this);
    $this.p53_1 = x;
    $this.q53_1 = y;
    return $this;
  }
  static s53(x, y) {
    return this.r53(x, y);
  }
  u3q(that) {
    return P.r53(this.p53_1 * that, this.q53_1 * that);
  }
  t53(that) {
    return P.r53(this.p53_1 + that.p53_1, this.q53_1 + that.q53_1);
  }
  toString() {
    return 'P(x=' + this.p53_1 + ', y=' + this.q53_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.p53_1);
    result = imul(result, 31) + getNumberHashCode(this.q53_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof P))
      return false;
    var tmp0_other_with_cast = other instanceof P ? other : THROW_CCE();
    if (!equals(this.p53_1, tmp0_other_with_cast.p53_1))
      return false;
    if (!equals(this.q53_1, tmp0_other_with_cast.q53_1))
      return false;
    return true;
  }
}
class EasingCubic {
  constructor(x1, y1, x2, y2, name) {
    name = name === VOID ? null : name;
    this.m51_1 = x1;
    this.n51_1 = y1;
    this.o51_1 = x2;
    this.p51_1 = y2;
    this.q51_1 = name;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r51_1 = [P.s53(0.0, 0.0), P.s53(clamp_0(this.m51_1, 0.0, 1.0), this.n51_1), P.s53(clamp_0(this.o51_1, 0.0, 1.0), this.p51_1), P.s53(1.0, 1.0)];
  }
  toString() {
    var tmp0_elvis_lhs = this.q51_1;
    return tmp0_elvis_lhs == null ? 'cubic-bezier(' + this.m51_1 + ', ' + this.n51_1 + ', ' + this.o51_1 + ', ' + this.p51_1 + ')' : tmp0_elvis_lhs;
  }
  i27(it) {
    var pivotLeft = it < 0.0 ? it * 10.0 : 0.0;
    var pivotRight = it > 1.0 ? it * 10.0 : 1.0;
    var pivot = it;
    var lastX = 0.0;
    var lastY = 0.0;
    var steps = 0;
    var inductionVariable = 0;
    if (inductionVariable < 50)
      $l$loop_0: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        steps = steps + 1 | 0;
        var res = calc(this, pivot);
        lastX = res.p53_1;
        lastY = res.q53_1;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = lastX - it;
        if (Math.abs(this_0) < 0.001)
          break $l$loop_0;
        if (it < lastX) {
          pivotRight = pivot;
          pivot = (pivotLeft + pivot) * 0.5;
        } else if (it > lastX) {
          pivotLeft = pivot;
          pivot = (pivotRight + pivot) * 0.5;
        } else {
          break $l$loop_0;
        }
      }
       while (inductionVariable < 50);
    return lastY;
  }
}
//endregion
function insertAt($this, n, min, max) {
  $this.s4k_1.z3w(n, min);
  $this.t4k_1.z3w(n, max);
}
function removeAt($this, n, count) {
  $this.s4k_1.b3x(n, count);
  $this.t4k_1.b3x(n, count);
}
var isConvex$delegate;
function Curves$contiguous$delegate$lambda(this$0) {
  return function () {
    var inductionVariable = 1;
    var last = this$0.h4l_1.g1();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = this$0.h4l_1.h1(n - 1 | 0);
        var next = this$0.h4l_1.h1(n);
        if (!curr.n4l_1.n3y().g27(next.n4l_1.m3y()))
          return false;
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    return true;
  };
}
function Curves$infos$delegate$lambda(this$0) {
  return function () {
    var pos = 0.0;
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.h4l_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'korlibs.math.geom.bezier.Curves.infos$delegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var start = pos;
      pos = pos + item.a();
      var tmp$ret$0 = new CurveInfo(index_0, item, start, pos, item.y4l());
      destination.h(tmp$ret$0);
    }
    return destination;
  };
}
function Curves$length$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var _iterator__ex2g4s = this$0.z4l().b1();
    while (_iterator__ex2g4s.c1()) {
      var element = _iterator__ex2g4s.d1();
      var tmp = sum;
      // Inline function 'korlibs.math.geom.bezier.Curves.length$delegate.<anonymous>.<anonymous>' call
      sum = tmp + element.a();
    }
    return sum;
  };
}
function Curves$findInfo$lambda($pos) {
  return function (it) {
    return it.r3x($pos) ? 0 : it.e4l_1 < $pos ? -1 : 1;
  };
}
function Curves$ratioFromLength$lambda($length) {
  return function (it) {
    return it.e4l_1 < $length ? -1 : it.d4l_1 > $length ? 1 : 0;
  };
}
function Bezier$Extrema$allt$delegate$lambda(this$0) {
  return function () {
    return combineSmallDistinctSorted(Companion_getInstance_8(), this$0.m4m_1, this$0.n4m_1);
  };
}
function Bezier$Extrema$xt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.m4m_1, new Float64Array([1.0])]);
  };
}
function Bezier$Extrema$yt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.n4m_1, new Float64Array([1.0])]);
  };
}
function map($this, v, ds, de, ts, te) {
  return convertRange(v, ds, de, ts, te);
}
function angle($this, o, v1, v2) {
  var dx1 = v1.r3i_1 - o.r3i_1;
  var dy1 = v1.s3i_1 - o.s3i_1;
  var dx2 = v2.r3i_1 - o.r3i_1;
  var dy2 = v2.s3i_1 - o.s3i_1;
  var cross = dx1 * dy2 - dy1 * dx2;
  var dot = dx1 * dx2 + dy1 * dy2;
  // Inline function 'kotlin.math.atan2' call
  return Math.atan2(cross, dot);
}
function compute($this, t, points) {
  var p = points;
  var order = p.g1() - 1 | 0;
  if (equals(t, Companion_getInstance().p27_1))
    return p.h1(0);
  if (equals(t, Companion_getInstance().s27_1))
    return p.h1(order);
  if (order === 0)
    return p.h1(0);
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance().s27_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var tmp;
  switch (order) {
    case 1:
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_0 = p.h1(0);
      var this_1 = Vector2D.y3k(this_0.r3i_1 * mt, this_0.s3i_1 * mt);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_2 = p.h1(1);
      var scale = Ratio__toDouble_impl_o7epze(t);
      var that = Vector2D.y3k(this_2.r3i_1 * scale, this_2.s3i_1 * scale);
      tmp = Vector2D.y3k(this_1.r3i_1 + that.r3i_1, this_1.s3i_1 + that.s3i_1);
      break;
    case 2:
      var a = mt2;
      // Inline function 'korlibs.math.interpolation.times' call

      var b = mt * _Ratio___get_value__impl__57cli6(t) * 2;
      var c = t2;
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_3 = p.h1(0);
      var this_4 = Vector2D.y3k(this_3.r3i_1 * a, this_3.s3i_1 * a);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_5 = p.h1(1);
      var that_0 = Vector2D.y3k(this_5.r3i_1 * b, this_5.s3i_1 * b);
      var this_6 = Vector2D.y3k(this_4.r3i_1 + that_0.r3i_1, this_4.s3i_1 + that_0.s3i_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_7 = p.h1(2);
      var that_1 = Vector2D.y3k(this_7.r3i_1 * c, this_7.s3i_1 * c);
      tmp = Vector2D.y3k(this_6.r3i_1 + that_1.r3i_1, this_6.s3i_1 + that_1.s3i_1);
      break;
    case 3:
      var a_0 = mt2 * mt;
      // Inline function 'korlibs.math.interpolation.times' call

      var b_0 = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
      var c_0 = mt * t2 * 3;
      var d = Ratio__times_impl_ucdh7y(t, t2);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_8 = p.h1(0);
      var this_9 = Vector2D.y3k(this_8.r3i_1 * a_0, this_8.s3i_1 * a_0);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_10 = p.h1(1);
      var that_2 = Vector2D.y3k(this_10.r3i_1 * b_0, this_10.s3i_1 * b_0);
      var this_11 = Vector2D.y3k(this_9.r3i_1 + that_2.r3i_1, this_9.s3i_1 + that_2.s3i_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_12 = p.h1(2);
      var that_3 = Vector2D.y3k(this_12.r3i_1 * c_0, this_12.s3i_1 * c_0);
      var this_13 = Vector2D.y3k(this_11.r3i_1 + that_3.r3i_1, this_11.s3i_1 + that_3.s3i_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_14 = p.h1(3);
      var that_4 = Vector2D.y3k(this_14.r3i_1 * d, this_14.s3i_1 * d);
      tmp = Vector2D.y3k(this_13.r3i_1 + that_4.r3i_1, this_13.s3i_1 + that_4.s3i_1);
      break;
    default:
      var reason = 'higher order curves';
      throw NotImplementedError.je('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function derive($this, points) {
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.z();
  var current = points;
  while (current.g1() >= 2) {
    var new_0 = new PointArrayList(current.g1() - 1 | 0);
    var c = current.g1() - 1 | 0;
    var inductionVariable = 0;
    var last = current.g1() - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        // Inline function 'korlibs.math.geom.Vector2D.minus' call
        var this_0 = current.h1(n + 1 | 0);
        var that = current.h1(n);
        var this_1 = Vector2D.y3k(this_0.r3i_1 - that.r3i_1, this_0.s3i_1 - that.s3i_1);
        var tmp$ret$2 = Vector2D.y3k(this_1.r3i_1 * c, this_1.s3i_1 * c);
        new_0.v44(tmp$ret$2);
      }
       while (inductionVariable < last);
    out.h(new_0);
    current = new_0;
  }
  return out;
}
function align($this, points, line, out) {
  var p1 = line.e3l_1;
  var p2 = line.f3l_1;
  var tx = p1.r3i_1;
  var ty = p1.s3i_1;
  // Inline function 'kotlin.math.atan2' call
  var y = p2.s3i_1 - ty;
  var x = p2.r3i_1 - tx;
  var a = -Math.atan2(y, x);
  // Inline function 'korlibs.math.geom.fastForEach' call
  var inductionVariable = 0;
  var last = points.g1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.Companion.align.<anonymous>' call
      var destruct = points.h1(n);
      var x_0 = destruct.em();
      var y_0 = destruct.fm();
      var tmp = x_0 - tx;
      // Inline function 'kotlin.math.cos' call
      var tmp_0 = tmp * Math.cos(a);
      var tmp_1 = y_0 - ty;
      // Inline function 'kotlin.math.sin' call
      var tmp_2 = tmp_0 - tmp_1 * Math.sin(a);
      var tmp_3 = x_0 - tx;
      // Inline function 'kotlin.math.sin' call
      var tmp_4 = tmp_3 * Math.sin(a);
      var tmp_5 = y_0 - ty;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$4 = Math.cos(a);
      out.u44(tmp_2, tmp_4 + tmp_5 * tmp$ret$4);
    }
     while (inductionVariable < last);
  return out;
}
function align$default($this, points, line, out, $super) {
  out = out === VOID ? new PointArrayList() : out;
  return align($this, points, line, out);
}
function droots($this, p) {
  switch (p.length) {
    case 3:
      var a = p[0];
      var b = p[1];
      var c = p[2];
      var d = a - 2 * b + c;
      if (!(d === 0.0)) {
        // Inline function 'kotlin.math.sqrt' call
        var x = b * b - a * c;
        var m1 = -Math.sqrt(x);
        var m2 = -a + b;
        var v1 = -(m1 + m2) / d;
        var v2 = -(-m1 + m2) / d;
        return doubleArrayOfValid01$default($this, v1, v2);
      } else if (!(b === c) && d === 0.0) {
        return doubleArrayOfValid01$default($this, (2.0 * b - c) / (2.0 * (b - c)));
      }

      break;
    case 2:
      var a_0 = p[0];
      var b_0 = p[1];
      if (!(a_0 === b_0))
        return doubleArrayOfValid01$default($this, a_0 / (a_0 - b_0));
      break;
    default:
      break;
  }
  return doubleArrayOfValid01$default($this);
}
function doubleArrayOfValid01($this, v1, v2, v3) {
  var v1Valid = 0.0 <= v1 ? v1 <= 1.0 : false;
  var v2Valid = 0.0 <= v2 ? v2 <= 1.0 : false;
  var v3Valid = 0.0 <= v3 ? v3 <= 1.0 : false;
  var validCount = 0;
  if (v1Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v2Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v3Valid) {
    validCount = validCount + 1 | 0;
  }
  if (validCount === 0)
    return $this.v4m_1;
  var index = 0;
  var out = new Float64Array(validCount);
  if (v1Valid) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    out[_unary__edvuaz] = normalizeZero(v1);
  }
  if (v2Valid) {
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    out[_unary__edvuaz_0] = normalizeZero(v2);
  }
  if (v3Valid) {
    var _unary__edvuaz_1 = index;
    index = _unary__edvuaz_1 + 1 | 0;
    out[_unary__edvuaz_1] = normalizeZero(v3);
  }
  return out;
}
function doubleArrayOfValid01$default($this, v1, v2, v3, $super) {
  v1 = v1 === VOID ? NaN : v1;
  v2 = v2 === VOID ? NaN : v2;
  v3 = v3 === VOID ? NaN : v3;
  return doubleArrayOfValid01($this, v1, v2, v3);
}
function combineSmallDistinctSorted($this, a, b) {
  var out = DoubleArrayList.f3x(a.length + b.length | 0);
  out.p3x(a);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < b.length) {
    // Inline function 'korlibs.math.geom.bezier.Companion.combineSmallDistinctSorted.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = b[_unary__edvuaz];
    if (!out.r3x(it)) {
      out.s29(it);
    }
  }
  sort(out);
  return out.y27();
}
function _get_aligned__7fjidv($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.o4l_1;
  aligned$factory();
  return this_0.w1();
}
function _getBoundingBox($this, m) {
  var xmin = 0.0;
  var ymin = 0.0;
  var xmax = 0.0;
  var ymax = 0.0;
  var inductionVariable = 0;
  if (inductionVariable <= 1)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ext = $this.w4m().x4m(n);
      var min = Infinity;
      var max = -Infinity;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < ext.length) {
        // Inline function 'korlibs.math.geom.bezier.Bezier._getBoundingBox.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        var t = ext[_unary__edvuaz];
        var p = $this.y4m(_Ratio___init__impl__9mwvn2(t));
        var value = n === 0 ? transformX(p, m) : transformY(p, m);
        // Inline function 'kotlin.math.min' call
        var a = min;
        min = Math.min(a, value);
        // Inline function 'kotlin.math.max' call
        var a_0 = max;
        max = Math.max(a_0, value);
      }
      if (n === 0) {
        xmin = min;
        xmax = max;
      } else {
        ymin = min;
        ymax = max;
      }
    }
     while (inductionVariable <= 1);
  return Companion_getInstance_1().o3q(xmin, ymin, xmax, ymax);
}
function findNearestLine($this, pX, pY, aX, aY, bX, bY, out) {
  out.c4n_1 = $this;
  var atobX = bX - aX;
  var atobY = bY - aY;
  var atopX = pX - aX;
  var atopY = pY - aY;
  var len = atobX * atobX + atobY * atobY;
  var dot = atopX * atobX + atopY * atobY;
  // Inline function 'kotlin.math.min' call
  // Inline function 'kotlin.math.max' call
  var b = dot / len;
  var b_0 = Math.max(0.0, b);
  var tmp$ret$1 = Math.min(1.0, b_0);
  var t = toRatio(tmp$ret$1);
  var tmp = out;
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp_0 = aX + atobX * _Ratio___get_value__impl__57cli6(t);
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp$ret$3 = atobY * _Ratio___get_value__impl__57cli6(t);
  tmp.z4m_1 = Vector2D.y3k(tmp_0, aY + tmp$ret$3);
  out.a4n_1 = t;
  out.b4n_1 = Companion_getInstance_2().e3t(out.z4m_1.r3i_1, out.z4m_1.s3i_1, pX, pY);
  return out;
}
var Companion_instance;
function Companion_getInstance_8() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function Bezier$aligned$delegate$lambda(this$0) {
  return function () {
    return align$default(Companion_getInstance_8(), this$0.n4l_1, Line2D.g3l(this$0.n4l_1.m3y(), this$0.n4l_1.n3y()));
  };
}
function Bezier$dpoints$delegate$lambda(this$0) {
  return function () {
    return derive(Companion_getInstance_8(), this$0.n4l_1);
  };
}
function Bezier$direction$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_3();
    var p0 = this$0.n4l_1.h1(0);
    var p1 = this$0.n4l_1.h1(this$0.k4n());
    var up = this$0.n4l_1.h1(1);
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0 = p0.r3i_1;
    var y0 = p0.s3i_1;
    var x1 = p1.r3i_1;
    var y1 = p1.s3i_1;
    var tmp$ret$1 = Angle_between(x0, y0, x1, y1, up);
    return new Angle(tmp$ret$1);
  };
}
function Bezier$extrema$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.l4n());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.f2_1;
    var last = this_0.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>' call
        var dim = item;
        var tmp = Companion_getInstance_8();
        // Inline function 'korlibs.datastructure.mapDouble' call
        var this_1 = this$0.m4n().h1(0).n44(dim);
        // Inline function 'kotlin.also' call
        var this_2 = new Float64Array(this_1.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
        var inductionVariable_0 = 0;
        var last_0 = this_1.length;
        if (inductionVariable_0 < last_0)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>.<anonymous>' call
            this_2[n] = this_1[n];
          }
           while (inductionVariable_0 < last_0);
        var out = droots(tmp, this_2);
        if (this$0.k4n() === 3)
          out = combineSmallDistinctSorted(Companion_getInstance_8(), out, droots(Companion_getInstance_8(), this$0.m4n().h1(1).n44(dim)));
        var tmp$ret$3 = out;
        destination.h(tmp$ret$3);
      }
       while (!(item === last));
    var out_0 = destination;
    return new Extrema(out_0.h1(0), out_0.h1(1));
  };
}
function Bezier$outerCircle$delegate$lambda(this$0) {
  return function () {
    return outerCircle(this$0.n4n());
  };
}
function Bezier$boundingBox$delegate$lambda(this$0) {
  return function () {
    return _getBoundingBox(this$0, Companion_getInstance_4().a3m_1);
  };
}
function Bezier$length$delegate$lambda(this$0) {
  return function () {
    var z = 0.5;
    var sum = 0.0;
    var inductionVariable = 0;
    var last = Companion_getInstance_8().r4m_1.length - 1 | 0;
    var tmp;
    if (inductionVariable <= last) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var t = _Ratio___init__impl__9mwvn2(z * Companion_getInstance_8().r4m_1[i] + z);
        var temp = this$0.o4n(t);
        sum = sum + Companion_getInstance_8().s4m_1[i] * temp.a();
      }
       while (inductionVariable <= last);
      tmp = Unit_instance;
    }
    return z * sum;
  };
}
function Bezier$lut$delegate$lambda(this$0) {
  return function () {
    return this$0.p4n();
  };
}
function Bezier$isLinear$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this$0.n4l_1.h1(this$0.k4n());
    var that = this$0.n4l_1.h1(0);
    var baseLength = Vector2D.y3k(this_0.r3i_1 - that.r3i_1, this_0.s3i_1 - that.s3i_1).a();
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var progression = until(0, _get_aligned__7fjidv(this$0).g1());
    var inductionVariable = progression.f2_1;
    var last = progression.g2_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = sum;
        // Inline function 'korlibs.math.geom.bezier.Bezier.isLinear$delegate.<anonymous>.<anonymous>' call
        var it = element;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_1 = _get_aligned__7fjidv(this$0).x3k(it);
        sum = tmp + Math.abs(this_1);
      }
       while (!(element === last));
    return sum < baseLength / 50.0;
  };
}
function Bezier$isSimple$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.k4n() === 3) {
      var a1 = angle(Companion_getInstance_8(), this$0.n4l_1.h1(0), this$0.n4l_1.h1(3), this$0.n4l_1.h1(1));
      var a2 = angle(Companion_getInstance_8(), this$0.n4l_1.h1(0), this$0.n4l_1.h1(3), this$0.n4l_1.h1(2));
      var tmp_0;
      if (a1 > 0.0 && a2 < 0.0 || (a1 < 0.0 && a2 > 0.0)) {
        return false;
      }
      tmp = tmp_0;
    }
    var n1 = this$0.q4n(Companion_getInstance().p27_1);
    var n2 = this$0.q4n(Companion_getInstance().s27_1);
    var s = n1.r3i_1 * n2.r3i_1 + n1.s3i_1 * n2.s3i_1;
    // Inline function 'kotlin.math.abs' call
    // Inline function 'kotlin.math.acos' call
    var x = Math.acos(s);
    return Math.abs(x) < 3.141592653589793 / 3.0;
  };
}
function BezierCurveFromIndices($this, indices, points) {
  var p = new PointArrayList(indices.length);
  var inductionVariable = 0;
  var last = indices.length;
  while (inductionVariable < last) {
    var index = indices[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    p.y44(points, index);
  }
  return Bezier.w4n(p);
}
var Companion_instance_0;
function Companion_getInstance_9() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function _split($this, t, hull, left) {
  var rt = convertRange(t, Companion_getInstance().p27_1, Companion_getInstance().s27_1, $this.h4m_1, $this.i4m_1);
  var rt1 = left ? $this.h4m_1 : rt;
  var rt2 = left ? rt : $this.i4m_1;
  var tmp;
  if ($this.g4m_1.k4n() < 2) {
    var p1 = $this.a4o(rt1);
    var p2 = $this.a4o(rt2);
    tmp = Bezier.t4n(p1, p2);
  } else {
    var indices = left ? Companion_getInstance_9().b4p_1 : Companion_getInstance_9().c4p_1;
    tmp = BezierCurveFromIndices(Companion_getInstance_9(), ensureNotNull(indices.h1($this.g4m_1.k4n())), ensureNotNull(hull));
  }
  var curve = tmp;
  return SubBezier.y4o(curve, rt1, rt2, $this.j4m_1);
}
function _splitLeft($this, t, hull) {
  return _split($this, t, hull, true);
}
function _splitLeft$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.g4m_1.x4o(t) : hull;
  return _splitLeft($this, t, hull);
}
function _splitRight($this, t, hull) {
  return _split($this, t, hull, false);
}
function _splitRight$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.g4m_1.x4o(t) : hull;
  return _splitRight($this, t, hull);
}
function estimateAt($this, values, value, out) {
  var result = binarySearch_0(values, value);
  if (_BSearchResult___get_found__impl__om04iz(result))
    return $this.d4p(out, _BSearchResult___get_index__impl__b5kraz(result), 0.0);
  var index = _BSearchResult___get_nearIndex__impl__s8nq43(result);
  if (value <= 0.0)
    return $this.d4p(out, 0, 0.0);
  if (index >= (values.g1() - 1 | 0))
    return $this.d4p(out, $this.h4o_1.g1() - 1 | 0, 0.0);
  var ratio0 = values.h1(index);
  var ratio1 = values.h1(index + 1 | 0);
  var ratio = convertRange_0(value, ratio0, ratio1, 0.0, 1.0);
  return $this.d4p(out, index, ratio);
}
function CurveLUT$toString$lambda(this$0) {
  return function (it) {
    return '' + this$0.i4o_1.h1(it) + ',len=' + this$0.e4p().h1(it) + ': ' + this$0.h4o_1.h1(it).toString();
  };
}
function toCurves(_this__u8e3s4, closed) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return new Curves(_this__u8e3s4, closed);
}
function toNonCurveSimplePointList(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var curves = _this__u8e3s4;
  var beziers = curves.h4l_1;
  var epsilon = 1.0E-5;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < beziers.g1()) {
    // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var bezier = beziers.h1(_unary__edvuaz);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(bezier.t4o().length === 0))
      return null;
    var points = bezier.n4l_1;
    // Inline function 'korlibs.math.geom.fastForEach' call
    var inductionVariable = 0;
    var last = points.g1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>.<anonymous>' call
        var p = points.h1(n_0);
        if (out.j1() || !out.n3y().l3t(p, epsilon)) {
          out.v44(p);
        }
      }
       while (inductionVariable < last);
  }
  if (out.n3y().l3t(out.m3y(), epsilon)) {
    out.z44(out.g1() - 1 | 0);
  }
  return out;
}
var Arc_instance;
function Arc_getInstance() {
  return Arc_instance;
}
function toVectorPath(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var first = {_v: true};
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.g1()) {
    // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var curves = _this__u8e3s4.h1(_unary__edvuaz);
    if (curves instanceof Curves) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = curves.h4l_1;
      var n_0 = 0;
      while (n_0 < this_0.g1()) {
        // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_0.h1(_unary__edvuaz_0);
        toVectorPath$bezier(first, out, it);
      }
      if (curves.i4l_1) {
        out.p6();
      }
    } else {
      if (curves instanceof Bezier) {
        toVectorPath$bezier(first, out, curves);
      } else {
        throw NotImplementedError.je();
      }
    }
  }
  return out;
}
function toVectorPath_0(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return toVectorPath(listOf(_this__u8e3s4), out);
}
function toBezier(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return Bezier.t4n(Vector2D.y3k(_this__u8e3s4.l3l(), _this__u8e3s4.m3l()), Vector2D.y3k(_this__u8e3s4.n3l(), _this__u8e3s4.o3l()));
}
function toDashes(_this__u8e3s4, pattern, offset) {
  offset = offset === VOID ? 0.0 : offset;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  if (pattern == null)
    return listOf(_this__u8e3s4);
  // Inline function 'kotlin.check' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.all' call
    var inductionVariable = 0;
    var last = pattern.length;
    while (inductionVariable < last) {
      var element = pattern[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.toDashes.<anonymous>' call
      if (!(element <= 0.0)) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!tmp$ret$1) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message = 'Check failed.';
    throw IllegalStateException.h5(toString(message));
  }
  var length = _this__u8e3s4.a();
  var current = offset;
  var dashNow = true;
  var index = 0;
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.z();
  while (current < length) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var len = getCyclic(pattern, _unary__edvuaz);
    if (dashNow) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = _this__u8e3s4.e4m(current, current + len);
      out.h(element_0);
    }
    current = current + len;
    dashNow = !dashNow;
  }
  return out;
}
function toVectorPath$bezier(first, $out, bezier) {
  var points = bezier.n4l_1;
  if (first._v) {
    $out.k4p(points.m3y());
    first._v = false;
  }
  switch (bezier.k4n()) {
    case 1:
      $out.x4p(points.h1(1));
      break;
    case 2:
      $out.y4p(points.h1(1), points.h1(2));
      break;
    case 3:
      $out.l4p(points.h1(1), points.h1(2), points.h1(3));
      break;
    default:
      // Inline function 'kotlin.TODO' call

      throw NotImplementedError.je();
  }
}
function isConvex$delegate$lambda($this$extraPropertyThis) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return $this$extraPropertyThis.j4l_1 || Convex_instance.z4p($this$extraPropertyThis);
}
function isConvex$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return it;
}
function infos$factory() {
  return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
    return receiver.z4l();
  }, null);
}
function length$factory() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function aligned$factory() {
  return getPropertyCallableRef('aligned', 1, KProperty1, function (receiver) {
    return _get_aligned__7fjidv(receiver);
  }, null);
}
function dpoints$factory() {
  return getPropertyCallableRef('dpoints', 1, KProperty1, function (receiver) {
    return receiver.m4n();
  }, null);
}
function extrema$factory() {
  return getPropertyCallableRef('extrema', 1, KProperty1, function (receiver) {
    return receiver.w4m();
  }, null);
}
function outerCircle$factory() {
  return getPropertyCallableRef('outerCircle', 1, KProperty1, function (receiver) {
    return receiver.b4o();
  }, null);
}
function boundingBox$factory() {
  return getPropertyCallableRef('boundingBox', 1, KProperty1, function (receiver) {
    return receiver.n4n();
  }, null);
}
function length$factory_0() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function lut$factory() {
  return getPropertyCallableRef('lut', 1, KProperty1, function (receiver) {
    return receiver.c4o();
  }, null);
}
function xt01$factory() {
  return getPropertyCallableRef('xt01', 1, KProperty1, function (receiver) {
    return receiver.e4n();
  }, null);
}
function yt01$factory() {
  return getPropertyCallableRef('yt01', 1, KProperty1, function (receiver) {
    return receiver.f4n();
  }, null);
}
var properties_initialized__MathGeom_bezier_kt_sxrpnw;
function _init_properties__MathGeom_bezier_kt__br5r2i() {
  if (!properties_initialized__MathGeom_bezier_kt_sxrpnw) {
    properties_initialized__MathGeom_bezier_kt_sxrpnw = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_0 = isConvex$delegate$lambda;
    var transform = isConvex$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.i28_1 = transform;
    isConvex$delegate = this_0;
  }
}
var Companion_instance_1;
function Companion_getInstance_10() {
  return Companion_instance_1;
}
function quickFindPositionForNewNodeBestAreaFit($this, width, height) {
  var score = 1.7976931348623157E308;
  var areaFit;
  var bestNode = Companion_getInstance_1().c3m();
  var _iterator__ex2g4s = $this.d4q_1.b1();
  while (_iterator__ex2g4s.c1()) {
    var r = _iterator__ex2g4s.d1();
    if (r.d3j_1 >= width && r.e3j_1 >= height) {
      areaFit = r.d3j_1 * r.e3j_1 - width * height;
      if (areaFit < score) {
        bestNode = new Rectangle(r.b3j_1, r.c3j_1, width, height);
        score = areaFit;
      }
    }
  }
  return bestNode;
}
function splitFreeNode($this, freeNode, usedNode) {
  var newNode;
  if (usedNode.i3j() >= freeNode.j3j() || usedNode.j3j() <= freeNode.b3j_1 || usedNode.d3q() >= freeNode.c3q() || usedNode.c3q() <= freeNode.d3q()) {
    return false;
  }
  if (usedNode.b3j_1 < freeNode.j3j() && usedNode.j3j() > freeNode.b3j_1) {
    if (usedNode.c3j_1 > freeNode.c3j_1 && usedNode.c3j_1 < freeNode.c3q()) {
      newNode = freeNode.l3r(VOID, VOID, VOID, usedNode.c3j_1 - freeNode.c3j_1);
      $this.d4q_1.h(newNode);
    }
    if (usedNode.c3q() < freeNode.c3q()) {
      newNode = freeNode.l3r(VOID, usedNode.c3q(), VOID, freeNode.c3q() - usedNode.c3q());
      $this.d4q_1.h(newNode);
    }
  }
  if (usedNode.c3j_1 < freeNode.c3q() && usedNode.c3q() > freeNode.c3j_1) {
    if (usedNode.b3j_1 > freeNode.b3j_1 && usedNode.b3j_1 < freeNode.j3j()) {
      newNode = freeNode.l3r(VOID, VOID, usedNode.b3j_1 - freeNode.b3j_1);
      $this.d4q_1.h(newNode);
    }
    if (usedNode.j3j() < freeNode.j3j()) {
      newNode = freeNode.l3r(usedNode.j3j(), VOID, freeNode.j3j() - usedNode.j3j());
      $this.d4q_1.h(newNode);
    }
  }
  return true;
}
function pruneFreeList($this) {
  var len = $this.d4q_1.g1();
  var i = 0;
  while (i < len) {
    var j = i + 1 | 0;
    var tmpRect = $this.d4q_1.h1(i);
    $l$loop: while (j < len) {
      var tmpRect2 = $this.d4q_1.h1(j);
      if (Companion_getInstance_1().q3q(tmpRect, tmpRect2)) {
        $this.d4q_1.j3(i);
        i = i - 1 | 0;
        len = len - 1 | 0;
        break $l$loop;
      }
      if (Companion_getInstance_1().q3q(tmpRect2, tmpRect)) {
        $this.d4q_1.j3(j);
        len = len - 1 | 0;
        j = j - 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
}
var HitTestDirection_ANY_instance;
var HitTestDirection_UP_instance;
var HitTestDirection_RIGHT_instance;
var HitTestDirection_DOWN_instance;
var HitTestDirection_LEFT_instance;
var Companion_instance_2;
function Companion_getInstance_11() {
  return Companion_instance_2;
}
var HitTestDirection_entriesInitialized;
function HitTestDirection_initEntries() {
  if (HitTestDirection_entriesInitialized)
    return Unit_instance;
  HitTestDirection_entriesInitialized = true;
  HitTestDirection_ANY_instance = new HitTestDirection('ANY', 0);
  HitTestDirection_UP_instance = new HitTestDirection('UP', 1);
  HitTestDirection_RIGHT_instance = new HitTestDirection('RIGHT', 2);
  HitTestDirection_DOWN_instance = new HitTestDirection('DOWN', 3);
  HitTestDirection_LEFT_instance = new HitTestDirection('LEFT', 4);
}
function HitTestDirection_ANY_getInstance() {
  HitTestDirection_initEntries();
  return HitTestDirection_ANY_instance;
}
var Convex_instance;
function Convex_getInstance() {
  return Convex_instance;
}
var SliceRotation_R0_instance;
var SliceRotation_R90_instance;
var SliceRotation_R180_instance;
var SliceRotation_R270_instance;
var Companion_instance_3;
function Companion_getInstance_12() {
  SliceRotation_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function values() {
  return [SliceRotation_R0_getInstance(), SliceRotation_R90_getInstance(), SliceRotation_R180_getInstance(), SliceRotation_R270_getInstance()];
}
var SliceRotation_entriesInitialized;
function SliceRotation_initEntries() {
  if (SliceRotation_entriesInitialized)
    return Unit_instance;
  SliceRotation_entriesInitialized = true;
  SliceRotation_R0_instance = new SliceRotation('R0', 0);
  SliceRotation_R90_instance = new SliceRotation('R90', 1);
  SliceRotation_R180_instance = new SliceRotation('R180', 2);
  SliceRotation_R270_instance = new SliceRotation('R270', 3);
  Companion_getInstance_12();
}
function _SliceOrientation___init__impl__ewylib(raw) {
  return raw;
}
function _SliceOrientation___get_raw__impl__tj3u8w($this) {
  return $this;
}
function _SliceOrientation___get_rotation__impl__m65r0o($this) {
  return Companion_getInstance_12().h1(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 2));
}
function _SliceOrientation___get_flipX__impl__lgb7bx($this) {
  return !(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 2, 1) === 0);
}
function _SliceOrientation___init__impl__ewylib_0(rotation, flipX) {
  rotation = rotation === VOID ? SliceRotation_R0_getInstance() : rotation;
  flipX = flipX === VOID ? false : flipX;
  return _SliceOrientation___init__impl__ewylib(insert_0(insert(0, rotation.p3_1, 0, 2), flipX, 2));
}
function _SliceOrientation___get_indices__impl__km5on3($this) {
  return Companion_getInstance_13().w4q_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
function _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this) {
  return _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R90_getInstance()) || _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R270_getInstance());
}
function SliceOrientation__toString_impl_tdph6r($this) {
  return Companion_getInstance_13().x4q_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
var Companion_instance_4;
function Companion_getInstance_13() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function SliceOrientation__hashCode_impl_7mjkdw($this) {
  return $this;
}
function SliceOrientation__equals_impl_h4gywg($this, other) {
  if (!(other instanceof SliceOrientation))
    return false;
  if (!($this === (other instanceof SliceOrientation ? other.h4r_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_5;
function Companion_getInstance_14() {
  return Companion_instance_5;
}
function transformed_1(_this__u8e3s4, orientation) {
  var i = _SliceOrientation___get_indices__impl__km5on3(orientation);
  return new RectCoords(_this__u8e3s4.m4t(i[0]), _this__u8e3s4.n4t(i[0]), _this__u8e3s4.m4t(i[1]), _this__u8e3s4.n4t(i[1]), _this__u8e3s4.m4t(i[2]), _this__u8e3s4.n4t(i[2]), _this__u8e3s4.m4t(i[3]), _this__u8e3s4.n4t(i[3]));
}
function splitInRows(_this__u8e3s4, width, height) {
  return split(_this__u8e3s4, width, height, true);
}
function split(_this__u8e3s4, width, height, inRows) {
  var nheight = _this__u8e3s4.s4r_1 / height | 0;
  var nwidth = _this__u8e3s4.r4r_1 / width | 0;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.collections.arrayListOf' call
  var this_0 = ArrayList.z();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.slice.split.<anonymous>' call
  if (inRows) {
    var inductionVariable = 0;
    if (inductionVariable < nheight)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < nwidth)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this_0.h(_this__u8e3s4.z4s(imul(x, width), imul(y, height), width, height));
          }
           while (inductionVariable_0 < nwidth);
      }
       while (inductionVariable < nheight);
  } else {
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < nwidth)
      do {
        var x_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < nheight)
          do {
            var y_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            this_0.h(_this__u8e3s4.z4s(imul(x_0, width), imul(y_0, height), width, height));
          }
           while (inductionVariable_2 < nheight);
      }
       while (inductionVariable_1 < nwidth);
  }
  return this_0;
}
function SliceRotation_R0_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R0_instance;
}
function SliceRotation_R90_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R90_instance;
}
function SliceRotation_R180_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R180_instance;
}
function SliceRotation_R270_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R270_instance;
}
function PolygonScanline$AllBuckets$pool$lambda(it) {
  it.ai();
  return Unit_instance;
}
function PolygonScanline$AllBuckets$pool$lambda_0(it) {
  return new Bucket();
}
function addPoint($this, x, y) {
  $this.k4v_1.u44(x, y);
}
function addEdge($this, ax, ay, bx, by) {
  if (ax === bx && ay === by)
    return Unit_instance;
  var isHorizontal = ay === by;
  var iax = $this.t4v(ax);
  var ibx = $this.t4v(bx);
  var iay = $this.t4v(ay);
  var iby = $this.t4v(by);
  var edge = ay < by ? $this.e4v_1.f42().u4v(iax, iay, ibx, iby, 1) : $this.e4v_1.f42().u4v(ibx, iby, iax, iay, -1);
  $this.h4v_1.h(edge);
  if (isHorizontal) {
    $this.g4v_1.h(edge);
  } else {
    $this.f4v_1.h(edge);
    $this.i4v_1.a4v(edge);
  }
  $this.d4v_1 = BoundsBuilder__plus_impl_cz7f7x($this.d4v_1, Vector2D.y3k(ax, ay));
  $this.d4v_1 = BoundsBuilder__plus_impl_cz7f7x($this.d4v_1, Vector2D.y3k(bx, by));
}
var IntArrayListSort_instance;
function IntArrayListSort_getInstance() {
  if (IntArrayListSort_instance === VOID)
    new IntArrayListSort();
  return IntArrayListSort_instance;
}
function PolygonScanline$edgesPool$lambda(it) {
  return new MEdge();
}
var Companion_instance_6;
function Companion_getInstance_15() {
  return Companion_instance_6;
}
var Companion_instance_7;
function Companion_getInstance_16() {
  return Companion_instance_7;
}
var EdgePoint_A_instance;
var EdgePoint_B_instance;
var EdgePoint_entriesInitialized;
function EdgePoint_initEntries() {
  if (EdgePoint_entriesInitialized)
    return Unit_instance;
  EdgePoint_entriesInitialized = true;
  EdgePoint_A_instance = new EdgePoint('A', 0, 0);
  EdgePoint_B_instance = new EdgePoint('B', 1, 1);
}
function _get_outFill__zcv64g($this) {
  var tmp = $this.y4w_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('outFill');
  }
}
function EdgePoint_A_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_A_instance;
}
function EdgePoint_B_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_B_instance;
}
function strokeToFill(_this__u8e3s4, lineWidth, joins, startCap, endCap, miterLimit, lineDash, lineDashOffset, temp, outFill) {
  joins = joins === VOID ? LineJoin_MITER_getInstance() : joins;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? startCap : endCap;
  miterLimit = miterLimit === VOID ? 4.0 : miterLimit;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = toCurvesList(_this__u8e3s4);
    var destination = ArrayList.z();
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var list = toDashes(element, lineDash.y27(), lineDashOffset);
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.b1();
    while (tmp0_iterator_0.c1()) {
      var item = tmp0_iterator_0.d1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var tmp$ret$3 = toVectorPath_0(item);
      destination_0.h(tmp$ret$3);
    }
    tmp = destination_0;
  } else {
    tmp = listOf(_this__u8e3s4);
  }
  var strokePaths = tmp;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < strokePaths.g1()) {
    // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var strokePath = strokePaths.h1(_unary__edvuaz);
    temp.g4y(strokePath, lineWidth, joins, startCap, endCap, miterLimit, outFill);
  }
  return outFill;
}
function strokeToFill_0(_this__u8e3s4, info, temp, outFill) {
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  return strokeToFill(_this__u8e3s4, info.h4y_1, info.m4y_1, info.k4y_1, info.l4y_1, info.n4y_1, info.o4y_1, info.p4y_1, temp, outFill);
}
function t($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.t4y_1;
    if (this_0.g3j()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.y3k(this_0.r3m(p.r3i_1, p.s3i_1), this_0.u3m(p.r3i_1, p.s3i_1));
  }
  return tmp$ret$0;
}
var _bvhCurvesCacheVersion$delegate;
var _bvhCurvesCache$delegate;
function set__curvesCacheVersion(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCacheVersion$delegate;
  var property = _curvesCacheVersion$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCacheVersion(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCacheVersion$delegate;
    var property = _curvesCacheVersion$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCacheVersion$delegate;
function set__curvesCache(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCache$delegate;
  var property = _curvesCache$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCache(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCache$delegate;
    var property = _curvesCache$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCache$delegate;
var Companion_instance_8;
function Companion_getInstance_17() {
  return Companion_instance_8;
}
function ensureMoveTo($this, p) {
  if ($this.d1t())
    return false;
  $this.k4p(p);
  return true;
}
function getCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  if (!(get__curvesCacheVersion(_this__u8e3s4) === _this__u8e3s4.s4p_1)) {
    set__curvesCacheVersion(_this__u8e3s4, _this__u8e3s4.s4p_1);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.z();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>' call
    var currentClosed = {_v: false};
    // Inline function 'kotlin.collections.arrayListOf' call
    var current = {_v: ArrayList.z()};
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges' call
    var m = Vector2D.i3l();
    var l = Vector2D.i3l();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = _this__u8e3s4.n4p_1;
    var n_0 = 0;
    while (n_0 < this_1.g1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.x27(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.y3k(tmp, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_1));
          m = it;
          l = it;
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.y3k(tmp_0, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_2 = current._v;
          var element = Bezier.t4n(p1, it_0);
          this_2.h(element);
          l = it_0;
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var p1_0 = Vector2D.y3k(tmp_1, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p2 = Vector2D.y3k(tmp_2, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_7));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_3 = current._v;
          var element_0 = Bezier.u4n(p1_1, p1_0, p2);
          this_3.h(element_0);
          l = p2;
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var p1_2 = Vector2D.y3k(tmp_3, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var p2_0 = Vector2D.y3k(tmp_4, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = _this__u8e3s4.o4p_1.h1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p3 = Vector2D.y3k(tmp_5, _this__u8e3s4.o4p_1.h1(_unary__edvuaz_13));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_3 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_4 = current._v;
          var element_1 = Bezier.v4n(p1_3, p1_2, p2_0, p3);
          this_4.h(element_1);
          l = p3;
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var equal = true ? l.g27(m) : l.equals(m);
          if (!equal) {
            // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call
            var p1_4 = l;
            var p2_1 = m;
            // Inline function 'kotlin.collections.plusAssign' call
            var this_5 = current._v;
            var element_2 = Bezier.t4n(p1_4, p2_1);
            this_5.h(element_2);
          }

          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          currentClosed._v = true;
          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
      }
    }
    getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
    set__curvesCache(_this__u8e3s4, this_0);
  }
  return ensureNotNull(get__curvesCache(_this__u8e3s4));
}
function plus(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return with_0(_this__u8e3s4, path);
}
function with_0(_this__u8e3s4, path, transform) {
  transform = transform === VOID ? Companion_getInstance_4().a3m_1 : transform;
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var bb = {_v: new BoundsBuilder(_this__u8e3s4)};
  var curvesList = getCurvesList(path);
  if (curvesList.j1() && path.d1t()) {
    path.i4z(new with$1(bb));
  }
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < curvesList.g1()) {
    // Inline function 'korlibs.math.geom.vector.with.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = curvesList.h1(_unary__edvuaz).h4l_1;
    var n_0 = 0;
    while (n_0 < this_0.g1()) {
      // Inline function 'korlibs.math.geom.vector.with.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var bezier = this_0.h1(_unary__edvuaz_0);
      bb._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x_0(bb._v.c3k_1, bezier.z4n(transform)));
    }
  }
  return bb._v.c3k_1;
}
function write(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.n4p_1;
  var n_0 = 0;
  while (n_0 < this_0.g1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.x27(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.o4p_1.h1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.y3k(tmp, path.o4p_1.h1(_unary__edvuaz_1));
        _this__u8e3s4.k4p(it);
        break;
      case 1:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.o4p_1.h1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.y3k(tmp_0, path.o4p_1.h1(_unary__edvuaz_3));
        _this__u8e3s4.x4p(it_0);
        break;
      case 2:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.o4p_1.h1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var p1 = Vector2D.y3k(tmp_1, path.o4p_1.h1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.o4p_1.h1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var p2 = Vector2D.y3k(tmp_2, path.o4p_1.h1(_unary__edvuaz_7));
        _this__u8e3s4.y4p(p1, p2);
        break;
      case 3:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.o4p_1.h1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var p1_0 = Vector2D.y3k(tmp_3, path.o4p_1.h1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.o4p_1.h1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var p2_0 = Vector2D.y3k(tmp_4, path.o4p_1.h1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.o4p_1.h1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var p3 = Vector2D.y3k(tmp_5, path.o4p_1.h1(_unary__edvuaz_13));
        _this__u8e3s4.l4p(p1_0, p2_0, p3);
        break;
      case 4:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        _this__u8e3s4.p6();
        break;
    }
  }
}
function getCurves(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var curvesList = getCurvesList(_this__u8e3s4);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.z();
  var tmp0_iterator = curvesList.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.math.geom.vector.getCurves.<anonymous>' call
    var list = element.h4l_1;
    addAll(destination, list);
  }
  var tmp = destination;
  var tmp59_safe_receiver = lastOrNull(curvesList);
  var tmp0_elvis_lhs = tmp59_safe_receiver == null ? null : tmp59_safe_receiver.i4l_1;
  return toCurves(tmp, tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
}
function toCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return getCurvesList(_this__u8e3s4);
}
function applyTransform(_this__u8e3s4, m) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp;
  if (m.h3j()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, _this__u8e3s4.o4p_1.g1()), 2);
    var inductionVariable = progression.f2_1;
    var last = progression.g2_1;
    var step_0 = progression.h2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.applyTransform.<anonymous>' call
        var it = Vector2D.y3k(_this__u8e3s4.o4p_1.h1(n + 0 | 0), _this__u8e3s4.o4p_1.h1(n + 1 | 0));
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          if (m.g3j()) {
            tmp$ret$0 = it;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.y3k(m.r3m(it.r3i_1, it.s3i_1), m.u3m(it.r3i_1, it.s3i_1));
        }
        var p = tmp$ret$0;
        _this__u8e3s4.o4p_1.q3x(n + 0 | 0, p.r3i_1);
        _this__u8e3s4.o4p_1.q3x(n + 1 | 0, p.s3i_1);
      }
       while (!(n === last));
    _this__u8e3s4.s4p_1 = _this__u8e3s4.s4p_1 + 1 | 0;
    tmp = _this__u8e3s4;
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function getCurvesList$_anonymous_$flush_1e57i7(current, $out, currentClosed, $this_getCurvesList) {
  if (current._v.j1())
    return Unit_instance;
  // Inline function 'kotlin.also' call
  var this_0 = new Curves(current._v, currentClosed._v);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>$flush.<anonymous>' call
  this_0.j4l_1 = $this_getCurvesList.r4p_1;
  $out.h(this_0);
  currentClosed._v = false;
  // Inline function 'kotlin.collections.arrayListOf' call
  current._v = ArrayList.z();
}
function _bvhCurvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _bvhCurvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _curvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$factory() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCacheVersion$factory_0() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCache$factory() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
function _curvesCache$factory_0() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
var properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk;
function _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe() {
  if (!properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk) {
    properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _bvhCurvesCacheVersion$delegate$lambda;
    _bvhCurvesCacheVersion$delegate = new Property(null, default_0);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_1 = _bvhCurvesCache$delegate$lambda;
    _bvhCurvesCache$delegate = new Property(null, default_1);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_2 = _curvesCacheVersion$delegate$lambda;
    _curvesCacheVersion$delegate = new Property(null, default_2);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_3 = _curvesCache$delegate$lambda;
    _curvesCache$delegate = new Property(null, default_3);
  }
}
var Winding_EVEN_ODD_instance;
var Winding_NON_ZERO_instance;
var Companion_instance_9;
function Companion_getInstance_18() {
  return Companion_instance_9;
}
var Winding_entriesInitialized;
function Winding_initEntries() {
  if (Winding_entriesInitialized)
    return Unit_instance;
  Winding_entriesInitialized = true;
  Winding_EVEN_ODD_instance = new Winding('EVEN_ODD', 0, 'evenOdd');
  Winding_NON_ZERO_instance = new Winding('NON_ZERO', 1, 'nonZero');
}
var LineJoin_BEVEL_instance;
var LineJoin_ROUND_instance;
var LineJoin_MITER_instance;
var Companion_instance_10;
function Companion_getInstance_19() {
  return Companion_instance_10;
}
var LineJoin_entriesInitialized;
function LineJoin_initEntries() {
  if (LineJoin_entriesInitialized)
    return Unit_instance;
  LineJoin_entriesInitialized = true;
  LineJoin_BEVEL_instance = new LineJoin('BEVEL', 0);
  LineJoin_ROUND_instance = new LineJoin('ROUND', 1);
  LineJoin_MITER_instance = new LineJoin('MITER', 2);
}
var LineCap_BUTT_instance;
var LineCap_SQUARE_instance;
var LineCap_ROUND_instance;
var Companion_instance_11;
function Companion_getInstance_20() {
  return Companion_instance_11;
}
var LineCap_entriesInitialized;
function LineCap_initEntries() {
  if (LineCap_entriesInitialized)
    return Unit_instance;
  LineCap_entriesInitialized = true;
  LineCap_BUTT_instance = new LineCap('BUTT', 0);
  LineCap_SQUARE_instance = new LineCap('SQUARE', 1);
  LineCap_ROUND_instance = new LineCap('ROUND', 2);
}
var LineScaleMode_NONE_instance;
var LineScaleMode_HORIZONTAL_instance;
var LineScaleMode_VERTICAL_instance;
var LineScaleMode_NORMAL_instance;
var LineScaleMode_entriesInitialized;
function LineScaleMode_initEntries() {
  if (LineScaleMode_entriesInitialized)
    return Unit_instance;
  LineScaleMode_entriesInitialized = true;
  LineScaleMode_NONE_instance = new LineScaleMode('NONE', 0, false, false);
  LineScaleMode_HORIZONTAL_instance = new LineScaleMode('HORIZONTAL', 1, true, false);
  LineScaleMode_VERTICAL_instance = new LineScaleMode('VERTICAL', 2, false, true);
  LineScaleMode_NORMAL_instance = new LineScaleMode('NORMAL', 3, true, true);
}
var Companion_instance_12;
function Companion_getInstance_21() {
  return Companion_instance_12;
}
function Winding_EVEN_ODD_getInstance() {
  Winding_initEntries();
  return Winding_EVEN_ODD_instance;
}
function Winding_NON_ZERO_getInstance() {
  Winding_initEntries();
  return Winding_NON_ZERO_instance;
}
function LineJoin_BEVEL_getInstance() {
  LineJoin_initEntries();
  return LineJoin_BEVEL_instance;
}
function LineJoin_MITER_getInstance() {
  LineJoin_initEntries();
  return LineJoin_MITER_instance;
}
function LineCap_BUTT_getInstance() {
  LineCap_initEntries();
  return LineCap_BUTT_instance;
}
function LineCap_SQUARE_getInstance() {
  LineCap_initEntries();
  return LineCap_SQUARE_instance;
}
function LineScaleMode_NORMAL_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NORMAL_instance;
}
function MPoint$Companion$POOL$lambda(it) {
  it.b50(0.0, 0.0);
  return Unit_instance;
}
function MPoint$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_22().c3m();
}
var Companion_instance_13;
function Companion_getInstance_22() {
  if (Companion_instance_13 === VOID)
    new Companion_13();
  return Companion_instance_13;
}
function MMatrix$Companion$POOL$lambda(it) {
  it.l50();
  return Unit_instance;
}
function MMatrix$Companion$POOL$lambda_0(it) {
  return new MMatrix();
}
var Companion_instance_14;
function Companion_getInstance_23() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_24() {
  return Companion_instance_15;
}
function MRectangle$Companion$POOL$lambda(it) {
  it.ai();
  return Unit_instance;
}
function MRectangle$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_25().c3m();
}
var Companion_instance_16;
function Companion_getInstance_25() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
function get_immutable(_this__u8e3s4) {
  return _this__u8e3s4;
}
function get_mutable(_this__u8e3s4) {
  return new MRectangle(_this__u8e3s4.b3j_1, _this__u8e3s4.c3j_1, _this__u8e3s4.d3j_1, _this__u8e3s4.e3j_1);
}
function toMatrix4(_this__u8e3s4) {
  if (_this__u8e3s4.g3j())
    return Companion_getInstance_7().b3p_1;
  return Companion_getInstance_7().e3p(_this__u8e3s4.e3m_1, _this__u8e3s4.g3m_1, 0.0, _this__u8e3s4.i3m_1, _this__u8e3s4.f3m_1, _this__u8e3s4.h3m_1, 0.0, _this__u8e3s4.j3m_1, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
}
function floorCeil(v) {
  var tmp;
  if (v < 0.0) {
    // Inline function 'kotlin.math.ceil' call
    tmp = Math.ceil(v);
  } else {
    // Inline function 'kotlin.math.floor' call
    tmp = Math.floor(v);
  }
  return tmp;
}
function get__ALL_LIST() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.getValue' call
  var this_0 = _ALL_LIST$delegate;
  _ALL_LIST$factory();
  return this_0.w1();
}
var _ALL_LIST$delegate;
function get__ALL() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.getValue' call
  var this_0 = _ALL$delegate;
  _ALL$factory();
  return this_0.w1();
}
var _ALL$delegate;
var Easings_SMOOTH_instance;
var Easings_EASE_IN_ELASTIC_instance;
var Easings_EASE_OUT_ELASTIC_instance;
var Easings_EASE_OUT_BOUNCE_instance;
var Easings_LINEAR_instance;
var Easings_EASE_instance;
var Easings_EASE_IN_instance;
var Easings_EASE_OUT_instance;
var Easings_EASE_IN_OUT_instance;
var Easings_EASE_IN_OLD_instance;
var Easings_EASE_OUT_OLD_instance;
var Easings_EASE_IN_OUT_OLD_instance;
var Easings_EASE_OUT_IN_OLD_instance;
var Easings_EASE_IN_BACK_instance;
var Easings_EASE_OUT_BACK_instance;
var Easings_EASE_IN_OUT_BACK_instance;
var Easings_EASE_OUT_IN_BACK_instance;
var Easings_EASE_IN_OUT_ELASTIC_instance;
var Easings_EASE_OUT_IN_ELASTIC_instance;
var Easings_EASE_IN_BOUNCE_instance;
var Easings_EASE_IN_OUT_BOUNCE_instance;
var Easings_EASE_OUT_IN_BOUNCE_instance;
var Easings_EASE_IN_QUAD_instance;
var Easings_EASE_OUT_QUAD_instance;
var Easings_EASE_IN_OUT_QUAD_instance;
var Easings_EASE_SINE_instance;
var Easings_EASE_CLAMP_START_instance;
var Easings_EASE_CLAMP_END_instance;
var Easings_EASE_CLAMP_MIDDLE_instance;
function values_0() {
  return [Easings_SMOOTH_getInstance(), Easings_EASE_IN_ELASTIC_getInstance(), Easings_EASE_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_BOUNCE_getInstance(), Easings_LINEAR_getInstance(), Easings_EASE_getInstance(), Easings_EASE_IN_getInstance(), Easings_EASE_OUT_getInstance(), Easings_EASE_IN_OUT_getInstance(), Easings_EASE_IN_OLD_getInstance(), Easings_EASE_OUT_OLD_getInstance(), Easings_EASE_IN_OUT_OLD_getInstance(), Easings_EASE_OUT_IN_OLD_getInstance(), Easings_EASE_IN_BACK_getInstance(), Easings_EASE_OUT_BACK_getInstance(), Easings_EASE_IN_OUT_BACK_getInstance(), Easings_EASE_OUT_IN_BACK_getInstance(), Easings_EASE_IN_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_IN_ELASTIC_getInstance(), Easings_EASE_IN_BOUNCE_getInstance(), Easings_EASE_IN_OUT_BOUNCE_getInstance(), Easings_EASE_OUT_IN_BOUNCE_getInstance(), Easings_EASE_IN_QUAD_getInstance(), Easings_EASE_OUT_QUAD_getInstance(), Easings_EASE_IN_OUT_QUAD_getInstance(), Easings_EASE_SINE_getInstance(), Easings_EASE_CLAMP_START_getInstance(), Easings_EASE_CLAMP_END_getInstance(), Easings_EASE_CLAMP_MIDDLE_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_0());
  return $ENTRIES;
}
var Easings_entriesInitialized;
function Easings_initEntries() {
  if (Easings_entriesInitialized)
    return Unit_instance;
  Easings_entriesInitialized = true;
  Easings_SMOOTH_instance = new Easings$SMOOTH();
  Easings_EASE_IN_ELASTIC_instance = new Easings$EASE_IN_ELASTIC();
  Easings_EASE_OUT_ELASTIC_instance = new Easings$EASE_OUT_ELASTIC();
  Easings_EASE_OUT_BOUNCE_instance = new Easings$EASE_OUT_BOUNCE();
  Easings_LINEAR_instance = new Easings$LINEAR();
  Easings_EASE_instance = new Easings$EASE();
  Easings_EASE_IN_instance = new Easings$EASE_IN();
  Easings_EASE_OUT_instance = new Easings$EASE_OUT();
  Easings_EASE_IN_OUT_instance = new Easings$EASE_IN_OUT();
  Easings_EASE_IN_OLD_instance = new Easings$EASE_IN_OLD();
  Easings_EASE_OUT_OLD_instance = new Easings$EASE_OUT_OLD();
  Easings_EASE_IN_OUT_OLD_instance = new Easings$EASE_IN_OUT_OLD();
  Easings_EASE_OUT_IN_OLD_instance = new Easings$EASE_OUT_IN_OLD();
  Easings_EASE_IN_BACK_instance = new Easings$EASE_IN_BACK();
  Easings_EASE_OUT_BACK_instance = new Easings$EASE_OUT_BACK();
  Easings_EASE_IN_OUT_BACK_instance = new Easings$EASE_IN_OUT_BACK();
  Easings_EASE_OUT_IN_BACK_instance = new Easings$EASE_OUT_IN_BACK();
  Easings_EASE_IN_OUT_ELASTIC_instance = new Easings$EASE_IN_OUT_ELASTIC();
  Easings_EASE_OUT_IN_ELASTIC_instance = new Easings$EASE_OUT_IN_ELASTIC();
  Easings_EASE_IN_BOUNCE_instance = new Easings$EASE_IN_BOUNCE();
  Easings_EASE_IN_OUT_BOUNCE_instance = new Easings$EASE_IN_OUT_BOUNCE();
  Easings_EASE_OUT_IN_BOUNCE_instance = new Easings$EASE_OUT_IN_BOUNCE();
  Easings_EASE_IN_QUAD_instance = new Easings$EASE_IN_QUAD();
  Easings_EASE_OUT_QUAD_instance = new Easings$EASE_OUT_QUAD();
  Easings_EASE_IN_OUT_QUAD_instance = new Easings$EASE_IN_OUT_QUAD();
  Easings_EASE_SINE_instance = new Easings$EASE_SINE();
  Easings_EASE_CLAMP_START_instance = new Easings$EASE_CLAMP_START();
  Easings_EASE_CLAMP_END_instance = new Easings$EASE_CLAMP_END();
  Easings_EASE_CLAMP_MIDDLE_instance = new Easings$EASE_CLAMP_MIDDLE();
}
var $ENTRIES;
function calc($this, it) {
  var t = toRatio_1(it);
  var p = $this.r51_1;
  var order = p.length - 1 | 0;
  if (equals(t, Companion_getInstance().p27_1))
    return p[0];
  if (equals(t, Companion_getInstance().s27_1))
    return p[order];
  if (order === 0)
    return p[0];
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance().s27_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var a = mt2 * mt;
  // Inline function 'korlibs.math.interpolation.times' call
  var b = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
  var c = mt * t2 * 3;
  var d = Ratio__times_impl_ucdh7y(t, t2);
  return p[0].u3q(a).t53(p[1].u3q(b)).t53(p[2].u3q(c)).t53(p[3].u3q(d));
}
function get_EASE_IN_OUT_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_QUAD_getInstance();
}
function get_EASE_OUT_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_OUT_QUAD_getInstance();
}
function get_EASE_IN_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_QUAD_getInstance();
}
function get_ALL(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return get__ALL();
}
function _ALL_LIST$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  return get_entries();
}
function _ALL$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get__ALL_LIST();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.xc(capacity);
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'korlibs.math.interpolation._ALL$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$0 = element.o3_1;
    destination.k3(tmp$ret$0, element);
  }
  return destination;
}
function Easings_SMOOTH_getInstance() {
  Easings_initEntries();
  return Easings_SMOOTH_instance;
}
function Easings_EASE_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_ELASTIC_instance;
}
function Easings_EASE_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BOUNCE_instance;
}
function Easings_LINEAR_getInstance() {
  Easings_initEntries();
  return Easings_LINEAR_instance;
}
function Easings_EASE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_instance;
}
function Easings_EASE_IN_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_instance;
}
function Easings_EASE_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_instance;
}
function Easings_EASE_IN_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_instance;
}
function Easings_EASE_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OLD_instance;
}
function Easings_EASE_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_OLD_instance;
}
function Easings_EASE_IN_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_OLD_instance;
}
function Easings_EASE_OUT_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_OLD_instance;
}
function Easings_EASE_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BACK_instance;
}
function Easings_EASE_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BACK_instance;
}
function Easings_EASE_IN_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BACK_instance;
}
function Easings_EASE_OUT_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BACK_instance;
}
function Easings_EASE_IN_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_ELASTIC_instance;
}
function Easings_EASE_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BOUNCE_instance;
}
function Easings_EASE_IN_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BOUNCE_instance;
}
function Easings_EASE_OUT_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BOUNCE_instance;
}
function Easings_EASE_IN_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_QUAD_instance;
}
function Easings_EASE_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_QUAD_instance;
}
function Easings_EASE_IN_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_QUAD_instance;
}
function Easings_EASE_SINE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_SINE_instance;
}
function Easings_EASE_CLAMP_START_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_START_instance;
}
function Easings_EASE_CLAMP_END_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_END_instance;
}
function Easings_EASE_CLAMP_MIDDLE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_MIDDLE_instance;
}
function _ALL_LIST$factory() {
  return getPropertyCallableRef('_ALL_LIST', 0, KProperty0, function () {
    return get__ALL_LIST();
  }, null);
}
function _ALL$factory() {
  return getPropertyCallableRef('_ALL', 0, KProperty0, function () {
    return get__ALL();
  }, null);
}
var properties_initialized_Easings_kt_w5y1uw;
function _init_properties_Easings_kt__swvzhy() {
  if (!properties_initialized_Easings_kt_w5y1uw) {
    properties_initialized_Easings_kt_w5y1uw = true;
    var tmp = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL_LIST$delegate = lazy_0(tmp, _ALL_LIST$delegate$lambda);
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL$delegate = lazy_0(tmp_0, _ALL$delegate$lambda);
  }
}
function get_niceStr_0(_this__u8e3s4) {
  return get_niceStr(Ratio__toDouble_impl_o7epze(_this__u8e3s4));
}
//region block: post-declaration
initMetadataForClass(IntSegmentSet, 'IntSegmentSet', IntSegmentSet);
initMetadataForClass(CurveInfo, 'CurveInfo');
initMetadataForClass(Curves, 'Curves');
protoOf(ProjectedPoint).g27 = isAlmostEquals$default;
initMetadataForClass(ProjectedPoint, 'ProjectedPoint', ProjectedPoint, VOID, [IsAlmostEquals]);
initMetadataForClass(Extrema, 'Extrema');
initMetadataForCompanion(Companion);
protoOf(Bezier).g27 = isAlmostEquals$default;
initMetadataForClass(Bezier, 'Bezier', Bezier.s4n, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SubBezier, 'SubBezier');
initMetadataForClass(ClosestResult, 'ClosestResult');
initMetadataForClass(Estimation, 'Estimation', Estimation);
initMetadataForClass(CurveLUT, 'CurveLUT');
initMetadataForObject(Arc, 'Arc');
initMetadataForCompanion(Companion_1);
initMetadataForClass(ImageDoNotFitException, 'ImageDoNotFitException');
initMetadataForClass(BinPacker, 'BinPacker');
initMetadataForClass(MaxRects, 'MaxRects');
initMetadataForCompanion(Companion_2);
initMetadataForClass(HitTestDirection, 'HitTestDirection');
initMetadataForObject(Convex, 'Convex');
initMetadataForClass(AbstractShape2D, 'AbstractShape2D');
initMetadataForCompanion(Companion_3);
initMetadataForClass(SliceRotation, 'SliceRotation');
initMetadataForCompanion(Companion_4);
initMetadataForClass(SliceOrientation, 'SliceOrientation');
initMetadataForInterface(SliceCoords, 'SliceCoords');
initMetadataForInterface(SliceCoordsWithBase, 'SliceCoordsWithBase', VOID, VOID, [SliceCoords]);
initMetadataForInterface(SliceCoordsWithBaseAndRect, 'SliceCoordsWithBaseAndRect', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectSlice).i3j = get_left;
protoOf(RectSlice).d3q = get_top;
protoOf(RectSlice).j3j = get_right;
protoOf(RectSlice).c3q = get_bottom;
protoOf(RectSlice).x3r = get_area;
protoOf(RectSlice).k4t = get_frameOffsetX;
protoOf(RectSlice).l4t = get_frameOffsetY;
protoOf(RectSlice).m4t = x;
protoOf(RectSlice).n4t = y;
initMetadataForClass(RectSlice, 'RectSlice', VOID, VOID, [SliceCoordsWithBaseAndRect]);
initMetadataForCompanion(Companion_5);
protoOf(SliceCoordsImpl).k4t = get_frameOffsetX;
protoOf(SliceCoordsImpl).l4t = get_frameOffsetY;
protoOf(SliceCoordsImpl).m4t = x;
protoOf(SliceCoordsImpl).n4t = y;
initMetadataForClass(SliceCoordsImpl, 'SliceCoordsImpl', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectCoords).m4t = x;
protoOf(RectCoords).n4t = y;
initMetadataForClass(RectCoords, 'RectCoords', VOID, VOID, [SliceCoords]);
initMetadataForClass(Bucket, 'Bucket', Bucket);
initMetadataForClass(Buckets, 'Buckets');
initMetadataForClass(AllBuckets, 'AllBuckets', AllBuckets);
initMetadataForClass(XWithWind, 'XWithWind', XWithWind);
initMetadataForObject(IntArrayListSort, 'IntArrayListSort');
initMetadataForClass(RastScale, 'RastScale', RastScale);
initMetadataForClass(PolygonScanline, 'PolygonScanline', PolygonScanline);
initMetadataForCompanion(Companion_6);
initMetadataForCompanion(Companion_7);
initMetadataForClass(MEdge, 'MEdge', MEdge);
initMetadataForClass(EdgePoint, 'EdgePoint');
initMetadataForClass(StrokeToFill, 'StrokeToFill', StrokeToFill);
initMetadataForInterface(VectorBuilder, 'VectorBuilder');
protoOf(VectorBuilder$transformed$1).w4y = line;
protoOf(VectorBuilder$transformed$1).x4y = rect;
protoOf(VectorBuilder$transformed$1).y4y = rect_0;
protoOf(VectorBuilder$transformed$1).z4y = rect_1;
protoOf(VectorBuilder$transformed$1).a4z = rect_2;
protoOf(VectorBuilder$transformed$1).b4z = arc;
protoOf(VectorBuilder$transformed$1).c4z = arc$default;
protoOf(VectorBuilder$transformed$1).d4z = circle;
protoOf(VectorBuilder$transformed$1).e4z = rMoveTo;
protoOf(VectorBuilder$transformed$1).f4z = rLineTo;
protoOf(VectorBuilder$transformed$1).m3r = transformed;
initMetadataForClass(VectorBuilder$transformed$1, VOID, VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_8);
initMetadataForInterface(Visitor, 'Visitor');
protoOf(VectorPath).w4y = line;
protoOf(VectorPath).j1 = isEmpty;
protoOf(VectorPath).d1t = isNotEmpty;
protoOf(VectorPath).x4y = rect;
protoOf(VectorPath).y4y = rect_0;
protoOf(VectorPath).z4y = rect_1;
protoOf(VectorPath).a4z = rect_2;
protoOf(VectorPath).b4z = arc;
protoOf(VectorPath).c4z = arc$default;
protoOf(VectorPath).d4z = circle;
protoOf(VectorPath).e4z = rMoveTo;
protoOf(VectorPath).f4z = rLineTo;
protoOf(VectorPath).m3r = transformed;
protoOf(VectorPath).g4z = transformed_0;
initMetadataForClass(VectorPath, 'VectorPath', VectorPath, VOID, [AbstractShape2D, VectorBuilder]);
protoOf(with$1).p6 = close;
protoOf(with$1).x4p = lineTo;
protoOf(with$1).y4p = quadTo_0;
protoOf(with$1).l4p = cubicTo;
initMetadataForClass(with$1, VOID, VOID, VOID, [Visitor]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Winding, 'Winding');
initMetadataForCompanion(Companion_10);
initMetadataForClass(LineJoin, 'LineJoin');
initMetadataForCompanion(Companion_11);
initMetadataForClass(LineCap, 'LineCap');
initMetadataForClass(LineScaleMode, 'LineScaleMode');
initMetadataForCompanion(Companion_12);
initMetadataForClass(StrokeInfo, 'StrokeInfo', StrokeInfo);
initMetadataForCompanion(Companion_13);
protoOf(MPoint).g27 = isAlmostEquals$default;
initMetadataForClass(MPoint, 'MPoint', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_14);
initMetadataForClass(MMatrix, 'MMatrix', MMatrix);
initMetadataForCompanion(Companion_15);
initMetadataForCompanion(Companion_16);
protoOf(MRectangle).g27 = isAlmostEquals$default;
initMetadataForClass(MRectangle, 'MRectangle', VOID, VOID, [IsAlmostEquals]);
protoOf(Easings).j27 = invoke;
protoOf(Easings).k27 = invoke_0;
initMetadataForClass(Easings, 'Easings', VOID, VOID, [Easing, Enum]);
initMetadataForClass(Easings$SMOOTH, 'SMOOTH');
initMetadataForClass(Easings$EASE_IN_ELASTIC, 'EASE_IN_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_ELASTIC, 'EASE_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_BOUNCE, 'EASE_OUT_BOUNCE');
initMetadataForClass(Easings$LINEAR, 'LINEAR');
initMetadataForClass(Easings$EASE, 'EASE');
initMetadataForClass(Easings$EASE_IN, 'EASE_IN');
initMetadataForClass(Easings$EASE_OUT, 'EASE_OUT');
initMetadataForClass(Easings$EASE_IN_OUT, 'EASE_IN_OUT');
initMetadataForClass(Easings$EASE_IN_OLD, 'EASE_IN_OLD');
initMetadataForClass(Easings$EASE_OUT_OLD, 'EASE_OUT_OLD');
initMetadataForClass(Easings$EASE_IN_OUT_OLD, 'EASE_IN_OUT_OLD');
initMetadataForClass(Easings$EASE_OUT_IN_OLD, 'EASE_OUT_IN_OLD');
initMetadataForClass(Easings$EASE_IN_BACK, 'EASE_IN_BACK');
initMetadataForClass(Easings$EASE_OUT_BACK, 'EASE_OUT_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_BACK, 'EASE_IN_OUT_BACK');
initMetadataForClass(Easings$EASE_OUT_IN_BACK, 'EASE_OUT_IN_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_ELASTIC, 'EASE_IN_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_IN_ELASTIC, 'EASE_OUT_IN_ELASTIC');
initMetadataForClass(Easings$EASE_IN_BOUNCE, 'EASE_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_OUT_BOUNCE, 'EASE_IN_OUT_BOUNCE');
initMetadataForClass(Easings$EASE_OUT_IN_BOUNCE, 'EASE_OUT_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_QUAD, 'EASE_IN_QUAD');
initMetadataForClass(Easings$EASE_OUT_QUAD, 'EASE_OUT_QUAD');
initMetadataForClass(Easings$EASE_IN_OUT_QUAD, 'EASE_IN_OUT_QUAD');
initMetadataForClass(Easings$EASE_SINE, 'EASE_SINE');
initMetadataForClass(Easings$EASE_CLAMP_START, 'EASE_CLAMP_START');
initMetadataForClass(Easings$EASE_CLAMP_END, 'EASE_CLAMP_END');
initMetadataForClass(Easings$EASE_CLAMP_MIDDLE, 'EASE_CLAMP_MIDDLE');
initMetadataForClass(P, 'P');
protoOf(EasingCubic).j27 = invoke;
protoOf(EasingCubic).k27 = invoke_0;
initMetadataForClass(EasingCubic, 'EasingCubic', VOID, VOID, [Easing]);
//endregion
//region block: init
Arc_instance = new Arc();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Convex_instance = new Convex();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
Companion_instance_12 = new Companion_12();
Companion_instance_15 = new Companion_15();
//endregion
//region block: exports
export {
  HitTestDirection_ANY_getInstance as HitTestDirection_ANY_getInstance1hlnrhgqmsigf,
  LineCap_BUTT_getInstance as LineCap_BUTT_getInstancetv7srcehoz43,
  LineJoin_MITER_getInstance as LineJoin_MITER_getInstance35lw9h64apo2h,
  LineScaleMode_NORMAL_getInstance as LineScaleMode_NORMAL_getInstance1wxue9rdh6hry,
  Winding_EVEN_ODD_getInstance as Winding_EVEN_ODD_getInstancemyc10vdu2m52,
  Winding_NON_ZERO_getInstance as Winding_NON_ZERO_getInstance38kh1ikwl48ly,
  arc$default as arc$default4sjbw0e0mkug,
  _SliceOrientation___get_flipX__impl__lgb7bx as _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41,
  _SliceOrientation___get_raw__impl__tj3u8w as _SliceOrientation___get_raw__impl__tj3u8w1oalkydpnsgkf,
  _SliceOrientation___get_rotation__impl__m65r0o as _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89,
  Companion_getInstance_8 as Companion_getInstance154uzbkgf0e3s,
  Companion_instance_1 as Companion_instanceeeaudfwfrq87,
  Companion_instance_5 as Companion_instance2i0t7ux7bzoqc,
  Companion_getInstance_13 as Companion_getInstance2kfoysd3on6as,
  Companion_getInstance_22 as Companion_getInstance3d17rumlj92i7,
  ProjectedPoint as ProjectedPoint37gr1oedqap6n,
  toBezier as toBezier1cphbqwqpx0d3,
  ImageDoNotFitException as ImageDoNotFitException2gm4q4wt4lh58,
  RectSlice as RectSlicec5msorw5q4el,
  SliceOrientation as SliceOrientation5szkqzxt7oev,
  splitInRows as splitInRows1cyiez6sz0yy1,
  PolygonScanline as PolygonScanline1ccjpk6mqxyxd,
  RastScale as RastScale3rcmuinujik1d,
  StrokeInfo as StrokeInfo1cunqczl43ffk,
  StrokeToFill as StrokeToFill127v8ehrppf9e,
  arc as arc1vjl2w7wqv39k,
  circle as circle1t8rrxfrm1ku9,
  isEmpty as isEmpty3b7xkdp0by4c8,
  line as line3u2mk0n2uhnlh,
  rLineTo as rLineTo1671hm1vy9pme,
  rMoveTo as rMoveTo38ittbd8h3wn5,
  rect as rect1tyihxx4629c2,
  rect_2 as rectlvaio1p4o04e,
  rect_0 as rect31bppuugx2wch,
  rect_1 as rect3nqbmqh4a4l2a,
  transformed as transformed2t6vo3srmaaf9,
  VectorBuilder as VectorBuilder2g8a28qau4ty9,
  VectorPath as VectorPath1chx1oqdw6sb9,
  applyTransform as applyTransform1vhqlmleb4dce,
  getCurves as getCurves2yjahbp68cxj3,
  plus as plus1r33v70e4ipd7,
  strokeToFill_0 as strokeToFill34bvxzbc34djp,
  strokeToFill as strokeToFill2j5wye7yyxd99,
  toCurvesList as toCurvesList2ibv2opnrpohn,
  write as write11msa0gyjblqp,
  MMatrix as MMatrix1y71lv7vv6y8t,
  get_immutable as get_immutablepxpdoj6e54ll,
  get_mutable as get_mutableqzgwrema46rx,
  toMatrix4 as toMatrix42ci5k1es0x1v1,
  get_ALL as get_ALL2kw5hdxomut5y,
  get_EASE_IN_OUT_QUAD as get_EASE_IN_OUT_QUAD21w3u6e1aoexb,
  get_EASE_IN_QUAD as get_EASE_IN_QUAD2lehtmi3y9ekj,
  get_EASE_OUT_QUAD as get_EASE_OUT_QUAD2mpgddt0aepte,
  IntSegmentSet as IntSegmentSet3br6yjcm9q2bd,
};
//endregion
